/* =============================================
 * IMPORTS AND CONSTANTS
 * ============================================= */
import React, { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';


/* Game Assets */
import prop1Img from './assets/props/prop1.png';
import prop2Img from './assets/props/prop2.png';
import prop3Img from './assets/props/prop3.png';
import prop4Img from './assets/props/prop4.png';
import prop5Img from './assets/props/prop5.png';
import prop6Img from './assets/props/prop6.png';
import prop7Img from './assets/props/prop7.png';
import prop8Img from './assets/props/prop8.png';
import prop9Img from './assets/props/prop9.png';
import prop10Img from './assets/props/prop10.png';
import underprop1Img from './assets/underprops/underprop1.png';
import underprop2Img from './assets/underprops/underprop2.png';
import underprop3Img from './assets/underprops/underprop3.png';
import underprop4Img from './assets/underprops/underprop4.png';
import underprop5Img from './assets/underprops/underprop5.png';
import underprop6Img from './assets/underprops/underprop6.png';
import underprop7Img from './assets/underprops/underprop7.png';
import underprop8Img from './assets/underprops/underprop8.png';
import underprop9Img from './assets/underprops/underprop9.png';
import underprop10Img from './assets/underprops/underprop10.png';
import underprop11Img from './assets/underprops/underprop11.png';
import underprop12Img from './assets/underprops/underprop12.png';
import logo from './assets/logo.png';
import corridorImg from './assets/corridor.png';
import restImg from './assets/rest.png';
import doorOpenImg from './assets/door_open.png';
import doorLockedImg from './assets/door_locked.png';
import cardbackImg from './assets/cardback.png';
import backgroundImg from './assets/background.jpg';
import chestOpenImg from './assets/chest_open.png';
import chestLockedImg from './assets/chest_locked.png';
import chestSimpleClosedImg from './assets/chest_simple_closed.png';
import chestSimpleLockedImg from './assets/chest_simple_locked.png';
import chestSimpleOpenImg from './assets/chest_simple_open.png';
import chestRareClosedImg from './assets/chest_rare_closed.png';
import chestRareLockedImg from './assets/chest_rare_locked.png';
// optional, only if you have a unique open sprite:
import chestRareOpenImg from './assets/chest_rare_open.png';
import brazierImg from './assets/brazier.png';
import brazierOutImg from './assets/brazier_out.png';
import merchantImg from './assets/merchant.png';
import shrineImg from './assets/shrine.png';
import wellImg from './assets/well.png';
import witchImg from './assets/witch.png';
import minimapIconImg from './assets/minimap.png';
import uiHPSPImg from './assets/UI_HPSP.png';
import backpackIcon from './assets/backpack.png';
import keyIcon from './assets/key_icon.png';
import teethIcon from './assets/teeth_icon.png';
import potionIcon from './assets/potion_icon.png';
import cultistEnemyImg from './assets/enemy.png';
import hexbinderEnemyImg from './assets/enemy_hexbinder.png';
import nestedHorrorEnemyImg from './assets/enemy_nested_horror.png';
import dreadbrandEnemyImg from './assets/enemy_dreadbrand.png';
import corruptedCultistEnemyImg from './assets/enemy_corrupted_cultist.png';
import yahakaEnemyImg from './assets/enemy_yahaka.png';
import yahakaEnemy2Img from './assets/enemy_yahaka_2.png';
import yahakaEnemy3Img from './assets/enemy_yahaka_3.png';
import yahakaEnemy4Img from './assets/enemy_yahaka_4.png';
import chainedPenitentEnemyImg from './assets/enemy_chained_penitent.png';
import chainedPenitentEnemy2Img from './assets/enemy_chained_penitent_2.png';
import chainedPenitentEnemy3Img from './assets/enemy_chained_penitent_3.png';
import monsignorEnemyImg from './assets/enemy_monsignor.png';
import darkApostleEnemyImg from './assets/enemy_dark_apostle.png';
import chymistEnemyImg from './assets/enemy_chymist.png';
import mercenaryEnemyImg from './assets/enemy_mercenary.png';
import lampKeeperEnemyImg from './assets/enemy_lamp_keeper.png';
import thresholdVerifierEnemyImg from './assets/enemy_threshold_verifier.png';
import custodianEnemyImg from './assets/enemy_custodian.png';
import blackhandEnemyImg from './assets/enemy_blackhand.png';
import primeVesselEnemyImg from './assets/enemy_prime_vessel.png';
import machinePrimeCrucible1Img from './assets/machine_prime_crucible_1.png';
import machinePulseEngineImg from './assets/machine_pulse_engine.png';
import machineSynapticRetortImg from './assets/machine_synaptic_retort.png';
import machineAstralReliquaryImg from './assets/machine_astral_reliquary.png';
import primeVesselOverlayPrimeCrucibleImg from './assets/enemy_prime_vessel_1.png';
import primeVesselOverlaySynapticRetortImg from './assets/enemy_prime_vessel_2.png';
import primeVesselOverlayPulseEngineImg from './assets/enemy_prime_vessel_3.png';
import primeVesselOverlayAstralReliquaryImg from './assets/enemy_prime_vessel_4.png';
import corridorLab0aImg from './assets/corridor_lab0a.png';
import corridorLab0bImg from './assets/corridor_lab0b.png';
import corridorLab0cImg from './assets/corridor_lab0c.png';
import corridorLab0dImg from './assets/corridor_lab0d.png';
import corridorLab1aImg from './assets/corridor_lab1a.png';
import corridorLab1bImg from './assets/corridor_lab1b.png';
import corridorLab2aImg from './assets/corridor_lab2a.png';
import corridorLab2bImg from './assets/corridor_lab2b.png';
import corridorLab2cImg from './assets/corridor_lab2c.png';
import corridorLab2dImg from './assets/corridor_lab2d.png';
import corridorLab3aImg from './assets/corridor_lab3a.png';
import corridorLab3bImg from './assets/corridor_lab3b.png';
import corridorLab3cImg from './assets/corridor_lab3c.png';
import corridorLab3dImg from './assets/corridor_lab3d.png';
import corridorLab3eImg from './assets/corridor_lab3e.png';
import stepsUpImg from './assets/steps_up.png';
import stepsDownImg from './assets/steps_down.png';
import loreImg from './assets/lore.png';
import loreImg2 from './assets/lore2.png';
import uiTorchImg from './assets/UI_TORCH.png';
import tileButtonImg from './assets/ui_button.png';
import madnessOverlayImg from './assets/madness_overlay.png';
import spiderwebImg from './assets/spiderweb.png';
import damageMask1Img from './assets/damage/mask1.png';
import damageMask2Img from './assets/damage/mask2.png';
import damageMask3Img from './assets/damage/mask3.png';
import damageMask4Img from './assets/damage/mask4.png';
import damageMask5Img from './assets/damage/mask5.png';
import damageMask6Img from './assets/damage/mask6.png';
import damageMask1OverlayImg from './assets/damage/mask1b.png';
import damageMask2OverlayImg from './assets/damage/mask2b.png';
import damageMask3OverlayImg from './assets/damage/mask3b.png';
import damageMask4OverlayImg from './assets/damage/mask4b.png';
import damageMask5OverlayImg from './assets/damage/mask5b.png';
import damageMask6OverlayImg from './assets/damage/mask6b.png';

import secretEntranceImg from './assets/secret_entrance.png';
import logoIntroVideoSrc from './assets/logo/logo.mp4';

import './index.css';
import './combat/styles.css';
import CombatOverlay from './combat/CombatOverlay';
import { useGameStore as useCombatStore } from './combat/store/useGameStore';
import { resolveInitialDeckIds } from './combat/config/starterDeck';
import { findEnemyDef, getEnemyDef } from './combat/game/enemies';

import storylineImg from './assets/storyline.png';
import storyline1Img from './assets/story_opt/storyline1-1080.webp';

import {
  BRAZIER_LIGHTING_ENABLED,
  BRAZIER_LIGHT_RADIUS,
} from './game/lighting/brazierLightingConfig';

import { useStoryletFlow } from './game/story/useStoryletFlow';

import { useLevelProgression } from './game/progression/useLevelProgression';
import { useDungeonCombatFlow } from './game/combat/useDungeonCombatFlow';

import { useBootLoader } from './game/boot/useBootLoader';

import DungeonBoard from './game/board/DungeonBoard';

import {
  readSavedFloorLevel,
  makeFreshRunSeed,
  readSavedRunSeed,
  readRansackedChestSpawned,
  readSavedFloorSnapshot,
  writeSavedFloorLevel,
  writeSavedRunSeed,
  writeRansackedChestSpawned,
  writeFloorSnapshot,
  clearSavedRunState,
  hasSavedContinueRun,
  readMainMenuSeen,
  writeMainMenuSeen,
  readSelectedCharacter,
  writeSelectedCharacter,
} from './game/persistence/runStorage';

// Storage queue helpers: coalesce frequent writes and flush on demand.
import {
  flushPendingStorageWrites,
  queueJsonStorageWrite,
} from './game/persistence/storageQueue';
import {
  unlockLegendariumEntries,
  clearLegendariumState,
} from './game/persistence/legendariumStorage';

import {
  pickBrazierCompletionLine,
  pickCleansingCompletionLine,
} from './game/text/floorObjectiveText';

// Extracted helpers
import {
  createInitialFloorState,
  useFloorTransition,
} from './game/floor/useFloorTransition';

import {
  SPIDER_BOSS_ENEMY_ID,
  SPIDERWEB_SHAKE_DURATION_MS,
} from './game/boss/spiderBossConfig';
import {
  SPECIAL_BOSS_MAP_SIZE,
  ensureSelectedSpecialBossFloorMap,
  getSpecialBossEnemyId,
  getSpecialBossFloorEncounter,
  getSpecialBossFloorInitialLitBraziers,
  getSpecialBossFloorMood,
  getSpecialBossFloorPlayerSpawn,
  isMonsignorBossEncounterSelection,
  MONSIGNOR_GUARD_COORDS,
  MONSIGNOR_LIBERATED_GUARD_TILE,
  BLACKHAND_FIXED_ZOOM_TORCH_PROGRESS,
  TEST_RUN_SPECIAL_BOSS_OVERRIDE_STORAGE_KEY,
  isSpecialBossFloor,
  isSpiderBossEncounterSelection,
  isBlackhandBossEncounterSelection,
} from './game/boss/specialBossFloorConfig';
import {
  bumpSpiderwebShakeTicks,
  buildSpiderBossFloorState,
  chooseSpiderBossSpawnPosition,
  createDisabledSpiderBossState,
  findSpiderBossPos,
  getTriggeredSpiderwebKeys,
  isPlayerWithinSpiderBossSight,
  moveSpiderBossOneStep,
  parseCoordKey,
  pickSpiderBossAlertWebKey,
  sanitizeSpiderBossFloorMap,
} from './game/boss/spiderBossSystem';

import useDungeonAudio from './game/audio/useDungeonAudio';

import {
  FLOOR_TILESET_PROFILES,
  getFloorTilesetProfile,
  corridorImgs,
  hash01,
} from './game/map/tilesets';
import { isWalkable } from './game/map/isWalkable';

import { useDungeonActions } from './game/dungeon/useDungeonActions';
import { useLegendariumLoreSync } from './game/lore/loreSystem';
import { useDungeonInput } from './game/input/useDungeonInput';
import {
  useDungeonClickBoundary,
  stopBoundaryClick,
} from './game/input/dungeonClickBoundary';

import { useMerchantStock } from './game/merchant/useMerchantStock';


import {
  isCorruptionEnabledForMood,
  getCorruptionConfig,
  buildInitialCorruptionState,
  advanceCorruptionState,
  parseTileKey,
  tileKey,
} from './game/map/corruptionSystem';

import { makeSeededRand } from './game/map/barredDoors';
import { CORRUPTED_SPECIAL_ENEMY_ID } from './game/enemies/dungeonEnemySelection';

import {
  RANSACKED_CHEST_TILE,
  isRansackedChestExclusiveRelic,
} from './game/map/ransackedChest';

import { relicsPool } from './game/data/relics';

// Centralized relic effect helpers
import {
  applyTorchHooks,
  computeCombatMods,
  getPerFloorCharges,
  getTrapActivationChanceMultiplier,
  getPerTileHpRegen,
} from './relicEffects';

import { uniq } from './utils/preloadAssets';

import { MerchantModal } from './ui/modals/MerchantModal';
import { LoreModal } from './ui/modals/LoreModal';
import { RelicPickerModal } from './ui/modals/RelicPickerModal';
import { ShrineModal } from './ui/modals/ShrineModal';
import { WellModal } from './ui/modals/WellModal';
import TrapQTEOverlay from './ui/modals/TrapQTEOverlay';
import EmbersOverlay from './ui/EmbersOverlay';
// Pull exploration scene into a separate component so rerenders in App
// do not cascade into the dungeon board unless its own props change.
import ExplorationScene from './game/board/ExplorationScene';
import TorchHintOverlay from './ui/overlays/TorchHintOverlay';
import StatusPanelOverlay from './ui/overlays/StatusPanelOverlay';
import MiniMapOverlay from './ui/overlays/MiniMapOverlay';
import TarotOverlay from './ui/overlays/TarotOverlay';
import StoryletOverlay from './ui/overlays/StoryletOverlay';
import LevelUpModal from './ui/modals/LevelUpModal';
import DeckCullRewardModal from './ui/modals/DeckCullRewardModal';
import RansackedChestModal from './ui/modals/RansackedChestModal';
import { SimpleChestResourceModal } from './ui/modals/SimpleChestResourceModal';
import WellEchoModal from './ui/modals/WellEchoModal';
import GameHudOverlay from './ui/overlays/GameHudOverlay';

// Tarot system imports
import { drawTarotCard, tarotCards, TAROT_START_FLOOR } from './tarot/cards';

import CharacterSelectScreen from './menu/CharacterSelectScreen';
import MainMenuScreen from './menu/MainMenuScreen';
import LegendariumScreen from './menu/LegendariumScreen';

// Initial combat draw milestones:
// Level 1–4: draw 3
// Level 5–9: draw 4  (+1)
// Level 10+: draw 5 (+2)
// (Bonus is clamped to max +2)

const MADNESS_OVERLAY_BLEND_MODE = 'saturation'; // Change this to 'screen', 'multiply', 'overlay', 'saturation', etc.

const getTarotCardById = (cardId) =>
  tarotCards.find((card) => card?.id === cardId) || null;

const hydrateTarotSelection = (cardId, orientation) => {
  if (orientation !== 'right' && orientation !== 'wrong') return null;
  const card = getTarotCardById(cardId);
  return card ? { card, orientation } : null;
};


const BOARD_STAGE_STYLE_BASE = Object.freeze({
  position: 'relative',
  width: '100%',
  height: '100%',
  overflow: 'visible',
});

const BOARD_VIEWPORT_STYLE_BASE = Object.freeze({
  position: 'absolute',
  inset: 0,
  transformOrigin: '50% 50%',
  transformStyle: 'preserve-3d',
  backfaceVisibility: 'hidden',
});

const BOARD_CAMERA_TRANSITION_LAYOUT = Object.freeze({ duration: 0 });
const BOARD_CAMERA_TRANSITION_SPRING = Object.freeze({ type: 'spring', stiffness: 100 });
const BOARD_CAMERA_EASE_PRECOMBAT = Object.freeze([0.22, 1, 0.36, 1]);

const AMBIENT_PROP_POOL = [
  {
    id: 'prop1',
    src: prop1Img,
    w: 520,
    h: 520,
    gapPx: 0,
    xOffsetPx: 0,
    yOffsetPx: 0,
    scale: 1,
  },
  {
    id: 'prop2',
    src: prop2Img,
    w: 520,
    h: 520,
    gapPx: 0,
    xOffsetPx: 0,
    yOffsetPx: 0,
    scale: 1,
  },
  {
    id: 'prop3',
    src: prop3Img,
    w: 520,
    h: 520,
    gapPx: 0,
    xOffsetPx: 0,
    yOffsetPx: 0,
    scale: 1,
  },
  {
    id: 'prop4',
    src: prop4Img,
    w: 520,
    h: 520,
    gapPx: 0,
    xOffsetPx: 0,
    yOffsetPx: 0,
    scale: 1,
  },
  {
    id: 'prop5',
    src: prop5Img,
    w: 520,
    h: 520,
    gapPx: 0,
    xOffsetPx: 0,
    yOffsetPx: 0,
    scale: 1,
  },
  {
    id: 'prop6',
    src: prop6Img,
    w: 520,
    h: 520,
    gapPx: 0,
    xOffsetPx: 0,
    yOffsetPx: 0,
    scale: 1,
  },
  {
    id: 'prop7',
    src: prop7Img,
    w: 520,
    h: 520,
    gapPx: 0,
    xOffsetPx: 0,
    yOffsetPx: 0,
    scale: 1,
  },
  {
    id: 'prop8',
    src: prop8Img,
    w: 520,
    h: 520,
    gapPx: 0,
    xOffsetPx: 0,
    yOffsetPx: 0,
    scale: 1,
  },
  {
    id: 'prop9',
    src: prop9Img,
    w: 520,
    h: 520,
    gapPx: 0,
    xOffsetPx: 0,
    yOffsetPx: 0,
    scale: 1,
  },
  {
    id: 'prop10',
    src: prop10Img,
    w: 520,
    h: 520,
    gapPx: 0,
    xOffsetPx: 0,
    yOffsetPx: 0,
    scale: 1,
  },
];

const UNDER_PROP_POOL = [
  { id: 'underprop1', src: underprop1Img, w: 180, h: 180, scale: 1, mixBlendMode: 'multiply' },
  { id: 'underprop2', src: underprop2Img, w: 180, h: 180, scale: 1, mixBlendMode: 'multiply' },
  { id: 'underprop3', src: underprop3Img, w: 180, h: 180, scale: 1, mixBlendMode: 'darken' },
  { id: 'underprop4', src: underprop4Img, w: 180, h: 180, scale: 1, mixBlendMode: 'darken' },
  { id: 'underprop5', src: underprop5Img, w: 180, h: 180, scale: 1, mixBlendMode: 'multiply' },
  { id: 'underprop6', src: underprop6Img, w: 180, h: 180, scale: 1, mixBlendMode: 'darken' },
  { id: 'underprop7', src: underprop7Img, w: 180, h: 180, scale: 1, mixBlendMode: 'darken' },
  { id: 'underprop8', src: underprop8Img, w: 180, h: 180, scale: 1, mixBlendMode: 'darken' },
  { id: 'underprop9', src: underprop9Img, w: 180, h: 180, scale: 1, mixBlendMode: 'darken' },
  { id: 'underprop10', src: underprop10Img, w: 180, h: 180, scale: 1, mixBlendMode: 'darken' },
  { id: 'underprop11', src: underprop11Img, w: 360, h: 360, scale: 1 },
  { id: 'underprop12', src: underprop12Img, w: 360, h: 360, scale: 1 },
];

/* Game Constants */
const TILE_WIDTH = 64;
const TILE_HEIGHT = 114;
const TILE_MARGIN = 4;
// ------------------------------------------------------------
// Map size schedule (floor-dependent)
// Floor 1: 15x15
// Floor 2: 30x30
// Floor 3+: 45x45
// ------------------------------------------------------------
const FLOOR1_SIZE = 20;
const FLOOR2_SIZE = 30;
const FLOOR3PLUS_SIZE = 45;

function getMapSizeForFloor(floor) {
  const lvl = Math.max(1, Math.floor(Number(floor) || 1));
  if (lvl === 1) return FLOOR1_SIZE;
  if (lvl === 2) return FLOOR2_SIZE;
  if (isSpecialBossFloor(lvl)) return SPECIAL_BOSS_MAP_SIZE;
  return FLOOR3PLUS_SIZE;
}

function getSpawnForSize(size) {
  const c = Math.floor(size / 2);
  return { x: c, y: c };
}

function getSpawnForFloor(floor) {
  return getSpawnForSize(getMapSizeForFloor(floor));
}

const MAX_TORCH_DURATION = 64;
const TRINKET_LIMIT = 20;
const GRAPHICS_FX_OVERRIDE_STORAGE_KEY = 'dd_graphics_fx_override_v1';

function readSavedGraphicsFxOverride() {
  if (typeof window === 'undefined') return null;

  try {
    const raw = window.localStorage.getItem(GRAPHICS_FX_OVERRIDE_STORAGE_KEY);
    if (raw === 'low') return 'mid';
    return raw === 'mid' || raw === 'full' ? raw : null;
  } catch {
    return null;
  }
}

function writeSavedGraphicsFxOverride(mode) {
  if (typeof window === 'undefined') return;

  try {
    if (mode === 'low' || mode === 'mid' || mode === 'full') {
      window.localStorage.setItem(GRAPHICS_FX_OVERRIDE_STORAGE_KEY, mode);
    } else {
      window.localStorage.removeItem(GRAPHICS_FX_OVERRIDE_STORAGE_KEY);
    }
  } catch {}
}

// Secret entrance whisper SFX (easy knobs)
const SECRET_ENTRANCE_WHISPER_RADIUS_TILES = 5;
const SECRET_ENTRANCE_WHISPER_COOLDOWN_MS = 9000;
const SECRET_ENTRANCE_WHISPER_VOLUME = 0.18;

// Brazier radius guide (visual-only)
const BRAZIER_RADIUS_GUIDE_ENABLED = true;

// Show the guide when the torch is out OR when it's close to running out.
// Tweak this to taste (e.g. 6, 8, 10).
const BRAZIER_RADIUS_GUIDE_NEAR_DANGER_TURNS = 999;

// Opacity range for tile tint (falloff maps into this range)
const BRAZIER_RADIUS_GUIDE_MIN_OPACITY = 0.10; // outer edge
const BRAZIER_RADIUS_GUIDE_MAX_OPACITY = 0.40; // near brazier


const YAHAKA_ENEMY_ID = 'yahaka_voidfeeder';
const YAHAKA_GHOST_REVEAL_RANGE = 2;
const GHOST_ENEMY_SP_THRESHOLD = 20;
const YAHAKA_SPAWN_MIN_DISTANCE = 4;
const YAHAKA_WALKABLE_TILES = new Set(['floor', 'corridor', 'trap']);
const YAHAKA_VARIANTS = [
  { enemyId: 'yahaka_voidfeeder_1', tileStage: 1 },
  { enemyId: 'yahaka_voidfeeder_2', tileStage: 1 },
  { enemyId: 'yahaka_voidfeeder_3', tileStage: 2 },
  { enemyId: 'yahaka_voidfeeder_4', tileStage: 2 },
  { enemyId: 'yahaka_voidfeeder_5', tileStage: 3 },
  { enemyId: 'yahaka_voidfeeder_6', tileStage: 3 },
  { enemyId: 'yahaka_voidfeeder_7', tileStage: 4 },
];
const YAHAKA_BANNER_LINES = [
  'The Beast has awakened',
  'Yahaka stirs beneath the stone',
  'The Voidfeeder walks this floor',
  'Something ancient has found your scent',
  'The dark now hunts with purpose',
  'A hungry shadow answers your collapse',
  'Yahaka opens its many eyes',
  'The silence has grown teeth',
  'The hollow one begins its crawl',
  'A twisted maw rises in the dark',
  'The void has learned your name',
  'Yahaka descends upon the living',
  'The black hunger is loose',
  'A predator wakes beyond the torchlight',
  'The floor itself delivers a curse',
];

const YAHAKA_VICTORY_BANNER_LINES = [
  'The Shadow Beast has been slain',
  'The Night has been conquered',
  'The Voidfeeder is no more',
  'The black hunger has been silenced',
  'Yahaka has fallen at last',
  'The beast of zero sanity is broken',
  'The torch has outlived the dark',
  'The abyss recoils from your name',
  'The crawling void lies still',
  'The many-eyed terror is ended',
  'The floor exhales in relief',
  'The predator in the dark is dead',
  'The living have denied the void',
  'The devourer has been unmade',
  'The final shadow has been cut down',
];

function pickYahakaBannerLine() {
  return YAHAKA_BANNER_LINES[Math.floor(Math.random() * YAHAKA_BANNER_LINES.length)] || 'The Beast has awakened.';
}

function pickYahakaVictoryBannerLine() {
  return YAHAKA_VICTORY_BANNER_LINES[Math.floor(Math.random() * YAHAKA_VICTORY_BANNER_LINES.length)] || 'The Shadow Beast has been slain.';
}

function getYahakaVariantIndex(defeatCount) {
  const count = Math.max(0, Math.floor(Number(defeatCount) || 0));
  return Math.min(YAHAKA_VARIANTS.length, count + 1);
}

function getYahakaEnemyIdForDefeatCount(defeatCount) {
  return YAHAKA_VARIANTS[getYahakaVariantIndex(defeatCount) - 1]?.enemyId || YAHAKA_ENEMY_ID;
}

function getYahakaTileImageForDefeatCount(defeatCount) {
  const stage = YAHAKA_VARIANTS[getYahakaVariantIndex(defeatCount) - 1]?.tileStage || 1;
  if (stage === 4) return yahakaEnemy4Img;
  if (stage === 3) return yahakaEnemy3Img;
  if (stage === 2) return yahakaEnemy2Img;
  return yahakaEnemyImg;
}

function createInactiveYahakaState() {
  return {
    active: false,
    x: null,
    y: null,
  };
}

function isYahakaWalkableTile(tile) {
  return YAHAKA_WALKABLE_TILES.has(tile);
}

function findYahakaSpawnPosition(mapLike, playerPos) {
  if (!Array.isArray(mapLike) || !mapLike.length || !playerPos) return null;

  const candidates = [];

  for (let y = 0; y < mapLike.length; y += 1) {
    const row = mapLike[y];
    if (!Array.isArray(row)) continue;

    for (let x = 0; x < row.length; x += 1) {
      const tile = row[x];
      if (!isYahakaWalkableTile(tile)) continue;
      if (x === playerPos.x && y === playerPos.y) continue;

      const nextStep = findYahakaNextStep(mapLike, { x, y }, playerPos);
      if (!nextStep) continue;

      candidates.push({ x, y });
    }
  }

  if (!candidates.length) return null;

  const picked = candidates[Math.floor(Math.random() * candidates.length)];
  return picked ? { x: picked.x, y: picked.y } : null;
}

function findYahakaNextStep(mapLike, start, target) {
  if (!Array.isArray(mapLike) || !mapLike.length || !start || !target) return null;
  if (start.x === target.x && start.y === target.y) return { x: target.x, y: target.y };

  const height = mapLike.length;
  const width = Array.isArray(mapLike[0]) ? mapLike[0].length : 0;
  if (width <= 0) return null;

  const startKey = `${start.x},${start.y}`;
  const targetKey = `${target.x},${target.y}`;
  const queue = [{ x: start.x, y: start.y }];
  const visited = new Set([startKey]);
  const prevByKey = new Map();

  while (queue.length > 0) {
    const current = queue.shift();
    if (!current) break;

    if (current.x === target.x && current.y === target.y) {
      break;
    }

    const neighbors = [
      { x: current.x + 1, y: current.y },
      { x: current.x - 1, y: current.y },
      { x: current.x, y: current.y + 1 },
      { x: current.x, y: current.y - 1 },
    ].filter((next) => next.x >= 0 && next.y >= 0 && next.x < width && next.y < height);

    neighbors.sort((a, b) => {
      const da = Math.abs(target.x - a.x) + Math.abs(target.y - a.y);
      const db = Math.abs(target.x - b.x) + Math.abs(target.y - b.y);
      return da - db;
    });

    for (const next of neighbors) {
      const nextKey = `${next.x},${next.y}`;
      if (visited.has(nextKey)) continue;

      const tile = mapLike[next.y]?.[next.x];
      const canEnter = nextKey === targetKey || isYahakaWalkableTile(tile);
      if (!canEnter) continue;

      visited.add(nextKey);
      prevByKey.set(nextKey, current);
      queue.push(next);
    }
  }

  if (!visited.has(targetKey)) return null;

  let cursor = { x: target.x, y: target.y };
  let previous = prevByKey.get(targetKey) || null;

  while (previous && !(previous.x === start.x && previous.y === start.y)) {
    cursor = previous;
    previous = prevByKey.get(`${previous.x},${previous.y}`) || null;
  }

  return cursor;
}

/* =============================================
 * UI COMPONENTS
 * ============================================= */

const TileActionButton = ({ label, onClick }) => {
  const CROP_X = 2;     // px cropped from LEFT and RIGHT (try 2–8)
  const NUDGE_X = 0;    // px (optional)
  const NUDGE_Y = 2;    // px (your down nudge)
  const RADIUS = 18;

  return (
    <button
      type="button"
      onClick={(e) => stopBoundaryClick(e, onClick)}
      className="relative inline-block p-0 m-0 bg-transparent border-0 outline-none"
      style={{
        WebkitTapHighlightColor: 'transparent',
        backgroundColor: 'transparent',
        lineHeight: 0,
      }}
    >
      {/* Cropping window */}
      <div
        className="relative w-[220px] md:w-[260px] overflow-hidden"
        style={{
          borderRadius: RADIUS,
          // THIS trims both sides without changing the image asset:
          clipPath: `inset(0px ${CROP_X}px 0px ${CROP_X}px round ${RADIUS}px)`,
        }}
      >
        <img
          src={tileButtonImg}
          alt=""
          draggable={false}
          className="block w-full h-auto select-none pointer-events-none"
          style={{
            transform: `translate(${NUDGE_X}px, ${NUDGE_Y}px)`,
            transformOrigin: 'center',
          }}
        />
      </div>

      {/* Label */}
      <span
        className="absolute inset-0 flex items-center justify-center font-serif text-[22px] md:text-[26px] text-white"
        style={{
          textShadow: '0 2px 6px rgba(0,0,0,0.85)',
          pointerEvents: 'none',
        }}
      >
        {label}
      </span>
    </button>
  );
};

/* =============================================
 * MAP GENERATION
 * ============================================= */

// generateMap + isWalkable are now in src/game/map

/* =============================================
 * MAIN GAME BOARD COMPONENT
 * ============================================= */

const GameBoard = ({
  onPlayerDeath = () => {},
  onOpenLegendarium = () => {},
  onExitToMainMenu = () => {},
  isLegendariumOpen = false,
  skipUnloadPersistenceRef,
}) => {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.innerWidth < 768;
  });

  const boardViewportRef = useRef(null);
  const boardElRef = useRef(null);

  // Viewport size is used for tile viewport culling (render only the tiles that can actually be seen).
  // We measure the actual board container (not the full window), because top/bottom UI bars reduce
  // the real visible area significantly.
  const [viewportSize, setViewportSize] = useState(() => {
    if (typeof window === 'undefined') return { w: 0, h: 0 };
    return { w: window.innerWidth, h: window.innerHeight };
  });
  const [graphicsFxOverride, setGraphicsFxOverride] = useState(() => readSavedGraphicsFxOverride());

  const graphicsFxMode = graphicsFxOverride || (isMobile ? 'mid' : 'full');
  const lowFx = graphicsFxMode !== 'full';
  const aggressiveLowFx = graphicsFxMode === 'low';

  const toggleGraphicsFxMode = React.useCallback(() => {
    setGraphicsFxOverride((current) => {
      const currentMode = current || (isMobile ? 'mid' : 'full');
      const next = currentMode === 'full' ? 'mid' : currentMode === 'mid' ? 'low' : 'full';
      writeSavedGraphicsFxOverride(next);
      return next;
    });
  }, [isMobile]);

  const [spawnTutorialStage, setSpawnTutorialStage] = useState(() => {
    try {
      const saved = readSavedFloorSnapshot();
      if (
        saved?.spawnTutorialStage === 'lightTorch' ||
        saved?.spawnTutorialStage === 'moveInteract' ||
        saved?.spawnTutorialStage === 'findExit' ||
        saved?.spawnTutorialStage === 'done'
      ) {
        return saved.spawnTutorialStage;
      }
      return saved?.showSpawnTorchHint !== false ? 'lightTorch' : 'done';
    } catch {
      return 'lightTorch';
    }
  });
  const [spawnTutorialMoveTriggered, setSpawnTutorialMoveTriggered] = useState(() => {
    try {
      return readSavedFloorSnapshot()?.spawnTutorialMoveTriggered === true;
    } catch {
      return false;
    }
  });
  const showSpawnTorchHint = spawnTutorialStage === 'lightTorch';
  const [ghostEnemyFlicker, setGhostEnemyFlicker] = useState(null);
  const ghostEnemyFlickerTimeoutRef = useRef(null);
  const ghostEnemyFlickerClearTimeoutRef = useRef(null);

  useEffect(() => {
    let raf = 0;

    const measure = () => {
      setIsMobile(window.innerWidth < 768);

      const el = boardViewportRef.current;
      if (el && el.getBoundingClientRect) {
        const r = el.getBoundingClientRect();
        const w = Math.round(r.width);
        const h = Math.round(r.height);

        // Ignore transient bogus values during mobile browser UI / layout changes.
        if (w > 10 && h > 10) {
          setViewportSize({ w, h });
          return;
        }
      }

      setViewportSize({
        w: Math.max(1, Math.round(window.innerWidth || 1)),
        h: Math.max(1, Math.round(window.innerHeight || 1)),
      });
    };

    const scheduleMeasure = () => {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(measure);
    };

    // Initial measure + a second pass after layout settles.
    measure();
    scheduleMeasure();

    window.addEventListener('resize', scheduleMeasure);

    const vv = typeof window !== 'undefined' ? window.visualViewport : null;
    if (vv) {
      vv.addEventListener('resize', scheduleMeasure);
      vv.addEventListener('scroll', scheduleMeasure);
    }

    let ro = null;
    if (typeof ResizeObserver !== 'undefined' && boardViewportRef.current) {
      ro = new ResizeObserver(() => scheduleMeasure());
      ro.observe(boardViewportRef.current);
    }

    return () => {
      if (raf) cancelAnimationFrame(raf);
      window.removeEventListener('resize', scheduleMeasure);
      if (vv) {
        vv.removeEventListener('resize', scheduleMeasure);
        vv.removeEventListener('scroll', scheduleMeasure);
      }
      if (ro) ro.disconnect();
    };
  }, []);

// Assets to preload during boot
const BOOT_LOCAL_ASSETS = React.useMemo(
  () =>
    uniq([
      // Core tiles
...Object.values(FLOOR_TILESET_PROFILES).flatMap((profile) => [
  profile.floorBaseImg,
  ...(profile.corridorImgs || []),
]),
corridorImg,

      restImg,
      doorOpenImg,
      doorLockedImg,
      chestOpenImg,
      chestLockedImg,
      chestSimpleClosedImg,
      chestSimpleLockedImg,
      chestSimpleOpenImg,
      chestRareClosedImg,
chestRareLockedImg,
// optional:
chestRareOpenImg,
      brazierImg,
      brazierOutImg,
      merchantImg,
      shrineImg,
      wellImg,
      cultistEnemyImg,
      hexbinderEnemyImg,
      nestedHorrorEnemyImg,
      dreadbrandEnemyImg,
      corruptedCultistEnemyImg,
      yahakaEnemyImg,
      yahakaEnemy2Img,
      yahakaEnemy3Img,
      yahakaEnemy4Img,
      chainedPenitentEnemyImg,
      chainedPenitentEnemy2Img,
      monsignorEnemyImg,
      darkApostleEnemyImg,
      chymistEnemyImg,
      mercenaryEnemyImg,
      primeVesselEnemyImg,
      machinePrimeCrucible1Img,
      machinePulseEngineImg,
      machineSynapticRetortImg,
      machineAstralReliquaryImg,
      stepsUpImg,
      stepsDownImg,
      loreImg,
      loreImg2,
      secretEntranceImg,
      spiderwebImg,
      damageMask1Img,
      damageMask2Img,
      damageMask3Img,
      damageMask4Img,
      damageMask5Img,
      damageMask6Img,
      damageMask1OverlayImg,
      damageMask2OverlayImg,
      damageMask3OverlayImg,
      damageMask4OverlayImg,
      damageMask5OverlayImg,
      damageMask6OverlayImg,

      // UI
      cardbackImg,
      backgroundImg,
      madnessOverlayImg,
      prop1Img,
      prop2Img,
      prop3Img,
      prop4Img,
      prop5Img,
      prop6Img,
      prop7Img,
      prop8Img,
      prop9Img,
      prop10Img,
      underprop1Img,
underprop2Img,
underprop3Img,
underprop4Img,
underprop5Img,
underprop6Img,
underprop7Img,
underprop8Img,
underprop9Img,
underprop10Img,
underprop11Img,
underprop12Img,
      minimapIconImg,
      uiHPSPImg,
      uiTorchImg,
      backpackIcon,
      keyIcon,
      teethIcon,
      potionIcon,
      tileButtonImg,

      // Storyline tile / fallback art still used by storylets
      storylineImg,
      storyline1Img,
    ]),
  []
);

  // Stable run seed so floors are deterministic within a run (but different between refreshes).
  const savedFloorSnapshotRef = useRef(readSavedFloorSnapshot());

  const runSeedRef = useRef(
    savedFloorSnapshotRef.current?.runSeed ?? readSavedRunSeed()
  );
  const ransackedChestSpawnedRef = useRef(readRansackedChestSpawned());
  // When combat is triggered from the dungeon, we remember where the player was standing
  // so returning to dungeon doesn't strand them on the enemy tile (or immediately retrigger combat).
  const preCombatPosRef = useRef(null);
  const [floorLevel, setFloorLevel] = useState(
    () => savedFloorSnapshotRef.current?.floorLevel ?? readSavedFloorLevel()
  );

const initialFloorStateRef = useRef(null);

if (!initialFloorStateRef.current) {
  const generated = createInitialFloorState({
    floorLevel,
    runSeed: runSeedRef.current,
    maxTorchDuration: MAX_TORCH_DURATION,
    getMapSizeForFloor,
    getSpawnForSize,
    ransackedChestSpawnedRef,
  });

  const saved = savedFloorSnapshotRef.current;

  const canHydrate =
    !!saved &&
    Array.isArray(saved.map) &&
    saved.map.length > 0 &&
    !!saved.playerPos;
  const hydratedSpecialBossFloorSelection = canHydrate
    ? sanitizeSpecialBossSelectionForFloor(
        saved?.specialBossFloorSelection,
        saved?.floorLevel ?? floorLevel
      )
    : null;
  initialFloorStateRef.current = canHydrate
    ? {
        ...generated,
        mood: saved.currentFloorMood,
        torchDuration:
          saved.currentFloorTorchDuration || generated.torchDuration,
        turns: saved.turns,
        playerPos: saved.playerPos,
        map: saved.map,
        barredDoorKeys:
          saved.barredDoorKeys?.size > 0
            ? saved.barredDoorKeys
            : generated.barredDoorKeys,
        floorCorruption: saved.floorCorruption ?? generated.floorCorruption,
        floorActionCount: saved.floorActionCount,
        exploredTiles:
          saved.exploredTiles?.size > 0
            ? saved.exploredTiles
            : new Set([`${saved.playerPos.x},${saved.playerPos.y}`]),
        litBraziers: saved.litBraziers ?? new Set(),
        slainEnemiesThisFloor: saved.slainEnemiesThisFloor,
        brazierQuestCompletionTriggered: saved.brazierQuestCompletionTriggered,
        brazierCompletionBannerText: saved.brazierCompletionBannerText,
        cleansingQuestCompletionTriggered:
          saved.cleansingQuestCompletionTriggered,
        cleansingCompletionBannerText: saved.cleansingCompletionBannerText,
        pendingDeckCullReward: saved.pendingDeckCullReward,
        pendingCorruptionBonusReward: saved.pendingCorruptionBonusReward,
        corruptionBannerText: saved.corruptionBannerText,
        torches: saved.torches ?? 3,
        keys: saved.keys ?? 3,
        teeth: saved.teeth ?? 4,
        potions: saved.potions ?? 1,
        nextCombatCost0: saved.nextCombatCost0 ?? 0,
        nextCombatNegateNextDamage: saved.nextCombatNegateNextDamage ?? 0,
        nextCombatStartArmor: saved.nextCombatStartArmor ?? 0,
        bypassEnemiesRemaining: saved.bypassEnemiesRemaining ?? 0,
        freeChestsRemaining: saved.freeChestsRemaining ?? 0,
        merchantStock: saved.merchantStock ?? null,
        relicOffers: saved.relicOfferIds ?? [],
        pendingRansackedChestPos: saved.pendingRansackedChestPos ?? null,
        pendingWellMythicPos: saved.pendingWellMythicPos ?? null,
        isWellEchoOpen: !!saved.isWellEchoOpen,
        tarot: saved.tarot ?? null,
        specialBossFloorSelection:
          hydratedSpecialBossFloorSelection ?? generated.specialBossFloorSelection ?? null,
        spiderBossState:
          saved.spiderBossState ?? createDisabledSpiderBossState(),
        yahakaState: saved.yahakaState ?? createInactiveYahakaState(),
        yahakaDefeatCount: Math.max(0, Math.min(7, Math.floor(Number(saved.yahakaDefeatCount) || 0))),
        yahakaSpawnArmed:
          typeof saved.yahakaSpawnArmed === 'boolean'
            ? saved.yahakaSpawnArmed
            : true,
        yahakaBannerText:
          typeof saved.yahakaBannerText === 'string'
            ? saved.yahakaBannerText
            : '',
      }
    : {
        ...generated,
        floorActionCount: 0,
        exploredTiles: new Set([
          `${generated.playerPos.x},${generated.playerPos.y}`,
        ]),
        litBraziers: new Set(),
        slainEnemiesThisFloor: 0,
        brazierQuestCompletionTriggered: false,
        brazierCompletionBannerText: '',
        cleansingQuestCompletionTriggered: false,
        cleansingCompletionBannerText: '',
        pendingDeckCullReward: false,
        pendingCorruptionBonusReward: false,
        corruptionBannerText: '',
        torches: 3,
        keys: 3,
        teeth: 4,
        potions: 1,
        nextCombatCost0: 0,
        nextCombatNegateNextDamage: 0,
        nextCombatStartArmor: 0,
        bypassEnemiesRemaining: 0,
        freeChestsRemaining: 0,
        merchantStock: null,
        relicOffers: [],
        pendingRansackedChestPos: null,
        pendingWellMythicPos: null,
        isWellEchoOpen: false,
        tarot: null,
        specialBossFloorSelection: generated.specialBossFloorSelection ?? null,
        spiderBossState: createDisabledSpiderBossState(),
        yahakaState: createInactiveYahakaState(),
        yahakaDefeatCount: 0,
        yahakaSpawnArmed: true,
        yahakaBannerText: '',
      };
}

const [currentFloorMood, setCurrentFloorMood] = useState(
  () => initialFloorStateRef.current.mood
);

const [currentFloorTorchDuration, setCurrentFloorTorchDuration] = useState(
  () => initialFloorStateRef.current.torchDuration
);
const [specialBossFloorSelection, setSpecialBossFloorSelection] = useState(
  () => initialFloorStateRef.current.specialBossFloorSelection ?? null
);

const [floorActionCount, setFloorActionCount] = useState(
  () => initialFloorStateRef.current.floorActionCount
);
const [floorCorruption, setFloorCorruption] = useState(
  () => initialFloorStateRef.current.floorCorruption
);
const [spiderBossState, setSpiderBossState] = useState(
  () => initialFloorStateRef.current.spiderBossState ?? createDisabledSpiderBossState()
);
const [corruptionBannerText, setCorruptionBannerText] = useState(
  () => initialFloorStateRef.current.corruptionBannerText
);
const [pendingCorruptionBonusReward, setPendingCorruptionBonusReward] = useState(
  () => initialFloorStateRef.current.pendingCorruptionBonusReward
);
const [yahakaState, setYahakaState] = useState(
  () => initialFloorStateRef.current.yahakaState ?? createInactiveYahakaState()
);
const [yahakaDefeatCount, setYahakaDefeatCount] = useState(
  () => Math.max(0, Math.min(7, Math.floor(Number(initialFloorStateRef.current.yahakaDefeatCount) || 0)))
);
const [yahakaSpawnArmed, setYahakaSpawnArmed] = useState(
  () => initialFloorStateRef.current.yahakaSpawnArmed ?? true
);
const [yahakaBannerText, setYahakaBannerText] = useState(
  () => initialFloorStateRef.current.yahakaBannerText ?? ''
);
const [loreBannerText, setLoreBannerText] = useState('');
const [blackhandTorchWarningText, setBlackhandTorchWarningText] = useState('');

const isYahakaAtTile = React.useCallback(
  (x, y) => !!yahakaState?.active && yahakaState.x === x && yahakaState.y === y,
  [yahakaState]
);

const activeYahakaEnemyId = React.useMemo(
  () => getYahakaEnemyIdForDefeatCount(yahakaDefeatCount),
  [yahakaDefeatCount]
);

const activeYahakaEnemyImg = React.useMemo(
  () => getYahakaTileImageForDefeatCount(yahakaDefeatCount),
  [yahakaDefeatCount]
);

const currentFloorTilesetProfile = React.useMemo(
  () => getFloorTilesetProfile(currentFloorMood),
  [currentFloorMood]
);

const currentFloorCorruptionConfig = React.useMemo(
  () => getCorruptionConfig(currentFloorMood),
  [currentFloorMood]
);

const activeSpecialBossEnemyId = React.useMemo(
  () => getSpecialBossEnemyId(specialBossFloorSelection),
  [specialBossFloorSelection]
);

const isSpecialBossFloorActive = React.useMemo(
  () => isSpecialBossFloor(floorLevel) && !!activeSpecialBossEnemyId,
  [floorLevel, activeSpecialBossEnemyId]
);

const isSpiderBossFloorActive = React.useMemo(
  () => isSpecialBossFloor(floorLevel) && isSpiderBossEncounterSelection(specialBossFloorSelection),
  [floorLevel, specialBossFloorSelection]
);

const isMonsignorBossFloorActive = React.useMemo(
  () => isSpecialBossFloor(floorLevel) && isMonsignorBossEncounterSelection(specialBossFloorSelection),
  [floorLevel, specialBossFloorSelection]
);

const isBlackhandBossFloorActive = React.useMemo(
  () => isSpecialBossFloor(floorLevel) && isBlackhandBossEncounterSelection(specialBossFloorSelection),
  [floorLevel, specialBossFloorSelection]
);

const isCorruptedFloorActive = React.useMemo(
  () => isCorruptionEnabledForMood(currentFloorMood),
  [currentFloorMood]
);

const normalFloorTiles = React.useMemo(
  () =>
    (FLOOR_TILESET_PROFILES.default?.corridorImgs || corridorImgs).map((img) => ({
      img,
      rotation: 0,
    })),
  []
);

const corruptedFloorTiles = React.useMemo(
  () =>
    (FLOOR_TILESET_PROFILES.corrupted?.corridorImgs || []).map((img) => ({
      img,
      rotation: 0,
    })),
  []
);

const floorSeed = (runSeedRef.current ^ (floorLevel * 0x9e3779b9)) >>> 0;

  // Preload combat card library once when the app boots so combat opens instantly.
  const combatLoadCards = useCombatStore((s) => s.loadCards);
const combatDispatch = useCombatStore((s) => s.dispatch);
const combatLibrary = useCombatStore((s) => s.library);

const {
  bootReady,
  bootProgress,
  bootPct,
} = useBootLoader({
  localAssets: BOOT_LOCAL_ASSETS,
  combatLibrary,
  combatLoadCards,
  combatDispatch,
});

  useEffect(() => {
    return () => {
      if (torchCameraAnimTimeoutRef.current) {
        clearTimeout(torchCameraAnimTimeoutRef.current);
        torchCameraAnimTimeoutRef.current = null;
      }
      if (torchZoomAnimRafRef.current) {
        cancelAnimationFrame(torchZoomAnimRafRef.current);
        torchZoomAnimRafRef.current = null;
      }
    };
  }, []);

  const triggerTorchCameraRecenterAnim = (fromScale, toScale) => {
    const durationMs = 420;

    setIsTorchCameraRecenterAnimating(true);

    if (torchCameraAnimTimeoutRef.current) {
      clearTimeout(torchCameraAnimTimeoutRef.current);
      torchCameraAnimTimeoutRef.current = null;
    }
    if (torchZoomAnimRafRef.current) {
      cancelAnimationFrame(torchZoomAnimRafRef.current);
      torchZoomAnimRafRef.current = null;
    }

    const safeFrom = Number.isFinite(fromScale) ? fromScale : toScale;
    const safeTo = Number.isFinite(toScale) ? toScale : safeFrom;
    const ratioRaw = (safeTo && Number.isFinite(safeTo)) ? (safeFrom / safeTo) : 1;
    const startMul = Number.isFinite(ratioRaw)
      ? Math.max(0.25, Math.min(8, ratioRaw))
      : 1;

    // Important: do NOT animate layout zoom here. Reflowing tile sizes every frame causes
    // visible camera jitter because the board dimensions and culling window keep changing.
    setLayoutZoomTweenScale(null);
    setTorchCameraVisualScaleMultiplier(startMul);

    // If there's effectively nothing to tween, just end immediately.
    if (Math.abs(startMul - 1) < 0.001) {
      setTorchCameraVisualScaleMultiplier(1);
      setIsTorchCameraRecenterAnimating(false);
      return;
    }

    const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);
    const startTs = (typeof performance !== 'undefined' && performance.now)
      ? performance.now()
      : Date.now();

    const tick = (nowTs) => {
      const now = Number.isFinite(nowTs) ? nowTs : ((typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now());
      const t = Math.max(0, Math.min(1, (now - startTs) / durationMs));
      const eased = easeOutCubic(t);
      const currentMul = startMul + ((1 - startMul) * eased);
      setTorchCameraVisualScaleMultiplier(currentMul);

      if (t < 1) {
        torchZoomAnimRafRef.current = requestAnimationFrame(tick);
        return;
      }

      setTorchCameraVisualScaleMultiplier(1);
      setLayoutZoomTweenScale(null);
      setIsTorchCameraRecenterAnimating(false);
      torchZoomAnimRafRef.current = null;
      if (torchCameraAnimTimeoutRef.current) {
        clearTimeout(torchCameraAnimTimeoutRef.current);
        torchCameraAnimTimeoutRef.current = null;
      }
    };

    torchZoomAnimRafRef.current = requestAnimationFrame(tick);

    // Failsafe in case RAF is interrupted (tab switch, etc.)
    torchCameraAnimTimeoutRef.current = setTimeout(() => {
      setTorchCameraVisualScaleMultiplier(1);
      setLayoutZoomTweenScale(null);
      setIsTorchCameraRecenterAnimating(false);
      if (torchZoomAnimRafRef.current) {
        cancelAnimationFrame(torchZoomAnimRafRef.current);
        torchZoomAnimRafRef.current = null;
      }
      torchCameraAnimTimeoutRef.current = null;
    }, durationMs + 80);
  };

const [playerPos, setPlayerPos] = useState(
  () => initialFloorStateRef.current.playerPos
);
const spawnStepsDownPlayedRef = useRef(false);
const previousSpawnTutorialPlayerPosRef = useRef(null);
const spawnTutorialFinalTimeoutRef = useRef(null);
const spawnTutorialFinalFadeTimeoutRef = useRef(null);
const [isSpawnTutorialFinalFading, setIsSpawnTutorialFinalFading] = useState(false);

const [map, setMap] = useState(
  () => initialFloorStateRef.current.map
);

const [ambientProps, setAmbientProps] = useState([]);
const [underProps, setUnderProps] = useState([]);

const [barredDoorKeys, setBarredDoorKeys] = useState(
  () => initialFloorStateRef.current.barredDoorKeys
);

  // Current map dimensions (drive all bounds checks + loops off the actual map)
  const mapWidth = map?.[0]?.length ?? 0;
  const mapHeight = map?.length ?? 0;

  const secretEntrancePos = React.useMemo(() => {
  if (!Array.isArray(map) || map.length === 0) return null;

  for (let y = 0; y < map.length; y++) {
    const row = map[y];
    if (!Array.isArray(row)) continue;

    for (let x = 0; x < row.length; x++) {
      if (row[x] === 'secret-entrance') return { x, y };
    }
  }

  return null;
}, [map]);
  const [turns, setTurns] = useState(
  () => initialFloorStateRef.current.turns
);

useEffect(() => {
  previousSpawnTutorialPlayerPosRef.current = playerPos;
}, []);

useEffect(() => {
  const previousPos = previousSpawnTutorialPlayerPosRef.current;
  const moved =
    !!previousPos &&
    (previousPos.x !== playerPos.x || previousPos.y !== playerPos.y);

  previousSpawnTutorialPlayerPosRef.current = playerPos;

  if (spawnTutorialStage !== 'moveInteract') return;
  if (spawnTutorialMoveTriggered) return;
  if (!moved) return;

  setSpawnTutorialMoveTriggered(true);
}, [playerPos, spawnTutorialMoveTriggered, spawnTutorialStage]);

useEffect(() => {
  if (spawnTutorialStage !== 'moveInteract' || !spawnTutorialMoveTriggered) return;

  setSpawnTutorialStage((currentStage) =>
    currentStage === 'moveInteract' ? 'findExit' : currentStage
  );
  setSpawnTutorialMoveTriggered(false);
}, [spawnTutorialMoveTriggered, spawnTutorialStage]);

useEffect(() => {
  if (spawnTutorialFinalTimeoutRef.current) {
    clearTimeout(spawnTutorialFinalTimeoutRef.current);
    spawnTutorialFinalTimeoutRef.current = null;
  }
  if (spawnTutorialFinalFadeTimeoutRef.current) {
    clearTimeout(spawnTutorialFinalFadeTimeoutRef.current);
    spawnTutorialFinalFadeTimeoutRef.current = null;
  }

  if (spawnTutorialStage !== 'findExit') {
    setIsSpawnTutorialFinalFading(false);
    return undefined;
  }

  setIsSpawnTutorialFinalFading(false);

  spawnTutorialFinalTimeoutRef.current = setTimeout(() => {
    setIsSpawnTutorialFinalFading(true);

    spawnTutorialFinalFadeTimeoutRef.current = setTimeout(() => {
      setSpawnTutorialStage((currentStage) =>
        currentStage === 'findExit' ? 'done' : currentStage
      );
      setIsSpawnTutorialFinalFading(false);
      spawnTutorialFinalFadeTimeoutRef.current = null;
    }, 900);

    spawnTutorialFinalTimeoutRef.current = null;
  }, 5000);

  return () => {
    if (spawnTutorialFinalTimeoutRef.current) {
      clearTimeout(spawnTutorialFinalTimeoutRef.current);
      spawnTutorialFinalTimeoutRef.current = null;
    }
    if (spawnTutorialFinalFadeTimeoutRef.current) {
      clearTimeout(spawnTutorialFinalFadeTimeoutRef.current);
      spawnTutorialFinalFadeTimeoutRef.current = null;
    }
  };
}, [spawnTutorialStage]);
const [torches, setTorches] = useState(
  () => initialFloorStateRef.current.torches
);
  // Only animate the exploration camera when the player manually relights a torch.
  // Keeping normal movement camera updates instant avoids the "left jump"/laggy feel.
  const [isTorchCameraRecenterAnimating, setIsTorchCameraRecenterAnimating] = useState(false);
  const [layoutZoomTweenScale, setLayoutZoomTweenScale] = useState(null);
  // Visual-only camera scale tween used during torch relight. This avoids reflow jitter
  // from animating tile widths/heights every frame (layout zoom stays snapped).
  const [torchCameraVisualScaleMultiplier, setTorchCameraVisualScaleMultiplier] = useState(1);
  const torchCameraAnimTimeoutRef = useRef(null);
  const torchZoomAnimRafRef = useRef(null);
const [keys, setKeys] = useState(
  () => initialFloorStateRef.current.keys
);
const [teeth, setTeeth] = useState(
  () => initialFloorStateRef.current.teeth
);

const [litBraziers, setLitBraziers] = useState(
  () => initialFloorStateRef.current.litBraziers
);
const [brazierQuestCompletionTriggered, setBrazierQuestCompletionTriggered] =
  useState(() => initialFloorStateRef.current.brazierQuestCompletionTriggered);
const [brazierCompletionBannerText, setBrazierCompletionBannerText] =
  useState(() => initialFloorStateRef.current.brazierCompletionBannerText);

const [slainEnemiesThisFloor, setSlainEnemiesThisFloor] = useState(
  () => initialFloorStateRef.current.slainEnemiesThisFloor
);
const [cleansingQuestCompletionTriggered, setCleansingQuestCompletionTriggered] =
  useState(() => initialFloorStateRef.current.cleansingQuestCompletionTriggered);
const [cleansingCompletionBannerText, setCleansingCompletionBannerText] =
  useState(() => initialFloorStateRef.current.cleansingCompletionBannerText);

const [pendingDeckCullReward, setPendingDeckCullReward] = useState(
  () => initialFloorStateRef.current.pendingDeckCullReward
);


const savedTarot = initialFloorStateRef.current.tarot || null;
  const hydratedSavedActiveTarot = React.useMemo(
    () =>
      hydrateTarotSelection(
        savedTarot?.activeCardId,
        savedTarot?.activeOrientation
      ),
    [savedTarot]
  );
  const hydratedSavedPendingTarot = React.useMemo(
    () =>
      hydrateTarotSelection(
        savedTarot?.pendingCardId,
        savedTarot?.pendingOrientation
      ),
    [savedTarot]
  );
  // ---------------------------------------------------------------------------
  // Tarot mechanic state
  // ---------------------------------------------------------------------------
  // The tarot card whose effects are currently active on this floor.
  const [currentTarot, setCurrentTarot] = useState(() => hydratedSavedActiveTarot);
  // A tarot reading chosen from the Witch that will apply on the next floor.
  const [pendingTarotForNextFloor, setPendingTarotForNextFloor] = useState(
    () => hydratedSavedPendingTarot
  );
  // The tarot card currently being shown in the overlay.
  const [displayedTarot, setDisplayedTarot] = useState(null);
  // Record of past draws to avoid repeats. Each entry is { id, orientation }.
  const [tarotHistory, setTarotHistory] = useState(
  () => savedTarot?.history ?? []
);
  // Whether the tarot overlay is currently visible.
  const [isTarotVisible, setIsTarotVisible] = useState(false);
  const tarotOpenedAtRef = useRef(0);

  // Per-floor tarot effect flags. These are reset when entering a new floor
  // unless the originating card is marked permanent. See resetTarotEffects().
  const [tarotPerTileHpHeal, setTarotPerTileHpHeal] = useState(
  () => savedTarot?.perTileHpHeal ?? 0
);
  const [tarotTrapTimeFactor, setTarotTrapTimeFactor] = useState(
  () => savedTarot?.trapTimeFactor ?? 1
);
  const [tarotExtraLife, setTarotExtraLife] = useState(
  () => savedTarot?.extraLife ?? false
);
  const [tarotLifeUsed, setTarotLifeUsed] = useState(
  () => savedTarot?.lifeUsed ?? false
);
  const [tarotBypassCombats, setTarotBypassCombats] = useState(
  () => savedTarot?.bypassCombats ?? false
);
  const [tarotEnemiesChase, setTarotEnemiesChase] = useState(
  () => savedTarot?.enemiesChase ?? false
);
  // 'more' → more rare items; 'less' → fewer rares; null → default
  const [tarotShopRarity, setTarotShopRarity] = useState(
  () => savedTarot?.shopRarity ?? null
);
  const [tarotPlayerStartArmor, setTarotPlayerStartArmor] = useState(
  () => savedTarot?.playerStartArmor ?? 0
);
  const [tarotEnemyStartArmor, setTarotEnemyStartArmor] = useState(
  () => savedTarot?.enemyStartArmor ?? 0
);
  const [tarotNoTorchesNeeded, setTarotNoTorchesNeeded] = useState(
  () => savedTarot?.noTorchesNeeded ?? false
);
  const [tarotLightRadiusPenalty, setTarotLightRadiusPenalty] = useState(
  () => savedTarot?.lightRadiusPenalty ?? 0
);

  // ---------------------------------------------------------------------------
  // Extended tarot mechanic state (per-floor)
  // These flags enable new card effects introduced via the agent task. They
  // follow the same reset semantics as the existing tarot flags and are
  // considered non-permanent.
  const [tarotFreeTrinkets, setTarotFreeTrinkets] = useState(
  () => savedTarot?.freeTrinkets ?? false
);
const [tarotNoMerchant, setTarotNoMerchant] = useState(
  () => savedTarot?.noMerchant ?? false
);
const [tarotExtraRewardChoice, setTarotExtraRewardChoice] = useState(
  () => savedTarot?.extraRewardChoice ?? 0
);
  const [tarotReducedRewardChoice, setTarotReducedRewardChoice] = useState(
  () => savedTarot?.reducedRewardChoice ?? false
);
const [tarotMagicModifier, setTarotMagicModifier] = useState(
  () => savedTarot?.magicModifier ?? null
);
const [tarotRevealMap, setTarotRevealMap] = useState(
  () => savedTarot?.revealMap ?? false
);
  const [tarotDarknessDamage, setTarotDarknessDamage] = useState(
  () => savedTarot?.darknessDamage ?? 0
);
const [tarotPlayerStartReflectPct, setTarotPlayerStartReflectPct] = useState(
  () => savedTarot?.playerStartReflectPct ?? 0
);
const [tarotEnemyStartReflectPct, setTarotEnemyStartReflectPct] = useState(
  () => savedTarot?.enemyStartReflectPct ?? 0
);
  const [tarotChainExpBonus, setTarotChainExpBonus] = useState(
  () => savedTarot?.chainExpBonus ?? false
);
const [tarotNoExp, setTarotNoExp] = useState(
  () => savedTarot?.noExp ?? false
);

  // ---------------------------------------------------------------------------
  // Tarot helpers (moved inside GameBoard for proper scope)
  // ---------------------------------------------------------------------------
  /**
   * Clear all non‑permanent tarot effects. This is invoked whenever the player
   * enters a new floor. Permanent effects (those that immediately mutate
   * persistent state like removing teeth or granting a trinket) are applied
   * at draw time and do not have ongoing state to reset here.
   */
  const resetTarotEffects = React.useCallback(() => {
    setTarotPerTileHpHeal(0);
    setTarotTrapTimeFactor(1);
    setTarotExtraLife(false);
    setTarotLifeUsed(false);
    setTarotBypassCombats(false);
    setTarotEnemiesChase(false);
    setTarotShopRarity(null);
    setTarotPlayerStartArmor(0);
    setTarotEnemyStartArmor(0);
    setTarotNoTorchesNeeded(false);
    setTarotLightRadiusPenalty(0);

    // Reset extended tarot effects.
    setTarotFreeTrinkets(false);
    setTarotNoMerchant(false);
    setTarotExtraRewardChoice(0);
    setTarotReducedRewardChoice(false);
    setTarotMagicModifier(null);
    setTarotRevealMap(false);
    setTarotDarknessDamage(0);
    setTarotPlayerStartReflectPct(0);
    setTarotEnemyStartReflectPct(0);
    setTarotChainExpBonus(false);
    setTarotNoExp(false);
  }, []);

  /**
   * Move all enemy tiles one step closer to the player. Enemies attempt to
   * move horizontally towards the player first; if blocked or aligned, they
   * move vertically. Only tiles labeled 'enemy' or 'enemy-boss' are moved.
   * Tiles occupied by the player are never entered. If no adjacent floor
   * or corridor tile exists, the enemy stays put.
   *
   * @param {Array<Array<string>>} curMap Current dungeon map
   * @param {{x: number, y: number}} player Player position
   * @returns {Array<Array<string>>} A new map with updated enemy positions
   */
  const moveEnemiesTowardsPlayer = React.useCallback((curMap, player) => {
    if (isMonsignorBossFloorActive) return curMap;

    const newMap = curMap.map((row) => row.slice());
    // Track positions already taken so two enemies don't stack.
    const occupied = new Set();
    occupied.add(`${player.x},${player.y}`);
    // First mark all current enemy positions as occupied
    for (let y = 0; y < mapHeight; y++) {
      for (let x = 0; x < mapWidth; x++) {
        const tile = curMap[y][x];
        if (tile === 'enemy' || (tile === 'enemy-boss' && !isSpecialBossFloorActive)) {
          occupied.add(`${x},${y}`);
        }
      }
    }
    for (let y = 0; y < mapHeight; y++) {
      for (let x = 0; x < mapWidth; x++) {
        const tile = curMap[y][x];
if (tile === 'enemy' || (tile === 'enemy-boss' && !isSpecialBossFloorActive)) {
  if (isYahakaAtTile(x, y)) {
    occupied.add(`${x},${y}`);
    continue;
  }

  const isSpecialCorruptedEnemy =
    tile === 'enemy' &&
    floorCorruption?.specialEnemyKeys?.has?.(tileKey(x, y));

  if (isSpecialCorruptedEnemy) {
    occupied.add(`${x},${y}`);
    continue;
  }

  // Determine direction towards player
          let moved = false;
          const dx = player.x - x;
          const dy = player.y - y;
          const tryDirs = [];
          if (Math.abs(dx) >= Math.abs(dy)) {
            // horizontal first
            if (dx !== 0) tryDirs.push({ dx: Math.sign(dx), dy: 0 });
            if (dy !== 0) tryDirs.push({ dx: 0, dy: Math.sign(dy) });
          } else {
            // vertical first
            if (dy !== 0) tryDirs.push({ dx: 0, dy: Math.sign(dy) });
            if (dx !== 0) tryDirs.push({ dx: Math.sign(dx), dy: 0 });
          }
          for (const dir of tryDirs) {
            const nx = x + dir.dx;
            const ny = y + dir.dy;
            if (
              nx >= 0 && ny >= 0 && nx < mapWidth && ny < mapHeight &&
              (curMap[ny][nx] === 'floor' || curMap[ny][nx] === 'corridor') &&
              !occupied.has(`${nx},${ny}`)
            ) {
              // move enemy
              newMap[y][x] = curMap[y][x] === 'enemy-boss' ? 'floor' : 'floor';
              newMap[ny][nx] = tile;
              occupied.add(`${nx},${ny}`);
              moved = true;
              break;
            }
          }
          if (!moved) {
            occupied.add(`${x},${y}`);
          }
        }
      }
    }
    return newMap;
}, [mapWidth, mapHeight, floorCorruption, isMonsignorBossFloorActive, isSpecialBossFloorActive, isYahakaAtTile]);

  /**
   * Utility to add a random trinket from the relics pool. If no eligible
   * trinkets remain, nothing happens. Trinkets gained via tarot bypass
   * standard merchant purchases and are immediately added to ownedRelics.
   */
    const addRandomTrinket = React.useCallback(() => {
    setOwnedRelics((prev) => {
      const ownedIds = new Set(prev.map((r) => r.id));
      const eligible = relicsPool.filter(
  (r) => r && r.id && !ownedIds.has(r.id) && !isRansackedChestExclusiveRelic(r)
);
      if (!eligible.length) return prev;
      const idx = Math.floor(Math.random() * eligible.length);
      const pick = eligible[idx];
      return [...prev, pick];
    });
  }, []);
/**
   * Remove the last trinket in the ownedRelics array. This should not remove
   * quest items (which are handled elsewhere), but for simplicity we treat
   * the last acquired trinket as the most expendable. If no trinkets are
   * owned, this is a no‑op.
   */
  const removeLastTrinket = React.useCallback(() => {
    setOwnedRelics((prev) => {
      if (!Array.isArray(prev) || prev.length === 0) return prev;
      const copy = [...prev];
      copy.pop();
      return copy;
    });
  }, []);

  /**
   * Apply the tarot reading chosen through the Witch when entering a new floor.
   * If no reading is pending, simply clear any previous floor-bound tarot state.
   *
   * @param {number} nextFloor The floor index being entered
   */
  const maybeDrawTarot = React.useCallback(
    (nextFloor) => {
      // Always clear previous effects when changing floors.
      resetTarotEffects();
      setCurrentTarot(null);
      setDisplayedTarot(null);
      setIsTarotVisible(false);

      if (nextFloor < TAROT_START_FLOOR) {
        setPendingTarotForNextFloor(null);
        return;
      }

      const nextTarot = pendingTarotForNextFloor;
      if (!nextTarot?.card || !nextTarot?.orientation) return;

      const { card, orientation } = nextTarot;
      const ctx = {
        setTarotPerTileHpHeal,
        setTarotTrapTimeFactor,
        setTarotExtraLife,
        setTarotBypassCombats,
        setTarotEnemiesChase,
        setTarotShopRarity,
        setTarotPlayerStartArmor,
        setTarotEnemyStartArmor,
        setTarotNoTorchesNeeded,
        setTarotLightRadiusPenalty,
        setTarotFreeTrinkets,
        setTarotNoMerchant,
        setTarotExtraRewardChoice,
        setTarotReducedRewardChoice,
        setTarotMagicModifier,
        setTarotRevealMap,
        setTarotDarknessDamage,
        setTarotPlayerStartReflectPct,
        setTarotEnemyStartReflectPct,
        setTarotChainExpBonus,
        setTarotNoExp,
        setTeeth,
        addRandomTrinket,
        removeLastTrinket,
      };

      try {
        const orientationDef = card.orientations?.[orientation];
        if (orientationDef && typeof orientationDef.apply === 'function') {
          orientationDef.apply(ctx);
        }
      } catch (e) {
        console.error('Error applying tarot effect:', e);
      }

      setCurrentTarot(nextTarot);
      setPendingTarotForNextFloor(null);
      setDisplayedTarot(nextTarot);

      tarotOpenedAtRef.current =
        (typeof performance !== 'undefined' && typeof performance.now === 'function')
          ? performance.now()
          : Date.now();

      setIsTarotVisible(true);
    },
    [
      pendingTarotForNextFloor,
      resetTarotEffects,
      setTarotPerTileHpHeal,
      setTarotTrapTimeFactor,
      setTarotExtraLife,
      setTarotBypassCombats,
      setTarotEnemiesChase,
      setTarotShopRarity,
      setTarotPlayerStartArmor,
      setTarotEnemyStartArmor,
      setTarotNoTorchesNeeded,
      setTarotLightRadiusPenalty,
      setTarotFreeTrinkets,
      setTarotNoMerchant,
      setTarotExtraRewardChoice,
      setTarotReducedRewardChoice,
      setTarotMagicModifier,
      setTarotRevealMap,
      setTarotDarknessDamage,
      setTarotPlayerStartReflectPct,
      setTarotEnemyStartReflectPct,
      setTarotChainExpBonus,
      setTarotNoExp,
      setTeeth,
      addRandomTrinket,
      removeLastTrinket,
    ]
  );

  const handleConsultWitch = React.useCallback(() => {
    if (floorLevel < TAROT_START_FLOOR) return;
    if (map?.[playerPos.y]?.[playerPos.x] !== 'witch') return;

    const result = drawTarotCard(tarotHistory);
    if (!result?.card || !result?.orientation) {
      setMap((prev) => {
        if (prev?.[playerPos.y]?.[playerPos.x] !== 'witch') return prev;
        const next = prev.map((row) => row.slice());
        next[playerPos.y][playerPos.x] = 'floor';
        return next;
      });
      return;
    }

    setTarotHistory((prev) => [
      ...prev,
      { id: result.card.id, orientation: result.orientation },
    ]);
    unlockLegendariumEntries({ tarot: [result.card.id] });
    setPendingTarotForNextFloor(result);
    setDisplayedTarot(result);

    tarotOpenedAtRef.current =
      (typeof performance !== 'undefined' && typeof performance.now === 'function')
        ? performance.now()
        : Date.now();

    setIsTarotVisible(true);
    setMap((prev) => {
      if (prev?.[playerPos.y]?.[playerPos.x] !== 'witch') return prev;
      const next = prev.map((row) => row.slice());
      next[playerPos.y][playerPos.x] = 'floor';
      return next;
    });
  }, [floorLevel, map, playerPos, tarotHistory, setMap]);

// --- Owned trinkets/relics (persisted across floors) ---
  const [ownedRelics, setOwnedRelics] = useState(() => {
    try {
      const raw = localStorage.getItem('dd_owned_relics_v1');
      const parsed = raw ? JSON.parse(raw) : null;
      const ids = Array.isArray(parsed) ? parsed : [];
      // Store only ids in localStorage; hydrate to full objects.
      return ids
        .map((id) => relicsPool.find((r) => r.id === id))
        .filter(Boolean);
    } catch {
      return [];
    }
  });

const prevTurnsRef = React.useRef(turns);

React.useEffect(() => {
  const prev = prevTurnsRef.current;
  if (turns <= prev) {
    prevTurnsRef.current = turns;
    return;
  }

  // If turns jumped by more than 1, award for every threshold crossed.
  for (let t = prev + 1; t <= turns; t++) {
    for (const r of ownedRelics) {
      const cfg = r?.dungeon?.perTurnSpRegen;
      if (!cfg) continue;

      const interval = Math.max(1, Math.floor(Number(cfg.turns) || 0));
      const spGain = Math.floor(Number(cfg.sp) || 0);

      if (interval > 0 && spGain !== 0 && t % interval === 0) {
        setSanity((s) => s + spGain);
      }
    }
  }

  prevTurnsRef.current = turns;
}, [turns, tarotLifeUsed]);


const BASE_MAX_TEETH = 6;
const BASE_MAX_KEYS = 3;
const BASE_MAX_POTIONS = 3;
const BASE_MAX_TORCHES = 3;

const BASE_MAX_HP = 100;
const BASE_MAX_SP = 100;


const brazierKey = (x, y) => `${x},${y}`;

// Memoize the brazier lit check so its reference stays stable across renders.
// Without useCallback, a new function is created on every render, causing
// `tileHelpers` to change and forcing all DungeonTile children to rerender.
// useCallback returns the same function instance unless `litBraziers` changes.
const isBrazierLit = React.useCallback((x, y) => {
  if (!BRAZIER_LIGHTING_ENABLED) return true;
  return litBraziers.has(brazierKey(x, y));
}, [litBraziers]);

const igniteBrazier = (x, y) => {
  setLitBraziers((prev) => {
    const k = brazierKey(x, y);
    if (prev.has(k)) return prev; // already lit
    const next = new Set(prev);
    next.add(k);
    return next;
  });
};

const litBrazierCoords = React.useMemo(() => {
  if (!BRAZIER_LIGHTING_ENABLED) return [];
  if (!(litBraziers instanceof Set) || litBraziers.size === 0) return [];

  const coords = [];
  litBraziers.forEach((key) => {
    const [xs, ys] = String(key).split(',');
    const x = Number(xs);
    const y = Number(ys);
    if (!Number.isFinite(x) || !Number.isFinite(y)) return;
    if (map?.[y]?.[x] !== 'brazier') return;
    coords.push({ x, y, key });
  });

  return coords;
}, [litBraziers, map]);

const isTileLitForCorruption = React.useCallback((x, y) => {
  // Recompute locally because torchProgress/lightRadius are declared later in GameBoard.
  const torchProg = tarotNoTorchesNeeded
    ? 1
    : Math.max(0, 1 - turns / currentFloorTorchDuration);

  const visionBonusLocal = ownedRelics.reduce(
    (acc, r) => acc + (r?.dungeon?.visionBonus || 0),
    0
  );

  const lightLevelLocal = Math.ceil(torchProg * 4);
  const lightRadiusLocal = Math.max(
    1,
    lightLevelLocal + visionBonusLocal - (tarotLightRadiusPenalty || 0)
  );

  // Player torch light
  if (torchProg > 0) {
    const dx = Math.abs(playerPos.x - x);
    const dy = Math.abs(playerPos.y - y);
    if (dx + dy <= lightRadiusLocal) return true;
  }

  // Brazier light
  if (BRAZIER_LIGHTING_ENABLED) {
    for (const { x: bx, y: by } of litBrazierCoords) {
      const dx = Math.abs(bx - x);
      const dy = Math.abs(by - y);
      if (dx + dy <= BRAZIER_LIGHT_RADIUS) return true;
    }
  }

  return false;
}, [
  tarotNoTorchesNeeded,
  turns,
  currentFloorTorchDuration,
  ownedRelics,
  tarotLightRadiusPenalty,
  playerPos,
  map,
  litBrazierCoords,
]);

const previousFloorLevelRef = useRef(floorLevel);

const brazierProgress = React.useMemo(() => {
  let total = 0;
  let lit = 0;

  if (!Array.isArray(map) || map.length === 0) {
    return { lit: 0, total: 0 };
  }

  for (let y = 0; y < map.length; y++) {
    const row = map[y];
    if (!Array.isArray(row)) continue;

    for (let x = 0; x < row.length; x++) {
      if (row[x] !== 'brazier') continue;

      total += 1;

      // Uses your existing helper so the toggle behavior stays consistent
      if (isBrazierLit(x, y)) {
        lit += 1;
      }
    }
  }

  return { lit, total };
}, [map, litBraziers]);

const floorCleansingProgress = React.useMemo(() => {
  let remaining = 0;

  if (!Array.isArray(map) || map.length === 0) {
    return { slain: 0, remaining: 0, total: 0 };
  }

  for (let y = 0; y < map.length; y++) {
    const row = map[y];
    if (!Array.isArray(row)) continue;

    for (let x = 0; x < row.length; x++) {
      if ((row[x] === 'enemy' || row[x] === 'enemy-boss') && !isYahakaAtTile(x, y)) {
        remaining += 1;
      }
    }
  }

  return {
    slain: slainEnemiesThisFloor,
    remaining,
    total: remaining + slainEnemiesThisFloor,
  };
}, [map, slainEnemiesThisFloor, isYahakaAtTile]);

// ------------------------------------------------------------
// Shrine sacrifices that permanently reduce MAX HP / MAX SP
// (Rare shrines use these as their payment)
// ------------------------------------------------------------
const [shrineMaxHpPenalty, setShrineMaxHpPenalty] = useState(() => {
  try {
    const raw = localStorage.getItem("dd_shrine_maxhp_penalty_v1");
    const parsed = raw ? JSON.parse(raw) : null;
    const n = Math.max(0, Math.floor(Number(parsed) || 0));
    return Number.isFinite(n) ? n : 0;
  } catch {
    return 0;
  }
});

const [shrineMaxSpPenalty, setShrineMaxSpPenalty] = useState(() => {
  try {
    const raw = localStorage.getItem("dd_shrine_maxsp_penalty_v1");
    const parsed = raw ? JSON.parse(raw) : null;
    const n = Math.max(0, Math.floor(Number(parsed) || 0));
    return Number.isFinite(n) ? n : 0;
  } catch {
    return 0;
  }
});

// ------------------------------------------------------------
// Level up (triggered on combat victory in the demo)
// ------------------------------------------------------------
const pendingLevelUpRefillRef = useRef(false);

const {
  playerLevel,
  playerXp,
  xpToNextLevel,
  levelMaxHpBonus,
  levelMaxSpBonus,
  isLevelUpOpen,
  levelUpPulse,
  levelUpStep,
  levelCombatMods,
  applyLevelUpChoice,
  continueAfterDrawBonus,
  awardCombatVictoryXp,
} = useLevelProgression({
  onLevelUpRefillRequested: () => {
    pendingLevelUpRefillRef.current = true;
  },
});

const maxHp = React.useMemo(() => {
  const bonus = ownedRelics.reduce((acc, r) => {
    const b = Number(
      r?.dungeon?.maxHpBonus ??
      r?.dungeon?.maxHPBonus ??
      r?.dungeon?.maxHp ??
      r?.dungeon?.maxHP ??
      0
    );
    return acc + (Number.isFinite(b) ? b : 0);
  }, 0);
  return Math.max(1, BASE_MAX_HP + bonus + (Number(levelMaxHpBonus) || 0) - (Number(shrineMaxHpPenalty) || 0));

}, [ownedRelics, levelMaxHpBonus, shrineMaxHpPenalty]);


const maxSp = React.useMemo(() => {
  const bonus = ownedRelics.reduce((acc, r) => {
    const b = Number(
      r?.dungeon?.maxSpBonus ??
      r?.dungeon?.maxSPBonus ??
      r?.dungeon?.maxSp ??
      r?.dungeon?.maxSP ??
      0
    );
    return acc + (Number.isFinite(b) ? b : 0);
  }, 0);
  return Math.max(1, BASE_MAX_SP + bonus + (Number(levelMaxSpBonus) || 0) - (Number(shrineMaxSpPenalty) || 0));

}, [ownedRelics, levelMaxSpBonus, shrineMaxSpPenalty]);



const maxTeeth = React.useMemo(() => {
  const bonus = ownedRelics.reduce((acc, r) => acc + (r?.dungeon?.maxTeethBonus || 0), 0);
  return BASE_MAX_TEETH + bonus;
}, [ownedRelics]);

const maxKeys = React.useMemo(() => {
  const bonus = ownedRelics.reduce((acc, r) => acc + (r?.dungeon?.maxKeysBonus || 0), 0);
  return BASE_MAX_KEYS + bonus;
}, [ownedRelics]);

const maxPotions = React.useMemo(() => {
  const bonus = ownedRelics.reduce((acc, r) => acc + (r?.dungeon?.maxPotionsBonus || 0), 0);
  return BASE_MAX_POTIONS + bonus;
}, [ownedRelics]);

const maxTorches = React.useMemo(() => {
  const bonus = ownedRelics.reduce((acc, r) => acc + (r?.dungeon?.maxTorchesBonus || 0), 0);
  return BASE_MAX_TORCHES + bonus;
}, [ownedRelics]);

const trinketLimit = React.useMemo(() => {
  const bonus = ownedRelics.reduce(
    (acc, r) => acc + (Number(r?.dungeon?.trinketLimitBonus) || 0),
    0
  );
  return TRINKET_LIMIT + bonus;
}, [ownedRelics]);

const torchDurationBonus = React.useMemo(() => {
  return ownedRelics.reduce((acc, r) => {
    const bonus = Number(
      r?.dungeon?.torchDurationBonus ??
      r?.dungeon?.torchDuration ??
      r?.combat?.torchDuration ??
      0
    );
    return acc + (Number.isFinite(bonus) ? bonus : 0);
  }, 0);
}, [ownedRelics]);

const revealMapOnFloorStart = React.useMemo(() => {
  return ownedRelics.some(
    (r) =>
      !!(
        r?.dungeon?.revealMapOnFloorStart ??
        r?.dungeon?.mapDiscovered ??
        r?.combat?.mapDiscovered
      )
  );
}, [ownedRelics]);

const torchRelicRuntimeRef = React.useRef({
  floorLevel,
  bonus: torchDurationBonus,
});

useEffect(() => {
  const prev = torchRelicRuntimeRef.current;
  let delta = 0;

  if (floorLevel !== prev.floorLevel) {
    delta = Math.floor(Number(torchDurationBonus) || 0);
  } else if (torchDurationBonus !== prev.bonus) {
    delta =
      Math.floor(Number(torchDurationBonus) || 0) -
      Math.floor(Number(prev.bonus) || 0);
  }

  if (delta !== 0) {
    setCurrentFloorTorchDuration((prevDuration) =>
      Math.max(1, Math.floor(Number(prevDuration) || 0) + delta)
    );
  }

  torchRelicRuntimeRef.current = {
    floorLevel,
    bonus: torchDurationBonus,
  };
}, [floorLevel, torchDurationBonus]);

const trapActivationChanceMultiplier = React.useMemo(() => {
  return getTrapActivationChanceMultiplier(ownedRelics);
}, [ownedRelics]);

const perTileHpRegen = React.useMemo(() => {
  return getPerTileHpRegen(ownedRelics);
}, [ownedRelics]);

const [flash, setFlash] = useState(false);

  const clampStat = (v, max) => {
  const n = Math.floor(Number(v) || 0);
  const m = Math.max(0, Math.floor(Number(max) || 0));
  return Math.max(0, Math.min(m, n));
};


  const [hp, _setHp] = useState(() => {
    try {
      const raw = localStorage.getItem('dd_player_hp_v1');
      const parsed = raw ? JSON.parse(raw) : null;
      return typeof parsed === 'number' ? clampStat(parsed, maxHp) : maxHp;
    } catch {
      return 100;
    }
  });

  const setHp = (next) => {
    _setHp((prev) => {
      const v = typeof next === 'function' ? next(prev) : next;
      return clampStat(v, maxHp);
    });
  };

  // Extra life effect (The Contract upright). If the player's HP reaches 0
  // while an extra life is active, immediately restore them to 1 HP and
  // consume the extra life. Only triggers once per floor.
  useEffect(() => {
    if (hp <= 0 && tarotExtraLife && !tarotLifeUsed) {
      setHp(1);
      setTarotExtraLife(false);
      setTarotLifeUsed(true);
    }
  }, [hp, tarotExtraLife, tarotLifeUsed]);

  const deathReturnTriggeredRef = useRef(false);

  useEffect(() => {
    if (hp > 0) {
      deathReturnTriggeredRef.current = false;
      return;
    }

    if (tarotExtraLife && !tarotLifeUsed) return;
    if (deathReturnTriggeredRef.current) return;

    deathReturnTriggeredRef.current = true;
    onPlayerDeath?.();
  }, [hp, onPlayerDeath, tarotExtraLife, tarotLifeUsed]);

  const [sanity, _setSanity] = useState(() => {
    try {
      const raw = localStorage.getItem('dd_player_sp_v1');
      const parsed = raw ? JSON.parse(raw) : null;
      return typeof parsed === 'number' ? clampStat(parsed, maxSp) : maxSp;
    } catch {
      return 100;
    }
  });

  const setSanity = (next) => {
    _setSanity((prev) => {
      const v = typeof next === 'function' ? next(prev) : next;
      return clampStat(v, maxSp);
    });
  };

  useEffect(() => {
    if (previousFloorLevelRef.current === floorLevel) return;

    previousFloorLevelRef.current = floorLevel;

    setLitBraziers(new Set());
    setBrazierQuestCompletionTriggered(false);
    setBrazierCompletionBannerText('');

    setSlainEnemiesThisFloor(0);
    setCleansingQuestCompletionTriggered(false);
    setCleansingCompletionBannerText('');
    setPendingDeckCullReward(false);
    setFloorActionCount(0);
    setCorruptionBannerText('');
    setPendingCorruptionBonusReward(false);
    setYahakaState(createInactiveYahakaState());
    setYahakaSpawnArmed(yahakaDefeatCount < 7);
    setYahakaBannerText('');
  }, [floorLevel, sanity, yahakaDefeatCount]);

  const sanityPct = maxSp > 0
    ? Math.max(0, Math.min(1, sanity / maxSp))
    : 1;

  const madness = 1 - sanityPct;
  const hudGlitchPctThreshold = 0.30;

  const sanityTier =
    sanityPct <= 0.25 ? 3 :
    sanityPct <= 0.50 ? 2 :
    sanityPct <= 0.75 ? 1 :
    0;


  const [canRest, setCanRest] = useState(false);
const [visibleTiles, setVisibleTiles] = useState(new Set());

const [exploredTiles, setExploredTiles] = useState(
  () => initialFloorStateRef.current.exploredTiles
);

useEffect(() => {
  if (!revealMapOnFloorStart) return;
  if (!Array.isArray(map) || map.length === 0) return;

  const height = map.length;
  const width = Array.isArray(map[0]) ? map[0].length : 0;
  if (width <= 0) return;

  setExploredTiles((prev) => {
    const all = new Set();
    for (let y = 0; y < height; y += 1) {
      for (let x = 0; x < width; x += 1) {
        all.add(`${x},${y}`);
      }
    }

    if (
      prev instanceof Set &&
      prev.size === all.size &&
      Array.from(all).every((key) => prev.has(key))
    ) {
      return prev;
    }

    return all;
  });
}, [floorLevel, map, revealMapOnFloorStart]);
// NEW: minimap modal toggle
const [isMiniMapOpen, setIsMiniMapOpen] = useState(false);

const [pulse, setPulse] = useState(false);

  // ------------------------------------------------------------
  // Demo reset (clears persisted run state)
  // ------------------------------------------------------------
  const resetDemo = React.useCallback(() => {
  const ok = window.confirm(
    'Reset the demo? This will clear your saved deck, looted trinkets, legendarium progress, and restart the run.'
  );
  if (!ok) return;

  skipUnloadPersistenceRef.current = true;

  clearSavedRunState({
    clearCharacter: true,
    clearMenuSeen: true,
  });
  clearLegendariumState();

  window.location.reload();
}, []);
  

  // One-shot exploration -> combat flags.
const [nextCombatCost0, setNextCombatCost0] = useState(
  () => initialFloorStateRef.current.nextCombatCost0
);

const [nextCombatNegateNextDamage, setNextCombatNegateNextDamage] = useState(
  () => initialFloorStateRef.current.nextCombatNegateNextDamage
);

const [nextCombatStartArmor, setNextCombatStartArmor] = useState(
  () => initialFloorStateRef.current.nextCombatStartArmor
);

// Per-floor charges (reset on descend).
const [bypassEnemiesRemaining, setBypassEnemiesRemaining] = useState(
  () => initialFloorStateRef.current.bypassEnemiesRemaining
);

// Per-floor chest freebies (reset on descend).
const [freeChestsRemaining, setFreeChestsRemaining] = useState(
  () => initialFloorStateRef.current.freeChestsRemaining
);

  // Snapshot of combat mods to apply for the current fight.
  const [activeCombatMods, setActiveCombatMods] = useState(null);

  // --- Card combat integration ---
  // Persist the player's combat deck across the run.
  const [playerDeckIds, setPlayerDeckIds] = useState(() => {
    try {
      const raw = localStorage.getItem('dd_player_deck_ids_v1');
      const parsed = raw ? JSON.parse(raw) : null;
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  });
  const deckCards = React.useMemo(() => {
  // While library is loading, return null so the UI can show "Loading…"
  if (!Array.isArray(combatLibrary) || combatLibrary.length === 0) return null;

  const lib = combatLibrary;

  // Library loaded, but deck is empty
  if (!playerDeckIds || playerDeckIds.length === 0) return [];

  return playerDeckIds
    .map((id) => lib.find((c) => c && c.id === id))
    .filter(Boolean);
}, [combatLibrary, playerDeckIds]);

const sameDeckIds = (a, b) => {
  if (!Array.isArray(a) || !Array.isArray(b)) return false;
  if (a.length !== b.length) return false;
  for (let i = 0; i < a.length; i += 1) {
    if (a[i] !== b[i]) return false;
  }
  return true;
};

useEffect(() => {
  if (!Array.isArray(combatLibrary) || combatLibrary.length === 0) return;

  const nextDeckIds = resolveInitialDeckIds(combatLibrary, playerDeckIds);

  if (nextDeckIds.length === 0) {
    console.warn('Starter deck: none of the configured starter ids exist in combatLibrary.');
    return;
  }

  if (sameDeckIds(playerDeckIds, nextDeckIds)) return;

  setPlayerDeckIds(nextDeckIds);
}, [combatLibrary, playerDeckIds]);

  const [isCombatActive, setIsCombatActive] = useState(false);
const [combatEnemyTile, setCombatEnemyTile] = useState(null);
const [isPreCombatTransitionActive, setIsPreCombatTransitionActive] = useState(false);
const [pendingStoryCombatResume, setPendingStoryCombatResume] = useState(null);
const [preCombatZoomTarget, setPreCombatZoomTarget] = useState(null);
const preCombatTransitionTimeoutRef = useRef(null);


  // ---------------------------------------------
// ENEMY SPAWNING (easy knobs)
// ---------------------------------------------
// Define the first floor where each roaming enemy can appear.
// Floor counting starts at 1 (see floorLevel's initial state).
//
// Add new enemies by:
// 1) importing their sprite
// 2) adding them to ENEMY_IMAGES
// 3) adding an entry here
// 4) (optional) giving them an enemy definition + enemyCards in combat/game/enemies.ts

const isSpecialCorruptedEnemyAtTile = React.useCallback(
  (x, y) => !!floorCorruption?.specialEnemyKeys?.has?.(tileKey(x, y)),
  [floorCorruption]
);
const findStepsDownPos = React.useCallback((mapLike) => {
  if (!Array.isArray(mapLike) || !mapLike.length) return null;

  for (let y = 0; y < mapLike.length; y++) {
    const row = mapLike[y];
    if (!Array.isArray(row)) continue;

    for (let x = 0; x < row.length; x++) {
      if (row[x] === 'steps-down') return { x, y };
    }
  }

  return null;
}, []);


const compassDirectionText = React.useMemo(() => {
  const hasCompass = ownedRelics.some((r) => r?.dungeon?.compassHint);
  if (!hasCompass) return '';

  const stepsPos = findStepsDownPos(map);
  if (!stepsPos) return '';

  const dx = stepsPos.x - playerPos.x;
  const dy = stepsPos.y - playerPos.y;
  if (dx === 0 && dy === 0) return 'beneath your feet';

  const vertical = dy < 0 ? 'north' : dy > 0 ? 'south' : '';
  const horizontal = dx > 0 ? 'east' : dx < 0 ? 'west' : '';
  return [vertical, horizontal].filter(Boolean).join('-');
}, [findStepsDownPos, map, ownedRelics, playerPos.x, playerPos.y]);

const compassDescriptionText = React.useMemo(() => {
  const hasCompass = ownedRelics.some((r) => r?.dungeon?.compassHint);
  if (!hasCompass) return 'It hints towards the exit steps.';
  if (!compassDirectionText) return 'It hints towards the exit steps.';
  if (compassDirectionText === 'beneath your feet') {
    return 'It hints towards the exit steps. Currently, it is pointing beneath your feet.';
  }
  return `It hints towards the exit steps. Currently, it is pointing ${compassDirectionText}.`;
}, [ownedRelics, compassDirectionText]);

const applyRuntimeRelicDescription = React.useCallback((relic) => {
  if (!relic) return relic;
  if (relic.id !== 'compass') return relic;
  return {
    ...relic,
    description: compassDescriptionText,
  };
}, [compassDescriptionText]);

const previousSpiderBossFloorRef = useRef(floorLevel);
const previousSpiderBossPlayerPosRef = useRef(playerPos);

const PRE_COMBAT_TRANSITION_MS = 700;
const PRE_COMBAT_ZOOM_MULTIPLIER = 2.8;
const PRE_COMBAT_FADE_DELAY_MS = 180;

const clearPreCombatTransitionTimeout = React.useCallback(() => {
  if (preCombatTransitionTimeoutRef.current) {
    window.clearTimeout(preCombatTransitionTimeoutRef.current);
    preCombatTransitionTimeoutRef.current = null;
  }
}, []);

useEffect(() => {
  return () => {
    clearPreCombatTransitionTimeout();
  };
}, [clearPreCombatTransitionTimeout]);

const beginCombatTransition = React.useCallback((enemyTile) => {
  if (!enemyTile) return;

  setCombatEnemyTile(enemyTile);

  if (isCombatActive || isPreCombatTransitionActive) {
    setIsCombatActive(true);
    return;
  }

  setPreCombatZoomTarget(enemyTile);
  setIsPreCombatTransitionActive(true);
  clearPreCombatTransitionTimeout();

  preCombatTransitionTimeoutRef.current = window.setTimeout(() => {
    preCombatTransitionTimeoutRef.current = null;
    setIsPreCombatTransitionActive(false);
    setPreCombatZoomTarget(null);
    setIsCombatActive(true);
  }, PRE_COMBAT_TRANSITION_MS);
}, [
  clearPreCombatTransitionTimeout,
  isCombatActive,
  isPreCombatTransitionActive,
]);


useEffect(() => {
  if (previousSpiderBossFloorRef.current === floorLevel) return;

  previousSpiderBossFloorRef.current = floorLevel;
  previousSpiderBossPlayerPosRef.current = playerPos;
}, [floorLevel, playerPos]);

useEffect(() => {
  const expectedSpecialBossSelection = getSpecialBossFloorEncounter(
    specialBossFloorSelection,
    {
      floor: floorLevel,
      runSeed: runSeedRef.current,
    }
  );

  if (!isSpecialBossFloor(floorLevel) || !expectedSpecialBossSelection) {
    if (specialBossFloorSelection) {
      setSpecialBossFloorSelection(null);
    }
    if (spiderBossState.enabled) {
      setSpiderBossState(createDisabledSpiderBossState());
    }
    return;
  }

  if (
    specialBossFloorSelection?.enemyId !== expectedSpecialBossSelection.enemyId ||
    specialBossFloorSelection?.id !== expectedSpecialBossSelection.id
  ) {
    setSpecialBossFloorSelection(expectedSpecialBossSelection);
  }

  const expectedBossMood = getSpecialBossFloorMood(expectedSpecialBossSelection);
  if (expectedBossMood && currentFloorMood?.id !== expectedBossMood.id) {
    setCurrentFloorMood(expectedBossMood);
  }

  if (!isSpiderBossEncounterSelection(expectedSpecialBossSelection)) {
    const preparedMap = ensureSelectedSpecialBossFloorMap({
      map,
      selection: expectedSpecialBossSelection,
      playerPos,
      runSeed: runSeedRef.current,
    });

    const preferredSpawn = getSpecialBossFloorPlayerSpawn(expectedSpecialBossSelection);
    const isPlayerPosValidOnPreparedMap =
      Array.isArray(preparedMap) &&
      preparedMap.length > 0 &&
      Number.isFinite(playerPos?.x) &&
      Number.isFinite(playerPos?.y) &&
      !!preparedMap?.[playerPos.y]?.[playerPos.x] &&
      isWalkable(preparedMap[playerPos.y][playerPos.x]);

    if (preparedMap !== map) {
      setMap(preparedMap);
      if (preferredSpawn) {
        setExploredTiles(new Set([`${preferredSpawn.x},${preferredSpawn.y}`]));
      }
    }

    if (
      preferredSpawn &&
      (
        preparedMap !== map ||
        !isPlayerPosValidOnPreparedMap
      ) &&
      (preferredSpawn.x !== playerPos.x || preferredSpawn.y !== playerPos.y)
    ) {
      setPlayerPos(preferredSpawn);
      setExploredTiles(new Set([`${preferredSpawn.x},${preferredSpawn.y}`]));
    }

    if (spiderBossState.enabled) {
      setSpiderBossState(createDisabledSpiderBossState());
    }
    return;
  }

  const canRepairArena = !spiderBossState.bossSpawned && !spiderBossState.bossDefeated;
  const sanitizedMap = canRepairArena ? sanitizeSpiderBossFloorMap(map) : map;
  const mapWasRepaired = sanitizedMap !== map;

  let repairedPlayerPos = playerPos;
  if (mapWasRepaired && Array.isArray(sanitizedMap) && sanitizedMap.length > 0) {
    const width = sanitizedMap[0]?.length || 0;
    const height = sanitizedMap.length;
    repairedPlayerPos = {
      x: Math.min(Math.max(1, Math.floor(Number(playerPos?.x) || 1)), Math.max(1, width - 2)),
      y: Math.min(Math.max(1, Math.floor(Number(playerPos?.y) || 1)), Math.max(1, height - 2)),
    };

    setMap(sanitizedMap);
    setExploredTiles(new Set([`${repairedPlayerPos.x},${repairedPlayerPos.y}`]));

    if (repairedPlayerPos.x !== playerPos.x || repairedPlayerPos.y !== playerPos.y) {
      setPlayerPos(repairedPlayerPos);
    }
  }

  if (
    !mapWasRepaired &&
    spiderBossState.enabled &&
    spiderBossState.floor === floorLevel &&
    spiderBossState.webKeys instanceof Set &&
    spiderBossState.webKeys.size > 0
  ) {
    return;
  }

  setSpiderBossState(
    buildSpiderBossFloorState({
      map: sanitizedMap,
      floor: floorLevel,
      playerPos: repairedPlayerPos,
      runSeed: runSeedRef.current,
    })
  );
}, [
  currentFloorMood,
  floorLevel,
  map,
  playerPos,
  runSeedRef,
  setCurrentFloorMood,
  setExploredTiles,
  setMap,
  setPlayerPos,
  setSpecialBossFloorSelection,
  specialBossFloorSelection,
  spiderBossState.bossDefeated,
  spiderBossState.bossSpawned,
  spiderBossState.enabled,
  spiderBossState.floor,
  spiderBossState.webKeys,
]);

useEffect(() => {
  if (!isMonsignorBossFloorActive) return;

  const initialLitBraziers = getSpecialBossFloorInitialLitBraziers(
    specialBossFloorSelection,
  );

  if (initialLitBraziers instanceof Set) {
    const needsLitSync =
      !(litBraziers instanceof Set) ||
      litBraziers.size !== initialLitBraziers.size ||
      [...initialLitBraziers].some((key) => !litBraziers.has(key));

    if (needsLitSync) {
      setLitBraziers(new Set(initialLitBraziers));
    }
  }

  if (!brazierQuestCompletionTriggered) {
    setBrazierQuestCompletionTriggered(true);
  }

  if (brazierCompletionBannerText) {
    setBrazierCompletionBannerText('');
  }
}, [
  brazierCompletionBannerText,
  brazierQuestCompletionTriggered,
  isMonsignorBossFloorActive,
  litBraziers,
  setLitBraziers,
  specialBossFloorSelection,
]);

useEffect(() => {
  if (!isSpiderBossFloorActive) return;
  if (!spiderBossState.enabled) return;
  if (spiderBossState.bossDefeated) return;

  const previousPos = previousSpiderBossPlayerPosRef.current;
  const moved =
    !previousPos ||
    previousPos.x !== playerPos.x ||
    previousPos.y !== playerPos.y;

  previousSpiderBossPlayerPosRef.current = playerPos;

  if (!moved) return;

const triggeredKeys = getTriggeredSpiderwebKeys(
  spiderBossState.webKeys,
  playerPos,
);

if (!triggeredKeys.length) return;

playSpiderwebShuffleSfx();

const alertWebKey = pickSpiderBossAlertWebKey(triggeredKeys, playerPos);

  if (!spiderBossState.bossSpawned) {
    const spawnPos = chooseSpiderBossSpawnPosition(map, playerPos);

    if (!spawnPos) {
      setSpiderBossState((prev) => ({
        ...prev,
        webShakeTicksByKey: bumpSpiderwebShakeTicks(
          prev.webShakeTicksByKey,
          triggeredKeys,
        ),
        bossAlertWebKey: alertWebKey,
      }));
      return;
    }

    const baseMap = Array.isArray(map) ? map.map((row) => row.slice()) : map;
    if (!Array.isArray(baseMap) || !baseMap[spawnPos.y]) return;

    const underTile = baseMap?.[spawnPos.y]?.[spawnPos.x] || 'floor';
    baseMap[spawnPos.y][spawnPos.x] = 'enemy-boss';

    const initiallyLockedOnPlayer = isPlayerWithinSpiderBossSight(spawnPos, playerPos);
    const initialTargetPos = initiallyLockedOnPlayer
      ? playerPos
      : parseCoordKey(alertWebKey);

    const firstStepResult = initialTargetPos
      ? moveSpiderBossOneStep({
          map: baseMap,
          bossPos: spawnPos,
          bossUnderTile: underTile,
          targetPos: initialTargetPos,
          playerPos,
        })
      : null;

    const nextMap =
      firstStepResult && Array.isArray(firstStepResult.map)
        ? firstStepResult.map
        : baseMap;
    const nextBossPos =
      firstStepResult && firstStepResult.moved && firstStepResult.bossPos
        ? firstStepResult.bossPos
        : spawnPos;
    const nextBossUnderTile =
      firstStepResult && firstStepResult.moved
        ? firstStepResult.bossUnderTile
        : underTile;
    const nextBossLockedOnPlayer =
      initiallyLockedOnPlayer ||
      isPlayerWithinSpiderBossSight(nextBossPos, playerPos);

    setMap(nextMap);

    setSpiderBossState((prev) => ({
      ...prev,
      webShakeTicksByKey: bumpSpiderwebShakeTicks(
        prev.webShakeTicksByKey,
        triggeredKeys,
      ),
      bossSpawned: true,
      bossPos: nextBossPos,
      bossUnderTile: nextBossUnderTile,
      bossAlertWebKey: alertWebKey,
      bossLockedOnPlayer: nextBossLockedOnPlayer,
      bossDefeated: false,
    }));
    return;
  }

  setSpiderBossState((prev) => ({
    ...prev,
    webShakeTicksByKey: bumpSpiderwebShakeTicks(
      prev.webShakeTicksByKey,
      triggeredKeys,
    ),
    bossAlertWebKey: prev.bossLockedOnPlayer ? prev.bossAlertWebKey : alertWebKey,
  }));
}, [
  isSpiderBossFloorActive,
  map,
  playerPos,
  spiderBossState.bossDefeated,
  spiderBossState.bossSpawned,
  spiderBossState.bossLockedOnPlayer,
  spiderBossState.enabled,
  spiderBossState.webKeys,
]);

  const [hoveredRelic, setHoveredRelic] = useState(null);
  const [mobileRelicInfo, setMobileRelicInfo] = useState(null);
  const [isBackpackOpen, setIsBackpackOpen] = useState(false);
const [potions, setPotions] = useState(
  () => initialFloorStateRef.current.potions
);
  const [isStatusOpen, setIsStatusOpen] = useState(false);
const [relics, setRelics] = useState(
  () => initialFloorStateRef.current.relicOffers
);
  const [tileVariations, setTileVariations] = useState({});

  const buildStoryRelicEffectCtx = React.useCallback(() => ({
    addPotions: (n) =>
      setPotions((p) => Math.max(0, Math.min(maxPotions, p + (Number(n) || 0)))),
    addSanity: (n) =>
      setSanity((s) => s + (Number(n) || 0)),
    addKeys: (n) =>
      setKeys((k) => Math.max(0, Math.min(maxKeys, k + (Number(n) || 0)))),
    addTorches: (n) =>
      setTorches((t) => Math.max(0, Math.min(maxTorches, t + (Number(n) || 0)))),
    addTeeth: (n) =>
      setTeeth((t) => Math.max(0, Math.min(maxTeeth, t + (Number(n) || 0)))),
    setNextCombatCost0: (n) =>
      setNextCombatCost0((v) => Math.max(v, Number(n) || 0)),
  }), [
    maxKeys,
    maxPotions,
    maxTeeth,
    maxTorches,
    setKeys,
    setNextCombatCost0,
    setPotions,
    setSanity,
    setTeeth,
    setTorches,
  ]);

  const grantStoryTrinketById = React.useCallback((rawRelicId) => {
    const relicId = String(rawRelicId || '').trim();
    if (!relicId) return null;

    const relic = relicsPool.find((r) => r?.id === relicId);
    if (!relic) return null;

    let gained = null;
    setOwnedRelics((prev) => {
      const owned = Array.isArray(prev) ? prev : [];
      if (owned.length >= trinketLimit) return owned;
      if (owned.some((r) => r?.id === relic.id)) return owned;
      gained = relic;
      return [...owned, relic];
    });

    if (gained) {
      gained.effect?.(buildStoryRelicEffectCtx());
    }

    return gained;
  }, [buildStoryRelicEffectCtx, trinketLimit]);

  const grantStoryRandomTrinket = React.useCallback(({ count = 1, pool = 'any' } = {}) => {
    const wanted = Math.max(0, Math.floor(Number(count) || 0));
    if (wanted <= 0) return [];

    const gained = [];
    setOwnedRelics((prev) => {
      const owned = Array.isArray(prev) ? prev : [];
      if (owned.length >= trinketLimit) return owned;

      const ownedIds = new Set(owned.map((r) => r?.id).filter(Boolean));
      const normalizedPool = String(pool || 'any').trim().toLowerCase();
      const baseEligible = relicsPool.filter((r) =>
        r &&
        r.id &&
        !ownedIds.has(r.id) &&
        !isRansackedChestExclusiveRelic(r)
      );

      let eligible = baseEligible;
      if (normalizedPool && normalizedPool !== 'any' && normalizedPool !== 'all') {
        const filtered = baseEligible.filter((r) => String(r?.rarity || 'common').toLowerCase() === normalizedPool);
        if (filtered.length > 0) eligible = filtered;
      }

      const shuffled = [...eligible];
      for (let i = shuffled.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
      }

      const remainingSlots = Math.max(0, trinketLimit - owned.length);
      const picks = shuffled.slice(0, Math.min(wanted, remainingSlots));
      gained.push(...picks);

      if (picks.length === 0) return owned;
      return [...owned, ...picks];
    });

    if (gained.length > 0) {
      const ctx = buildStoryRelicEffectCtx();
      gained.forEach((relic) => relic?.effect?.(ctx));
    }

    return gained;
  }, [buildStoryRelicEffectCtx, trinketLimit]);

  const grantStoryCardById = React.useCallback((rawCardId) => {
    const cardId = String(rawCardId || '').trim();
    if (!cardId) return null;

    const lib = Array.isArray(combatLibrary) ? combatLibrary : [];
    const card = lib.find((c) => c?.id === cardId);
    if (!card || card.kind === 'enemy' || card.acquisitionLocked) return null;

    setPlayerDeckIds((prev) => [...(Array.isArray(prev) ? prev : []), card.id]);
    return card.id;
  }, [combatLibrary]);

  const grantStoryRandomCard = React.useCallback(({ count = 1, pool = 'any' } = {}) => {
    const wanted = Math.max(0, Math.floor(Number(count) || 0));
    if (wanted <= 0) return [];

    const lib = Array.isArray(combatLibrary) ? combatLibrary : [];
    if (lib.length === 0) return [];

    const gained = [];
    setPlayerDeckIds((prev) => {
      const currentIds = Array.isArray(prev) ? [...prev] : [];
      const currentIdSet = new Set(currentIds);
      const normalizedPool = String(pool || 'any').trim().toLowerCase();

      const allEligible = lib.filter((c) => c && c.id && c.kind !== 'enemy' && !c.acquisitionLocked);
      const matchesPool = (card) => {
        if (!normalizedPool || normalizedPool === 'any' || normalizedPool === 'all') return true;

        const haystacks = [
          card?.kind,
          card?.cardType,
          card?.tag,
          card?.specialType,
          card?.subtitle,
          card?.deckKind,
        ]
          .map((value) => String(value || '').trim().toLowerCase())
          .filter(Boolean);

        return haystacks.some((value) => value === normalizedPool || value.includes(normalizedPool));
      };

      let eligible = allEligible.filter(matchesPool);
      if (eligible.length === 0) eligible = allEligible;

      let preferred = eligible.filter((card) => !currentIdSet.has(card.id));
      if (preferred.length === 0) preferred = eligible;

      const shuffled = [...preferred];
      for (let i = shuffled.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
      }

      const picks = shuffled.slice(0, wanted).map((card) => card.id).filter(Boolean);
      gained.push(...picks);
      return [...currentIds, ...picks];
    });

    return gained;
  }, [combatLibrary]);

  const startStoryCombatEncounter = React.useCallback((rawEncounterId, _difficulty, options = {}) => {
    const encounterId = String(rawEncounterId || '').trim();
    if (!encounterId) return null;

    const enemyDef = findEnemyDef(encounterId);
    if (!enemyDef?.id) {
      console.warn(`[story] Unknown encounter id: ${encounterId}`);
      return null;
    }

    const resumeStorylet = String(options?.resumeStorylet || '').trim();
    const resumeScene = String(options?.resumeScene || '').trim();

    setPendingStoryCombatResume(
      resumeStorylet
        ? {
            storyletId: resumeStorylet,
            sceneId: resumeScene,
          }
        : null
    );

    beginCombatTransition({
      x: Number(playerPos?.x) || 0,
      y: Number(playerPos?.y) || 0,
      floor: floorLevel,
      enemyId: enemyDef.id,
    });

    return enemyDef.id;
  }, [beginCombatTransition, floorLevel, playerPos]);

 const {
  isStorylineActive,
  activeStorylet,
  cardState,
  swipeDirection,
  storyDragX,
  setStoryDragX,
  isStoryStepFlipping,
  storyNextBg,
  startStoryline,
  openStoryletById,
  getActiveStep,
  advanceStoryTap,
  handleStorySwipe,
} = useStoryletFlow({
  playerPos,
  setMap,
 
  keys,
  teeth,
  potions,
  torches,

  maxKeys,
  maxTeeth,
  maxPotions,
  maxTorches,

  setSanity,
  setKeys,
  setTeeth,
  setPotions,
  setTorches,

  gainTrinketById: grantStoryTrinketById,
  gainRandomTrinket: grantStoryRandomTrinket,
  addCardToDeck: grantStoryCardById,
  gainRandomCard: grantStoryRandomCard,
  startCombatEncounter: startStoryCombatEncounter,
});

  const {
  playTorchIgniteAndLoop,
  playBrazierLitSfx,
  playPlayerStepSfx,
  playTrapCountdownStartSfx,
  playTrapActivateSfx,
  playChestOpenSfx,
  playChestUnlockingSfx,
  playDoorOpenSfx,
  playDoorUnlockingSfx,
  playLoreInspectSfx,
  playDoorBarredSfx,
  playStepsDownSfx,
  playSpiderwebShuffleSfx,
  secretWhisperTorchFlicker,
  sanityScreenFlicker,
  sanityDistortionSpike,
  sanityPeripheralShadow,
  sanityCollapseBurst,
  sanityHudGlitchBurst,
} = useDungeonAudio({
  bootReady,
  isCombatActive,
  isSpiderBossFloorActive,
  isMonsignorBossFloorActive,
  isSpecialBossFloorActive,
  suppressCombatMusic: isCombatActive && isSpecialBossFloorActive,
  isStorylineActive,
  turns,
  currentFloorTorchDuration,
  tarotNoTorchesNeeded,
  playerPos,
  secretEntrancePos,
  sanity,
  maxSp,
  sanityPct,
  madness,
  sanityTier,
});

useEffect(() => {
  if (!bootReady) return;
  if (spawnStepsDownPlayedRef.current) return;

  spawnStepsDownPlayedRef.current = true;

  if (typeof window !== 'undefined') {
    const now = Date.now();
    const lastPlayedAt = Number(window.__dd_lastSpawnStepsDownAt || 0);

    if (now - lastPlayedAt < 750) return;

    window.__dd_lastSpawnStepsDownAt = now;
  }

  playStepsDownSfx();
}, [bootReady, playStepsDownSfx]);



  // When the tarot Torchbearer (upright) card is active, the player does not
  // need to light torches; the dungeon remains fully lit. In this case we
  // override the normal torch progress calculation to always be fully lit.
  // Otherwise, torchProgress decays from 1 to 0 as turns increase relative
  // to MAX_TORCH_DURATION.
  const rawTorchProgress = tarotNoTorchesNeeded
  ? 1
  : Math.max(0, 1 - turns / currentFloorTorchDuration);
  const torchProgress = isBlackhandBossFloorActive
    ? Math.min(BLACKHAND_FIXED_ZOOM_TORCH_PROGRESS, rawTorchProgress)
    : rawTorchProgress;

  const isDark = torchProgress === 0;
  const lightLevel = Math.ceil(torchProgress * 4);
  const visionBonus = ownedRelics.reduce((acc, r) => acc + (r?.dungeon?.visionBonus || 0), 0);
  // Apply any tarot penalty to the light radius. The torchbearer (reversed)
  // card sets tarotLightRadiusPenalty to a positive number. Subtract this
  // penalty from the computed light radius while ensuring we never go below 1.
  const lightRadius = Math.max(1, lightLevel + visionBonus - (tarotLightRadiusPenalty || 0));

  const madnessOverlayOpacity = React.useMemo(() => {
    if (!Number.isFinite(sanityPct) || sanityPct > 0.32) return 0;

    const progress = Math.max(0, Math.min(1, (0.32 - sanityPct) / 0.32));
    return Math.max(0, Math.min(1, 0.01 + progress * 0.99));
  }, [sanityPct]);

  const sanityFx = React.useMemo(() => {
    const enabled = bootReady && !isCombatActive && !isStorylineActive;

    const tier1Progress = sanityTier >= 1 ? Math.min(1, Math.max(0, (madness - 0.25) / 0.75)) : 0;
    const tier2Progress = sanityTier >= 2 ? Math.min(1, Math.max(0, (madness - 0.50) / 0.50)) : 0;
    const tier3Progress = sanityTier >= 3 ? Math.min(1, Math.max(0, (madness - 0.75) / 0.25)) : 0;
    const hudGlitchProgress = enabled && sanityPct < hudGlitchPctThreshold
      ? Math.min(1, Math.max(0, (hudGlitchPctThreshold - sanityPct) / hudGlitchPctThreshold))
      : 0;

    const collapseActive = enabled && sanityPct <= 0;
    const collapseProgress = collapseActive ? 1 : 0;

    return {
      enabled,
      sanityPct,
      madness,
      tier: sanityTier,

      collapseActive,
      collapseProgress,
      collapseOverlay: collapseActive ? 1 : 0,
      collapseBoardJitter: collapseActive ? 1 : 0,
      collapseHudGlitch: collapseActive ? 1 : 0,
      collapseChroma: collapseActive ? 1 : 0,
      collapseDarkFlash: collapseActive ? 1 : 0,

      vignetteOpacity: enabled && sanityTier >= 1 ? 0.08 + tier1Progress * 0.28 : 0,
      vignettePulseOpacity: enabled && sanityTier >= 1 ? 0.05 + tier1Progress * 0.18 : 0,

      torchCorruption: enabled && sanityTier >= 2 ? 0.12 + tier2Progress * 0.68 : 0,
      boardDistortion: enabled && sanityTier >= 2 ? 0.15 + tier2Progress * 0.85 : 0,
      hudInstability: hudGlitchProgress > 0 ? 0.14 + hudGlitchProgress * 0.86 : 0,
      hudGlitchProgress,

      shadowHallucination: enabled && sanityTier >= 3 ? 0.25 + tier3Progress * 0.75 : 0,
      positionalSfx: enabled && sanityTier >= 3 ? 0.20 + tier3Progress * 0.80 : 0,

      torchProgress,
    };
  }, [
    bootReady,
    isCombatActive,
    isStorylineActive,
    sanityPct,
    madness,
    sanityTier,
    torchProgress,
    hudGlitchPctThreshold,
  ]);

  useEffect(() => {
    const clearGhostTimers = () => {
      if (ghostEnemyFlickerTimeoutRef.current) {
        clearTimeout(ghostEnemyFlickerTimeoutRef.current);
        ghostEnemyFlickerTimeoutRef.current = null;
      }
      if (ghostEnemyFlickerClearTimeoutRef.current) {
        clearTimeout(ghostEnemyFlickerClearTimeoutRef.current);
        ghostEnemyFlickerClearTimeoutRef.current = null;
      }
    };

    clearGhostTimers();

    const effectEnabled =
      bootReady &&
      !isCombatActive &&
      !isStorylineActive &&
      Number.isFinite(sanity) &&
      sanity < GHOST_ENEMY_SP_THRESHOLD &&
      Array.isArray(map) &&
      map.length > 0;

    if (!effectEnabled) {
      setGhostEnemyFlicker(null);
      return () => clearGhostTimers();
    }

    let cancelled = false;

    const scheduleNextGhost = () => {
      if (cancelled) return;

      const shadowHallucination = Number(sanityFx?.shadowHallucination || 0);
      const torchInstability = 1 - Math.max(0, Math.min(1, Number(torchProgress) || 0));
      const cadenceBoost = 1 + shadowHallucination * 1.15 + torchInstability * 0.55;

      const delayMs = Math.max(1400, Math.round((2600 + Math.random() * 3600) / cadenceBoost));

      ghostEnemyFlickerTimeoutRef.current = window.setTimeout(() => {
        if (cancelled) return;

        const eligibleTiles = [];

        for (let y = 0; y < map.length; y += 1) {
          const row = map[y];
          if (!Array.isArray(row)) continue;

          for (let x = 0; x < row.length; x += 1) {
            const tile = row[x];
            const tileKey = `${x},${y}`;

            if (!visibleTiles.has(tileKey)) continue;
            if (x === playerPos.x && y === playerPos.y) continue;

            const dist = Math.hypot(x - playerPos.x, y - playerPos.y);
            if (dist <= 0.9 || dist > Math.max(1, lightRadius)) continue;

            if (tile !== 'floor' && tile !== 'corridor' && tile !== 'trap') continue;

            eligibleTiles.push({ x, y, dist });
          }
        }

        if (eligibleTiles.length === 0) {
          setGhostEnemyFlicker(null);
          scheduleNextGhost();
          return;
        }

        const preferredTiles = eligibleTiles.filter(({ dist }) => dist >= Math.max(1.15, lightRadius * 0.45));
        const pool = preferredTiles.length > 0 ? preferredTiles : eligibleTiles;
        const pickedTile = pool[Math.floor(Math.random() * pool.length)];

        const enemyPool = [
          'cultist',
          'cultist',
          'hexbinder',
          'dreadbrand',
          CORRUPTED_SPECIAL_ENEMY_ID,
        ];

        const durationMs = Math.round(260 + Math.random() * 240 + shadowHallucination * 140);
        const driftRange = 4 + shadowHallucination * 7 + torchInstability * 3;

        setGhostEnemyFlicker({
          id: `${Date.now()}-${Math.round(Math.random() * 100000)}`,
          x: pickedTile.x,
          y: pickedTile.y,
          enemyId: enemyPool[Math.floor(Math.random() * enemyPool.length)],
          opacity: Number((0.44 + Math.random() * 0.2 + shadowHallucination * 0.16).toFixed(3)),
          scale: Number((0.96 + Math.random() * 0.08).toFixed(3)),
          blurPx: Number((0.12 + Math.random() * 0.55 + shadowHallucination * 0.45).toFixed(2)),
          shiftX: Number((((Math.random() - 0.5) * driftRange) * 1.1).toFixed(2)),
          shiftY: Number(((-4 - Math.random() * (6 + driftRange * 0.45))).toFixed(2)),
          echoX: Number((((Math.random() - 0.5) * (5 + shadowHallucination * 8))).toFixed(2)),
          echoY: Number((((Math.random() - 0.5) * (3 + shadowHallucination * 6))).toFixed(2)),
          glowOpacity: Number((0.2 + Math.random() * 0.18 + shadowHallucination * 0.14).toFixed(3)),
          durationMs,
        });

        ghostEnemyFlickerClearTimeoutRef.current = window.setTimeout(() => {
          if (cancelled) return;
          setGhostEnemyFlicker(null);
          scheduleNextGhost();
        }, durationMs);
      }, delayMs);
    };

    scheduleNextGhost();

    return () => {
      cancelled = true;
      clearGhostTimers();
    };
  }, [
    bootReady,
    isCombatActive,
    isStorylineActive,
    map,
    playerPos,
    visibleTiles,
    lightRadius,
    torchProgress,
    sanity,
    sanityFx?.shadowHallucination,
  ]);


  // Yahaka can only spawn once per floor. We intentionally do not re-arm
  // the spawn after sanity is recovered on the same floor.

  useEffect(() => {
    const canSpawn =
      bootReady &&
      !isCombatActive &&
      !isPreCombatTransitionActive &&
      !isStorylineActive &&
      Array.isArray(map) &&
      map.length > 0 &&
      sanity <= 0 &&
      yahakaDefeatCount < 7 &&
      yahakaSpawnArmed &&
      !yahakaState?.active;

    if (!canSpawn) return;

    const spawnPos = findYahakaSpawnPosition(map, playerPos);
    if (!spawnPos) return;

    setMap((prev) => {
      if (!Array.isArray(prev) || !prev[spawnPos.y]) return prev;
      const tile = prev[spawnPos.y][spawnPos.x];
      if (!isYahakaWalkableTile(tile)) return prev;

      const next = prev.map((row) => row.slice());
      next[spawnPos.y][spawnPos.x] = 'enemy';
      return next;
    });

    setYahakaState({
      active: true,
      x: spawnPos.x,
      y: spawnPos.y,
    });
    setYahakaSpawnArmed(false);
    setYahakaBannerText(pickYahakaBannerLine());
  }, [
    bootReady,
    isCombatActive,
    isPreCombatTransitionActive,
    isStorylineActive,
    map,
    playerPos,
    sanity,
    yahakaDefeatCount,
    yahakaSpawnArmed,
    yahakaState?.active,
  ]);

  const yahakaMoveActionCountRef = useRef(floorActionCount);

  useEffect(() => {
    const previousActionCount = yahakaMoveActionCountRef.current;
    yahakaMoveActionCountRef.current = floorActionCount;

    if (floorActionCount <= previousActionCount) return;
    if (!yahakaState?.active) return;
    if (isCombatActive || isPreCombatTransitionActive || isStorylineActive) return;
    if (!Array.isArray(map) || !map.length) return;

    const currentPos = { x: yahakaState.x, y: yahakaState.y };
    const nextStep = findYahakaNextStep(map, currentPos, playerPos);
    if (!nextStep) return;

    if (nextStep.x === playerPos.x && nextStep.y === playerPos.y) {
      beginCombatTransition({
        x: currentPos.x,
        y: currentPos.y,
        floor: floorLevel,
        enemyId: activeYahakaEnemyId,
      });
      return;
    }

    setMap((prev) => {
      if (!Array.isArray(prev) || !prev[currentPos.y] || !prev[nextStep.y]) return prev;
      if (prev[currentPos.y][currentPos.x] !== 'enemy') return prev;
      if (!isYahakaWalkableTile(prev[nextStep.y][nextStep.x])) return prev;

      const next = prev.map((row) => row.slice());
      next[currentPos.y][currentPos.x] = 'floor';
      next[nextStep.y][nextStep.x] = 'enemy';
      return next;
    });

    setYahakaState((prev) => {
      if (!prev?.active || prev.x !== currentPos.x || prev.y !== currentPos.y) return prev;
      return {
        ...prev,
        x: nextStep.x,
        y: nextStep.y,
      };
    });
  }, [
    beginCombatTransition,
    floorActionCount,
    floorLevel,
    activeYahakaEnemyId,
    isCombatActive,
    isPreCombatTransitionActive,
    isStorylineActive,
    map,
    playerPos,
    yahakaState,
  ]);

  // Brazier radius guide visibility (contextual)
  const torchTurnsRemaining = tarotNoTorchesNeeded
  ? Number.POSITIVE_INFINITY
  : Math.max(0, currentFloorTorchDuration - turns);

  const showBrazierRadiusGuide =
    BRAZIER_RADIUS_GUIDE_ENABLED &&
    BRAZIER_LIGHTING_ENABLED &&
    !isCombatActive &&
    !isStorylineActive &&
    (
      torchProgress === 0 ||
      torchTurnsRemaining <= BRAZIER_RADIUS_GUIDE_NEAR_DANGER_TURNS
    );

  // Precompute per-tile guide intensity (0..1) for all lit braziers.
  // Uses MANHATTAN distance to match the actual brazier safety radius.
  const brazierRadiusGuideByTile = React.useMemo(() => {
    const out = Object.create(null);

    if (!BRAZIER_RADIUS_GUIDE_ENABLED) return out;
    if (!BRAZIER_LIGHTING_ENABLED) return out;
    if (!Array.isArray(map) || mapHeight <= 0 || mapWidth <= 0) return out;
    if (!litBraziers || litBraziers.size === 0) return out;

    const radius = Math.max(0, BRAZIER_LIGHT_RADIUS);
    if (radius <= 0) return out;

    for (const { x: bx, y: by } of litBrazierCoords) {
      for (let dy = -radius; dy <= radius; dy++) {
        const y = by + dy;
        if (y < 0 || y >= mapHeight) continue;

        const dxMax = radius - Math.abs(dy);
        for (let dx = -dxMax; dx <= dxMax; dx++) {
          const x = bx + dx;
          if (x < 0 || x >= mapWidth) continue;

          const d = Math.abs(dx) + Math.abs(dy);
          // Soft falloff so the edge fades instead of hard-cutting visually
          const t = Math.max(0, 1 - (d / (radius + 0.75)));
          if (t <= 0) continue;

          const k = `${x},${y}`;
          if (!out[k] || t > out[k]) out[k] = t; // overlap => keep strongest
        }
      }
    }

    return out;
  }, [litBrazierCoords, mapWidth, mapHeight]);

  // Mobile needs a slightly wider view so the board isn't cramped.
  const maxZoom = isMobile ? 3.4 : 4.5;
  const minZoom = isMobile ? 0.75 : 0.9;
  const explorationZoomTorchProgress = torchProgress;
  const baseScaleFactor = maxZoom - (Math.pow(explorationZoomTorchProgress, 0.35) * (maxZoom - minZoom));
  const scaleFactor = isStorylineActive ? maxZoom : baseScaleFactor;

  // DOM layout zoom for exploration (sharper than scaling the whole board layer)
  const useLayoutBoardZoom = !isCombatActive && !isStorylineActive;
  const effectiveExplorationScaleFactor = (
    useLayoutBoardZoom && layoutZoomTweenScale != null
      ? layoutZoomTweenScale
      : scaleFactor
  );
  const boardLayoutZoom = useLayoutBoardZoom ? effectiveExplorationScaleFactor : 1;
  const renderTileWidth = TILE_WIDTH * boardLayoutZoom;
  const renderTileHeight = TILE_HEIGHT * boardLayoutZoom;
  const renderTileMargin = TILE_MARGIN * boardLayoutZoom;
  const renderTileHalfMargin = renderTileMargin / 2;
  const renderTileRadiusPx = Math.max(6, 6 * boardLayoutZoom);
  const renderTileRadius = `${renderTileRadiusPx}px`;
  const boardSpanX = renderTileWidth + renderTileMargin;
  const boardSpanY = renderTileHeight + renderTileMargin;

// --------------------------------------------------
// --------------------------------------------------
// Ambient props: random placement OUTSIDE the board only (stable per floor)
// This guarantees they never cover any tiles/cards.
// --------------------------------------------------
useEffect(() => {
  if (!Array.isArray(map) || map.length === 0 || !Array.isArray(map[0])) {
    setAmbientProps([]);
    return;
  }

  const H = map.length;
  const W = map[0].length;

  if (!AMBIENT_PROP_POOL?.length) {
    setAmbientProps([]);
    return;
  }

  // Stable RNG per floor (within a run)
  const rng = makeSeededRand(
    ((runSeedRef.current ^ (floorLevel * 0x9e3779b9) ^ 0xA17B1E5) >>> 0)
  );

  // --- knobs ---
  const PAD_TILES = 1;      // how far outside the board we allow props (in tiles)
  const MIN_DIST_TILES = 2;  // keep props separated (in tile-units)

  // Outside candidates = ring around the map bounds (ONLY out-of-bounds cells)
  const outside = [];
  for (let y = -PAD_TILES; y < H + PAD_TILES; y++) {
    for (let x = -PAD_TILES; x < W + PAD_TILES; x++) {
      const inBounds = (x >= 0 && x < W && y >= 0 && y < H);
      if (inBounds) continue;
      outside.push({ x, y });
    }
  }

  const usedCenters = [];
  const farEnough = (cx, cy) =>
    usedCenters.every((p) => Math.hypot(cx - p.cx, cy - p.cy) >= MIN_DIST_TILES);

  const pickFrom = (arr) =>
    arr.length ? arr[Math.floor(rng() * arr.length)] : null;

  const pickSpot = () => {
    for (let attempt = 0; attempt < 400; attempt++) {
      const cand = pickFrom(outside);
      if (!cand) return null;

      // center in tile-units (x+0.5, y+0.5) plus subtle sub-tile jitter
      const jitterX = (rng() - 0.5) * 0.8;
      const jitterY = (rng() - 0.5) * 0.8;

      const cx = cand.x + 0.5 + jitterX;
      const cy = cand.y + 0.5 + jitterY;

      if (farEnough(cx, cy)) return { cx, cy };
    }
    return null;
  };

  const placed = AMBIENT_PROP_POOL.map((prop) => {
    const spot =
      pickSpot() ||
      // fallback: somewhere to the right if we got unlucky
      { cx: (W + 1) + rng() * PAD_TILES, cy: rng() * H };

    usedCenters.push(spot);

    return {
      ...prop,
      cx: spot.cx, // tile-units (always outside bounds now)
      cy: spot.cy,
    };
  });

  setAmbientProps(placed);
}, [map, floorLevel]);
  
useEffect(() => {
  if (!Array.isArray(map) || map.length === 0 || !Array.isArray(map[0])) {
    setUnderProps([]);
    return;
  }

  const H = map.length;
  const W = map[0].length;

  if (!UNDER_PROP_POOL?.length) {
    setUnderProps([]);
    return;
  }

  const rng = makeSeededRand(
    ((runSeedRef.current ^ (floorLevel * 0x9e3779b9) ^ 0x4c51a7f3) >>> 0)
  );

  // Tweak these freely
  const COUNT = Math.max(8, Math.min(22, Math.floor((W * H) / 50)));
  const EDGE_PAD_TILES = 0.35;
  const MIN_DIST_TILES = 1.8;

  const usedCenters = [];

  const farEnough = (cx, cy) =>
    usedCenters.every((p) => Math.hypot(cx - p.cx, cy - p.cy) >= MIN_DIST_TILES);

  const pickPoolItem = () =>
    UNDER_PROP_POOL[Math.floor(rng() * UNDER_PROP_POOL.length)];

  const placed = [];

  for (let i = 0; i < COUNT; i++) {
    let chosen = null;

    for (let attempt = 0; attempt < 300; attempt++) {
      const cx =
        EDGE_PAD_TILES + (rng() * Math.max(0.01, (W - EDGE_PAD_TILES * 2)));
      const cy =
        EDGE_PAD_TILES + (rng() * Math.max(0.01, (H - EDGE_PAD_TILES * 2)));

      if (!farEnough(cx, cy)) continue;

      chosen = { cx, cy };
      break;
    }

    if (!chosen) {
      chosen = {
        cx: EDGE_PAD_TILES + (rng() * Math.max(0.01, (W - EDGE_PAD_TILES * 2))),
        cy: EDGE_PAD_TILES + (rng() * Math.max(0.01, (H - EDGE_PAD_TILES * 2))),
      };
    }

    usedCenters.push(chosen);

    const picked = pickPoolItem();
    const scaleJitter = 0.9 + (rng() * 0.3);
    const rotateDeg = -12 + (rng() * 24);

    placed.push({
      ...picked,
      id: `${picked.id}-${i}`,
      cx: chosen.cx,
      cy: chosen.cy,
      scale: scaleJitter,
      rotateDeg,
      opacity: 0.95,
    });
  }

  setUnderProps(placed);
}, [map, floorLevel]);


  // In exploration we use layout zoom for sharpness, but during torch relight we add a
  // temporary transform-only scale tween to avoid layout/culling jitter.
  const boardMotionScale = isPreCombatTransitionActive
    ? PRE_COMBAT_ZOOM_MULTIPLIER
    : useLayoutBoardZoom
      ? (isTorchCameraRecenterAnimating ? torchCameraVisualScaleMultiplier : 1)
      : scaleFactor;

   // ------------------------------------------------------------
  // Exploration board perspective (visual only; disabled during combat)
  // ------------------------------------------------------------
  const useBoardPerspective = !isCombatActive;
  const boardPerspectiveTiltDeg = isMobile ? 26 : 42;

const zoomTarget = isPreCombatTransitionActive && preCombatZoomTarget
  ? preCombatZoomTarget
  : playerPos;
const viewW = viewportSize.w || (typeof window !== 'undefined' ? window.innerWidth : 0);
const viewH = viewportSize.h || (typeof window !== 'undefined' ? window.innerHeight : 0);
const zx = Number.isFinite(zoomTarget?.x) ? zoomTarget.x : (Number.isFinite(playerPos?.x) ? playerPos.x : 0);
const zy = Number.isFinite(zoomTarget?.y) ? zoomTarget.y : (Number.isFinite(playerPos?.y) ? playerPos.y : 0);
const rawOffsetX0 = (viewW / 2) - ((zx + 0.5) * boardSpanX * boardMotionScale);
const rawOffsetY0 = (viewH / 2) - ((zy + 0.5) * boardSpanY * boardMotionScale);
const rawOffsetX = Number.isFinite(rawOffsetX0) ? rawOffsetX0 : 0;
const rawOffsetY = Number.isFinite(rawOffsetY0) ? rawOffsetY0 : 0;
const offsetX = (useLayoutBoardZoom && !isTorchCameraRecenterAnimating) ? Math.round(rawOffsetX) : rawOffsetX;
const offsetY = (useLayoutBoardZoom && !isTorchCameraRecenterAnimating) ? Math.round(rawOffsetY) : rawOffsetY;

  const boardCameraTransition = React.useMemo(() => {
    if (isPreCombatTransitionActive) {
      return {
        duration: PRE_COMBAT_TRANSITION_MS / 1000,
        ease: BOARD_CAMERA_EASE_PRECOMBAT,
      };
    }
    return useLayoutBoardZoom
      ? BOARD_CAMERA_TRANSITION_LAYOUT
      : BOARD_CAMERA_TRANSITION_SPRING;
  }, [isPreCombatTransitionActive, useLayoutBoardZoom]);

  const boardPerspectiveStageStyle = React.useMemo(() => {
    if (!useBoardPerspective) return BOARD_STAGE_STYLE_BASE;
    return {
      ...BOARD_STAGE_STYLE_BASE,
      perspective: isMobile ? '1200px' : '1600px',
      perspectiveOrigin: '50% 50%',
    };
  }, [useBoardPerspective, isMobile]);

  const boardPerspectiveViewportStyle = React.useMemo(() => {
    return {
      ...BOARD_VIEWPORT_STYLE_BASE,
      transform: useBoardPerspective
        ? `rotateX(${boardPerspectiveTiltDeg}deg)`
        : 'none',
    };
  }, [useBoardPerspective, boardPerspectiveTiltDeg]);

  const boardPixelWidth = mapWidth * boardSpanX;
  const boardPixelHeight = mapHeight * boardSpanY;

const ambientPropRenders = React.useMemo(() => {
  if (!Array.isArray(ambientProps) || ambientProps.length === 0) return [];

  // Scale with layout zoom so props grow/shrink with the board in exploration.
  const z = boardLayoutZoom || 1;

  // Board bounds in the same coordinate system as left/top
  const boardPixelWidth = mapWidth * boardSpanX;
  const boardPixelHeight = mapHeight * boardSpanY;

  // Safety moat (in pixels) — smaller = props hug the board more
const MOAT_TILES = 0.10; // try 0.10–0.25. Use 0 for “touching the edge”
const moatX = boardSpanX * MOAT_TILES;
const moatY = boardSpanY * MOAT_TILES;

  return ambientProps.map((p) => {
    const baseW = p.w ?? 260;
    const baseH = p.h ?? 260;
    const baseScale = p.scale ?? 1;

    const w = baseW * z * baseScale;
    const h = baseH * z * baseScale;

    const xOffset = (p.xOffsetPx ?? 0) * z;
    const yOffset = (p.yOffsetPx ?? 0) * z;

    // cx/cy are in tile-units (0.5 = center of tile 0, can be negative/outside)
    const cx = Number.isFinite(p.cx) ? p.cx : (mapWidth / 2);
    const cy = Number.isFinite(p.cy) ? p.cy : (mapHeight / 2);

    // Raw placement
    let left = (cx * boardSpanX) - (w / 2) + xOffset;
    let top  = (cy * boardSpanY) - (h / 2) + yOffset;

    // ✅ If the prop is OUTSIDE the map, enforce a 1-tile moat so it cannot overlap walkable tiles.
    // (This does not change inside-board props; those must be made safe at spawn-time.)
    const outsideLeft = cx < 0;
    const outsideRight = cx > mapWidth;
    const outsideTop = cy < 0;
    const outsideBottom = cy > mapHeight;

    if (outsideLeft) {
      // keep fully left of the board, with 1 tile gap
      left = Math.min(left, -moatX - w);
    }
    if (outsideRight) {
      // keep fully right of the board, with 1 tile gap
      left = Math.max(left, boardPixelWidth + moatX);
    }
    if (outsideTop) {
      // keep fully above the board, with 1 tile gap
      top = Math.min(top, -moatY - h);
    }
    if (outsideBottom) {
      // keep fully below the board, with 1 tile gap
      top = Math.max(top, boardPixelHeight + moatY);
    }

    return {
      id: p.id,
      src: p.src,
      left,
      top,
      w,
      h,
    };
  });
}, [ambientProps, boardLayoutZoom, boardSpanX, boardSpanY, mapWidth, mapHeight]);

  const boardPerspectiveBoardStyle = React.useMemo(() => ({
    position: 'relative',
    width: boardPixelWidth,
    height: boardPixelHeight,
    transform: 'none',
    transformOrigin: 'top left',
    transformStyle: 'preserve-3d',
    backfaceVisibility: 'hidden',
    isolation: 'isolate',
  }), [boardPixelWidth, boardPixelHeight]);

  // ------------------------------------------------------------
  // Tile viewport culling
  // ------------------------------------------------------------
  // We keep the layout identical (full grid width/height are preserved), but we only mount
  // actual tile components for rows/columns that can be seen.
  const tileViewport = React.useMemo(() => {
    const spanX = boardSpanX;
    const spanY = boardSpanY;
    const rowW = mapWidth * spanX;
    const rowH = spanY;

    const fallback = {
      enabled: false,
      xStart: 0,
      xEnd: Math.max(0, mapWidth - 1),
      yStart: 0,
      yEnd: Math.max(0, mapHeight - 1),
      leftPad: 0,
      rightPad: 0,
      rowW,
      rowH,
    };

    // Render budget: only mount tiles within the player's current light radius
    // plus a small buffer ("+2") so movement doesn't cause popping.
    // NOTE: We still intersect this with the actual screen viewport (below), so we
    // don't render unseen tiles even if they are within the light radius.
    const lightCullRadius = Math.max(1, Math.floor((lightRadius || 1) + 2));

    const isYahakaOutsideViewport =
      !!yahakaState?.active &&
      Math.hypot((yahakaState.x ?? playerPos.x) - playerPos.x, (yahakaState.y ?? playerPos.y) - playerPos.y) > lightCullRadius;

    // During cinematic states we keep full rendering to avoid any edge-case pop.
    // Also disable viewport culling while Yahaka is active outside the normal tile mount radius,
    // otherwise the board never mounts the tile that needs to render its ghost form.
    const disable = isCombatActive || isStorylineActive || isPreCombatTransitionActive || isTorchCameraRecenterAnimating || isYahakaOutsideViewport;

    // Don't bother when the map is small (it just adds overhead).
    const enabled =
      !disable &&
      mapWidth > 0 &&
      mapHeight > 0 &&
      mapWidth * mapHeight > 200 &&
      viewportSize.w > 0 &&
      viewportSize.h > 0;

    if (!enabled) return fallback;

    const centerX = Number.isFinite(zoomTarget?.x) ? zoomTarget.x : playerPos.x;
    const centerY = Number.isFinite(zoomTarget?.y) ? zoomTarget.y : playerPos.y;

    if (
      !Number.isFinite(spanX) || spanX <= 0 ||
      !Number.isFinite(spanY) || spanY <= 0 ||
      !Number.isFinite(boardMotionScale) || boardMotionScale <= 0 ||
      !Number.isFinite(viewportSize.w) || viewportSize.w <= 0 ||
      !Number.isFinite(viewportSize.h) || viewportSize.h <= 0 ||
      !Number.isFinite(centerX) ||
      !Number.isFinite(centerY)
    ) {
      return fallback;
    }

    const overscan = isMobile ? 4 : 3;
    const tilePxX = spanX * boardMotionScale;
    const tilePxY = spanY * boardMotionScale;

    if (!Number.isFinite(tilePxX) || tilePxX <= 0 || !Number.isFinite(tilePxY) || tilePxY <= 0) {
      return fallback;
    }

    // "Camera" span derived from the real viewport, but clamped so we never mount
    // more tiles than the light radius + 2 buffer.
    const halfXRaw = Math.ceil((viewportSize.w / 2) / tilePxX) + overscan;
    const halfYRaw = Math.ceil((viewportSize.h / 2) / tilePxY) + overscan;

    if (!Number.isFinite(halfXRaw) || !Number.isFinite(halfYRaw)) {
      return fallback;
    }

    const halfX = Math.min(halfXRaw, lightCullRadius);
    const halfY = Math.min(halfYRaw, lightCullRadius);

    const xStart = Math.max(0, Math.floor(centerX - halfX));
    const xEnd = Math.min(mapWidth - 1, Math.ceil(centerX + halfX));
    const yStart = Math.max(0, Math.floor(centerY - halfY));
    const yEnd = Math.min(mapHeight - 1, Math.ceil(centerY + halfY));

    if (![xStart, xEnd, yStart, yEnd].every(Number.isFinite) || xStart > xEnd || yStart > yEnd) {
      return fallback;
    }

    const leftPad = xStart * spanX;
    const rightPad = Math.max(0, (mapWidth - xEnd - 1)) * spanX;

    return { enabled: true, xStart, xEnd, yStart, yEnd, leftPad, rightPad, rowW, rowH };
  }, [
    isCombatActive,
    isStorylineActive,
    isPreCombatTransitionActive,
    isTorchCameraRecenterAnimating,
    mapWidth,
    mapHeight,
    viewportSize.w,
    viewportSize.h,
    boardSpanX,
    boardSpanY,
    boardMotionScale,
    isMobile,
    zoomTarget?.x,
    zoomTarget?.y,
    playerPos.x,
    playerPos.y,
    lightRadius,
    yahakaState?.active,
    yahakaState?.x,
    yahakaState?.y,
  ]);

  const restingOnTile = map[playerPos.y][playerPos.x] === 'rest';
  
  const FLOOR_CLEANSING_MIN_DECK_SIZE = 16;

const deckCullCards = Array.isArray(deckCards) ? deckCards : [];
const deckCullPhysCount = deckCullCards.filter((c) => c?.kind === 'physical').length;
const deckCullMagCount = deckCullCards.filter((c) => c?.kind === 'magic').length;
const deckCullAtMinDeck = deckCullCards.length <= FLOOR_CLEANSING_MIN_DECK_SIZE;

const getDeckCullBlockReason = (card) => {
  if (!card) return 'Invalid card.';
  if (deckCullAtMinDeck) {
    return `Deck is already at the minimum size (${FLOOR_CLEANSING_MIN_DECK_SIZE}).`;
  }
  if (card.kind === 'physical' && deckCullPhysCount <= 1) {
    return 'Cannot remove the last Physical card.';
  }
  if (card.kind === 'magic' && deckCullMagCount <= 1) {
    return 'Cannot remove the last Magic card.';
  }
  return '';
};

const claimFloorCleansingReward = (cardId) => {
  const chosen = deckCullCards.find((c) => c?.id === cardId);
  const blockReason = getDeckCullBlockReason(chosen);

  if (!chosen || blockReason) return;

  setPlayerDeckIds((ids) => {
    const next = Array.isArray(ids) ? [...ids] : [];
    const idx = next.indexOf(cardId);
    if (idx >= 0) next.splice(idx, 1);
    return next;
  });

  setPendingDeckCullReward(false);
};

  
  useEffect(() => {
    const currentVisible = new Set();
  
    // --- Visibility helpers ---
    // IMPORTANT:
    // We use a flood-fill FOV (Manhattan radius) that respects blockers.
    // This avoids diagonal "corner peeking" where Bresenham rays can miss
    // the door tile and accidentally reveal tiles behind it.
    const inBounds = (x, y) => x >= 0 && x < mapWidth && y >= 0 && y < mapHeight;

    // Closed/locked doors should block light and vision.
    // (The blocking tile itself can still be visible; we just don't propagate past it.)
    const isVisionBlocked = (x, y) => {
  const t = map?.[y]?.[x];
  return (
    t === 'door-locked' ||
    t === 'door-closed' ||
    t === 'non-walkable' ||
    t === 'secret-entrance'
  );
};

    const addFOV = (sx, sy, radius) => {
      if (!inBounds(sx, sy)) return;
      const q = [{ x: sx, y: sy, d: 0 }];
      const visited = new Set([`${sx},${sy}`]);

      while (q.length) {
        const { x, y, d } = q.shift();
        currentVisible.add(`${x},${y}`);
        if (d >= radius) continue;

        // If this tile blocks vision, do not propagate beyond it.
        // (But keep it visible, which we already did above.)
        if (!(x === sx && y === sy) && isVisionBlocked(x, y)) continue;

        const neighbors = [
          { x: x + 1, y },
          { x: x - 1, y },
          { x, y: y + 1 },
          { x, y: y - 1 }
        ];

        for (const n of neighbors) {
          if (!inBounds(n.x, n.y)) continue;
          const nd = d + 1;
          if (nd > radius) continue;
          const k = `${n.x},${n.y}`;
          if (visited.has(k)) continue;
          visited.add(k);
          q.push({ x: n.x, y: n.y, d: nd });
        }
      }
    };

    // Torch visibility
    if (torchProgress > 0) {
      addFOV(playerPos.x, playerPos.y, lightRadius);
    } else {
      currentVisible.add(`${playerPos.x},${playerPos.y}`);
    }
  
    // Brazier visibility (also respects closed/locked doors)
    if (BRAZIER_LIGHTING_ENABLED) {
      for (const { x, y } of litBrazierCoords) {
        addFOV(x, y, BRAZIER_LIGHT_RADIUS + visionBonus);
      }
    }
  
    if (tarotRevealMap) {
      for (let y = 0; y < mapHeight; y++) {
        for (let x = 0; x < mapWidth; x++) {
          currentVisible.add(`${x},${y}`);
        }
      }
    }

    setVisibleTiles(currentVisible);
    // NEW: remember everything we've ever revealed this floor
setExploredTiles((prev) => {
  const next = new Set(prev);
  currentVisible.forEach((k) => next.add(k));
  return next;
});

  }, [playerPos, lightRadius, torchProgress, map, visionBonus, litBrazierCoords, tarotRevealMap]);
  
    useEffect(() => {
    if (torchProgress === 0) {
      let isInBrazierLight = false;

      for (const { x, y } of litBrazierCoords) {
        const dx = Math.abs(x - playerPos.x);
        const dy = Math.abs(y - playerPos.y);
        if (dx + dy <= BRAZIER_LIGHT_RADIUS) {
          isInBrazierLight = true;
          break;
        }
      }

      if (!isInBrazierLight) {
        const darknessPenalty = turns - currentFloorTorchDuration + 1;
        if (darknessPenalty > 0) {
          if (sanity <= 0) {
            setHp((h) => Math.max(0, h - 1));
          } else {
            setSanity((s) => Math.max(0, s - darknessPenalty));
          }

          if (tarotDarknessDamage > 0) {
            setHp((h) => Math.max(0, h - tarotDarknessDamage));
          }
        }
      }
    }
  }, [turns, playerPos, map, torchProgress, litBrazierCoords, currentFloorTorchDuration, tarotDarknessDamage]);


useEffect(() => {
  if (!brazierCompletionBannerText) return;

  const t = setTimeout(() => {
    setBrazierCompletionBannerText('');
  }, 9000);

  return () => clearTimeout(t);
}, [brazierCompletionBannerText]);

useEffect(() => {
  if (!cleansingCompletionBannerText) return;

  const t = setTimeout(() => {
    setCleansingCompletionBannerText('');
  }, 9000);

  return () => clearTimeout(t);
}, [cleansingCompletionBannerText]);

useEffect(() => {
  if (!corruptionBannerText) return;

  const t = setTimeout(() => {
    setCorruptionBannerText('');
  }, 9000);

  return () => clearTimeout(t);
}, [corruptionBannerText]);

useEffect(() => {
  if (!blackhandTorchWarningText) return;

  const t = setTimeout(() => {
    setBlackhandTorchWarningText('');
  }, 3200);

  return () => clearTimeout(t);
}, [blackhandTorchWarningText]);

useEffect(() => {
  if (isBlackhandBossFloorActive) return;
  if (!blackhandTorchWarningText) return;
  setBlackhandTorchWarningText('');
}, [isBlackhandBossFloorActive, blackhandTorchWarningText]);

useEffect(() => {
  if (!yahakaBannerText) return;

  const t = setTimeout(() => {
    setYahakaBannerText('');
  }, 9000);

  return () => clearTimeout(t);
}, [yahakaBannerText]);

useEffect(() => {
  if (!loreBannerText) return;

  const t = setTimeout(() => {
    setLoreBannerText('');
  }, 9000);

  return () => clearTimeout(t);
}, [loreBannerText]);

useEffect(() => {
  // If brazier lighting is disabled, do nothing.
  if (!BRAZIER_LIGHTING_ENABLED) return;

  const total = Number(brazierProgress?.total || 0);
  const lit = Number(brazierProgress?.lit || 0);

  if (total <= 0) return;                 // no braziers on floor
  if (lit < total) return;                // not complete yet
  if (brazierQuestCompletionTriggered) return; // already triggered this floor

  // Mark completion (one-time)
  setBrazierQuestCompletionTriggered(true);

  // Random dramatic line
  setBrazierCompletionBannerText(pickBrazierCompletionLine());

  // Optional reward: reveal whole floor (fog memory)
  setExploredTiles(() => {
    const all = new Set();
    for (let y = 0; y < mapHeight; y++) {
      for (let x = 0; x < mapWidth; x++) {
        all.add(`${x},${y}`);
      }
    }
    return all;
  });
}, [
  mapHeight,
  mapWidth,
  brazierProgress,
  brazierQuestCompletionTriggered,
]);

useEffect(() => {
  const total = Number(floorCleansingProgress?.total || 0);
  const slain = Number(floorCleansingProgress?.slain || 0);

  if (total <= 0) return; // no enemies on floor
  if (slain < total) return; // not complete yet
  if (cleansingQuestCompletionTriggered) return; // already triggered this floor

  // Mark completion (one-time)
  setCleansingQuestCompletionTriggered(true);

  // Random dramatic line
  setCleansingCompletionBannerText(pickCleansingCompletionLine());

  // Reward: allow one deck cull for cleansing the whole floor
  setPendingDeckCullReward(true);
}, [
  floorCleansingProgress,
  cleansingQuestCompletionTriggered,
]);

useEffect(() => {
  if (floorCorruption) return;
  if (!isCorruptedFloorActive) return;

  setFloorCorruption(
    buildInitialCorruptionState({
      map,
      floor: floorLevel,
      runSeed: runSeedRef.current,
      spawn: playerPos,
      config: currentFloorCorruptionConfig,
    })
  );
}, [floorCorruption, isCorruptedFloorActive, currentFloorCorruptionConfig, map, floorLevel, playerPos]);

useEffect(() => {
  if (!isCorruptedFloorActive) return;
  if (!floorCorruption?.enabled) return;

  const allEnemiesCleared =
    Number(floorCleansingProgress?.total || 0) > 0 &&
    Number(floorCleansingProgress?.slain || 0) >= Number(floorCleansingProgress?.total || 0);

  const allBraziersLit =
    Number(brazierProgress?.total || 0) > 0 &&
    Number(brazierProgress?.lit || 0) >= Number(brazierProgress?.total || 0);

  const { nextState, events } = advanceCorruptionState({
    corruptionState: floorCorruption,
    map,
    actionCount: floorActionCount,
    config: currentFloorCorruptionConfig,
    isTileLit: isTileLitForCorruption,
    allEnemiesCleared,
    allBraziersLit,
  });

  if (nextState !== floorCorruption) {
    setFloorCorruption(nextState);
  }

  if (events?.dominanceTriggered) {
    setCorruptionBannerText('Corruption dominates this floor.');

    const dominanceTorch = Math.max(
      1,
      Math.floor(Number(currentFloorCorruptionConfig?.dominanceTorchDuration || 48))
    );

    setCurrentFloorTorchDuration((prev) => {
      if (prev <= dominanceTorch) return prev;
      return dominanceTorch;
    });

    setTurns((prev) => Math.min(prev, dominanceTorch));
  }

if (events?.spawnedSpecialEnemyKey) {
  const { x, y } = parseTileKey(events.spawnedSpecialEnemyKey);

  setMap((prev) => {
    if (!Array.isArray(prev) || !prev[y]) return prev;

    const baseTile = prev[y][x];
    if (baseTile !== 'floor' && baseTile !== 'corridor') return prev;

    const next = prev.map((row) => row.slice());
    next[y][x] = 'enemy';
    return next;
  });
}
  if (events?.collapseTriggered && nextState?.heartKey) {
    const heart = parseTileKey(nextState.heartKey);

    setMap((prev) => {
      const next = prev.map((row) => row.slice());

      const stepsPos = findStepsDownPos(next);
      if (stepsPos) {
        next[stepsPos.y][stepsPos.x] = 'floor';
      }

      if (next[heart.y]?.[heart.x] === 'floor' || next[heart.y]?.[heart.x] === 'corridor') {
        next[heart.y][heart.x] = 'enemy-boss';
      }

      return next;
    });

    setFloorCorruption((prev) => {
      if (!prev) return prev;
      return {
        ...prev,
        stepsHidden: true,
        stepsDownOriginalPos: prev.stepsDownOriginalPos || findStepsDownPos(map),
        bossSpawned: true,
      };
    });
  }
}, [
  isCorruptedFloorActive,
  floorCorruption,
  floorActionCount,
  map,
  currentFloorCorruptionConfig,
  brazierProgress,
  floorCleansingProgress,
  isTileLitForCorruption,
  findStepsDownPos,
]);

  useEffect(() => {
  const newVariations = {};

  const safeNormalTiles = normalFloorTiles.length
    ? normalFloorTiles
    : [{ img: FLOOR_TILESET_PROFILES.default.floorBaseImg, rotation: 0 }];

  const safeCorruptedTiles = corruptedFloorTiles.length
    ? corruptedFloorTiles
    : [{ img: FLOOR_TILESET_PROFILES.corrupted.floorBaseImg, rotation: 0 }];

  for (let y = 0; y < mapHeight; y++) {
    for (let x = 0; x < mapWidth; x++) {
      const key = `${x},${y}`;

      const containerRotation = ((hash01(x * 13 + 7, y * 17 + 3, floorSeed) * 2) - 1).toFixed(1);

      const normalIdx = Math.floor(
        hash01(x * 17 + 5, y * 31 + 11, floorSeed ^ 0x11111111) * safeNormalTiles.length
      );

      const corruptedIdx = Math.floor(
        hash01(x * 19 + 9, y * 29 + 15, floorSeed ^ 0x22222222) * safeCorruptedTiles.length
      );

      newVariations[key] = {
        containerRotation: parseFloat(containerRotation),
        rotation: 0,
        normalImg: safeNormalTiles[normalIdx]?.img || FLOOR_TILESET_PROFILES.default.floorBaseImg,
        corruptedImg: safeCorruptedTiles[corruptedIdx]?.img || FLOOR_TILESET_PROFILES.corrupted.floorBaseImg,
      };
    }
  }

  setTileVariations(newVariations);
}, [mapWidth, mapHeight, floorSeed, normalFloorTiles, corruptedFloorTiles]);

  // Aggregate combat modifiers are now provided by computeCombatMods in relicEffects.js.


  // Persist deck ids across refreshes using deferred storage queue.
  useEffect(() => {
    queueJsonStorageWrite('dd_player_deck_ids_v1', playerDeckIds);
  }, [playerDeckIds]);

  // Persist owned relic ids across refreshes using deferred storage queue.
  useEffect(() => {
    queueJsonStorageWrite(
      'dd_owned_relics_v1',
      ownedRelics.map((r) => r.id)
    );
  }, [ownedRelics]);

  // Persist exploration HP across refreshes using deferred storage queue.
  useEffect(() => {
    queueJsonStorageWrite('dd_player_hp_v1', hp);
  }, [hp]);

  // Persist exploration SP across refreshes using deferred storage queue.
  useEffect(() => {
    queueJsonStorageWrite('dd_player_sp_v1', sanity);
  }, [sanity]);

  useEffect(() => {
    writeSavedFloorLevel(floorLevel);
  }, [floorLevel]);

  useEffect(() => {
    writeSavedRunSeed(runSeedRef.current);
  }, []);

  useEffect(() => {
    writeRansackedChestSpawned(ransackedChestSpawnedRef.current);
  }, [floorLevel]);

  useEffect(() => {
    queueJsonStorageWrite('dd_shrine_maxhp_penalty_v1', shrineMaxHpPenalty);
  }, [shrineMaxHpPenalty]);

  useEffect(() => {
    queueJsonStorageWrite('dd_shrine_maxsp_penalty_v1', shrineMaxSpPenalty);
  }, [shrineMaxSpPenalty]);


const previousPerFloorChargesRef = useRef(getPerFloorCharges(ownedRelics));
const previousPerFloorChargeFloorRef = useRef(floorLevel);

// Refresh per-floor charges.
  useEffect(() => {
    // Compute per-floor charges via helper
    const { bypassEnemyCharges, freeChestCharges } = getPerFloorCharges(ownedRelics);
    const prevCharges = previousPerFloorChargesRef.current || { bypassEnemyCharges: 0, freeChestCharges: 0 };
    const floorChanged = previousPerFloorChargeFloorRef.current !== floorLevel;

    if (floorChanged) {
      setBypassEnemiesRemaining(bypassEnemyCharges);
      setFreeChestsRemaining(freeChestCharges);
      previousPerFloorChargeFloorRef.current = floorLevel;
    } else {
      const bypassDelta = bypassEnemyCharges - (prevCharges.bypassEnemyCharges || 0);
      const chestDelta = freeChestCharges - (prevCharges.freeChestCharges || 0);
      if (bypassDelta !== 0) {
        setBypassEnemiesRemaining((n) => Math.max(0, n + bypassDelta));
      }
      if (chestDelta !== 0) {
        setFreeChestsRemaining((n) => Math.max(0, n + chestDelta));
      }
    }

    previousPerFloorChargesRef.current = { bypassEnemyCharges, freeChestCharges };
  }, [floorLevel, ownedRelics]);

useEffect(() => {
  setTeeth((t) => Math.min(t, maxTeeth));
  setKeys((k) => Math.min(k, maxKeys));
  setPotions((p) => Math.min(p, maxPotions));
  setTorches((t) => Math.min(t, maxTorches));
}, [maxTeeth, maxKeys, maxPotions, maxTorches]);

useEffect(() => {
  setHp((h) => Math.min(h, maxHp));
  setSanity((s) => Math.min(s, maxSp));
}, [maxHp, maxSp]);

// If we just leveled up, refill AFTER the max caps have updated.
useEffect(() => {
  if (!pendingLevelUpRefillRef.current) return;
  pendingLevelUpRefillRef.current = false;

  setHp(maxHp);
  setSanity(maxSp);
}, [maxHp, maxSp]);

const {
  handleCombatVictory,
  handleCombatDefeat,
  triggerRest,
  usePotionFromBackpack,
} = useDungeonCombatFlow({
  combatEnemyTile,
  setCombatEnemyTile,
  map,
  setMap,
  floorCorruption,
  setFloorCorruption,
  setCorruptionBannerText,
  setYahakaState,
  setYahakaDefeatCount,
  setYahakaBannerText,
  spiderBossState,
  setSpiderBossState,
  setPendingCorruptionBonusReward,
  slainEnemiesThisFloor,
  setSlainEnemiesThisFloor,
  floorCleansingTotal: floorCleansingProgress.total,
  setPlayerDeckIds,
  setHp,
  setSanity,
  setTeeth,
  maxTeeth,
  setKeys,
  maxKeys,
  potions,
  setPotions,
  maxPotions,
  setTorches,
  maxTorches,
  hp,
  maxHp,
  maxSp,
  setIsCombatActive,
  setActiveCombatMods,
  preCombatPosRef,
  setPlayerPos,
  awardCombatVictoryXp,
  tarotNoExp,
  tarotChainExpBonus,
  floorLevel,
  runSeedRef,
  restingOnTile,
  ownedRelics,
  setRelics,
  yahakaDefeatCount,
  pickYahakaVictoryBannerLine,
  setNextCombatCost0,
  setTurns,
  currentFloorTorchDuration,
  setFloorActionCount,
  setPulse,
});

const handleCombatVictoryWithStoryResume = React.useCallback((rewardCard, nextDeckIds, finalStats, finalLoot) => {
  handleCombatVictory(rewardCard, nextDeckIds, finalStats, finalLoot);

  const resume = pendingStoryCombatResume;
  setPendingStoryCombatResume(null);

  if (!resume?.storyletId) return;

  window.setTimeout(() => {
    openStoryletById(resume.storyletId, resume.sceneId);
  }, 0);
}, [handleCombatVictory, openStoryletById, pendingStoryCombatResume]);

const handleCombatDefeatWithStoryResume = React.useCallback((finalStats) => {
  setPendingStoryCombatResume(null);
  handleCombatDefeat(finalStats);
}, [handleCombatDefeat]);
  
  const currentFloorSize = map?.length || getMapSizeForFloor(floorLevel);

  const {
  isMerchantOpen,
  setIsMerchantOpen,
  merchantStock,
  setMerchantStock,
  activeMerchantStock,
  setActiveMerchantKey,
  getMerchantPrices,
  onBuyCard: handleBuyMerchantCard,
  onBuyTrinket: handleBuyMerchantTrinket,
  onBuyTorch: handleBuyMerchantTorch,
  onBuyKey: handleBuyMerchantKey,
  onBuyPotion: handleBuyMerchantPotion,
} = useMerchantStock({
  initialMerchantStock: initialFloorStateRef.current.merchantStock,
  currentFloorMood,
  floorLevel,
  tarotFreeTrinkets,
  tarotShopRarity,
  tarotNoMerchant,
  combatLibrary,
  ownedRelics,
  playerDeckIds,
    runSeedRef,
  currentFloorSize,
  getSpawnForSize,

  teeth,
  setTeeth,
  maxTeeth,

  keys,
  setKeys,
  maxKeys,

  torches,
  setTorches,
  maxTorches,

  potions,
  setPotions,
  maxPotions,

  setSanity,
  setOwnedRelics,
  setPlayerDeckIds,
  setNextCombatCost0,

  TRINKET_LIMIT: trinketLimit,
});


  
  const { descendStairs } = useFloorTransition({
  floorLevel,
  currentFloorTorchDuration,
  turns,
  runSeedRef,
  ransackedChestSpawnedRef,
  getMapSizeForFloor,
  getSpawnForSize,
  maxTorchDuration: MAX_TORCH_DURATION,
  playStepsDownSfx,
  maybeDrawTarot,

  setFloorLevel,
  setMap,
  setBarredDoorKeys,
  setPlayerPos,
  setCurrentFloorMood,
  setSpecialBossFloorSelection,
  setCurrentFloorTorchDuration,
  setTurns,
  setFloorActionCount,
  setFloorCorruption,
  setCorruptionBannerText,
  setPendingCorruptionBonusReward,
  setExploredTiles,
  setIsMiniMapOpen,
  setBrazierQuestCompletionTriggered,
  setBrazierCompletionBannerText,
  setSlainEnemiesThisFloor,
  setCleansingQuestCompletionTriggered,
  setCleansingCompletionBannerText,
  setCanRest,
   setRelics,
  setMerchantStock,
  setActiveCombatMods,
});

const {
  isShrineOpen,
  shrineError,
  shrineResult,

  isWellOpen,
  wellError,
  wellResult,

  trapQTE,
  activeLore,
  barredDoorLore,
  isRansackedChestOpen,
  isWellEchoOpen,
  pendingRansackedChestPos,
  pendingWellMythicPos,
  simpleChestRelicPickerMode,
  simpleChestResourceReward,

  activeShrineTier,
  activeShrineCostText,
  activeShrineRewardText,
  activeShrineCanAfford,

  openShrineAt,
  closeShrine,
  confirmShrineOffer,

  openWellAt,
  closeWell,
  confirmWellDiscard,

  openRansackedChest,
  closeRansackedChest,
  inspectRansackedChestReward,
  lootSimpleChestResources,

  confirmWellEchoListen,

  canInspectSanctifiedSecretStatue,
  inspectSanctifiedSecretStatue,

  handleLoreClick,
  closeLore,
  closeBarredDoorLore,

  handleTap,
  handleTileClick,
  handleMove,
  resolveTrap,
  unlockChest,

  handleDungeonRelicPick,
  handleDungeonRelicPickerClose,
} = useDungeonActions({
  map,
  setMap,
  mapWidth,
  mapHeight,
  playerPos,
  setPlayerPos,
  floorLevel,
  runSeedRef,
  barredDoorKeys,
  floorCorruption,

  isStatusOpen,
  isMerchantOpen,
  isMiniMapOpen,
  isStorylineActive,
  isCombatActive,
  isPreCombatTransitionActive,
  pendingDeckCullReward,

  initialPendingRansackedChestPos:
    initialFloorStateRef.current.pendingRansackedChestPos,
  initialPendingWellMythicPos:
    initialFloorStateRef.current.pendingWellMythicPos,
  initialIsWellEchoOpen:
    initialFloorStateRef.current.isWellEchoOpen,

  keys,
  setKeys,
  maxKeys,
  teeth,
  setTeeth,
  maxTeeth,
  potions,
  setPotions,
  maxPotions,
  torches,
  setTorches,
  maxTorches,
  setHp,
  maxHp,
  setSanity,
  maxSp,

  playerDeckIds,
  setPlayerDeckIds,
  ownedRelics,
  setOwnedRelics,
  setRelics,
  freeChestsRemaining,
  setFreeChestsRemaining,

  setShrineMaxHpPenalty,
  setShrineMaxSpPenalty,
  nextCombatCost0,
  setNextCombatCost0,
  nextCombatNegateNextDamage,
  setNextCombatNegateNextDamage,
  nextCombatStartArmor,
  setNextCombatStartArmor,

  bypassEnemiesRemaining,
  setBypassEnemiesRemaining,
  levelCombatMods,
  setCombatEnemyTile,
  setIsCombatActive,
  beginCombatTransition,
  setActiveCombatMods,
  preCombatPosRef,

  setCanRest,
  setIsMerchantOpen,
  setActiveMerchantKey,
  setFloorActionCount,
  setTurns,

  isBrazierLit,
  isSpecialCorruptedEnemyAtTile,
  isYahakaAtTile,
  yahakaCombatEnemyId: activeYahakaEnemyId,
  specialBossEnemyId: activeSpecialBossEnemyId,
  igniteBrazier,
  descendStairs,
  startStoryline,
  onConsultWitch: handleConsultWitch,
  moveEnemiesTowardsPlayer,

  tarotBypassCombats,
  tarotPlayerStartArmor,
  tarotEnemyStartArmor,
  tarotPlayerStartReflectPct,
  tarotEnemyStartReflectPct,
  tarotMagicModifier,
  tarotPerTileHpHeal,
  tarotTrapTimeFactor,
  tarotEnemiesChase,

  trapActivationChanceMultiplier,
  perTileHpRegen,
  TRINKET_LIMIT: trinketLimit,

  playDoorBarredSfx,
  playDoorUnlockingSfx,
  playDoorOpenSfx,
  playPlayerStepSfx,
  playTrapCountdownStartSfx,
  playChestUnlockingSfx,
  playChestOpenSfx,
  playLoreInspectSfx,
  playBrazierLitSfx,
});

const {
  handleTouchStart,
  handleTouchMove,
  handleTouchEnd,
} = useDungeonInput({
  isMobile,

  isStatusOpen,
  isMerchantOpen,
  isShrineOpen,
  isWellOpen,
  isStorylineActive,
  isCombatActive,
  isPreCombatTransitionActive,
  trapQTE,
  pendingDeckCullReward,
  activeLore,
  barredDoorLore,
  isRansackedChestOpen,
  isWellEchoOpen,
  isSimpleChestResourceOpen: !!simpleChestResourceReward,

  handleMove,
  handleTap,
  handleTileClick,
});


useEffect(() => {
  const relicIds = ownedRelics.map((relic) => relic?.id).filter(Boolean);
  if (!relicIds.length) return;

  unlockLegendariumEntries({ relics: relicIds });
}, [ownedRelics]);

useEffect(() => {
  const offeredRelicIds = (Array.isArray(relics) ? relics : []).map((relic) => relic?.id).filter(Boolean);
  if (!offeredRelicIds.length) return;

  unlockLegendariumEntries({ relics: offeredRelicIds });
}, [relics]);

useEffect(() => {
  const deckIds = (Array.isArray(playerDeckIds) ? playerDeckIds : []).filter((id) => typeof id === 'string' && id);
  if (!deckIds.length) return;

  unlockLegendariumEntries({ cards: deckIds });
}, [playerDeckIds]);

useEffect(() => {
  const enemyId = combatEnemyTile?.enemyId;
  if (!enemyId) return;

  const enemyDef = getEnemyDef(enemyId);
  const enemyCardIds = (enemyDef?.enemyCards || []).map((card) => card?.id).filter(Boolean);

  unlockLegendariumEntries({
    enemies: [enemyDef?.id || String(enemyId)],
    cards: enemyCardIds,
  });
}, [combatEnemyTile]);

const combatModsForOverlay = React.useMemo(() => {
  const baseMods = activeCombatMods || undefined;
  const enemyId = combatEnemyTile?.enemyId;

  const shouldBuffFloor10Boss =
    Math.max(1, Math.floor(Number(floorLevel) || 1)) === 10 &&
    !!enemyId &&
    !!activeSpecialBossEnemyId &&
    enemyId === activeSpecialBossEnemyId;

  if (!shouldBuffFloor10Boss) return baseMods;

  const enemyDef = getEnemyDef(enemyId);
  const baseHp = Math.max(1, Math.floor(Number(enemyDef?.hp ?? 1) || 1));
  const baseArmor = Math.max(0, Math.floor(Number(enemyDef?.armor ?? 0) || 0));
  const bonusHp = Math.max(0, Math.floor(baseHp * 0.5));
  const bonusArmor = Math.max(0, Math.floor(baseArmor * 0.5));

  return {
    ...(baseMods || {}),
    enemyStartHp: (Number(baseMods?.enemyStartHp || 0) || 0) + bonusHp,
    enemyStartArmor: (Number(baseMods?.enemyStartArmor || 0) || 0) + bonusArmor,
  };
}, [activeCombatMods, combatEnemyTile, floorLevel, activeSpecialBossEnemyId]);

useLegendariumLoreSync({
  activeLore,
  barredDoorLore,
  unlockLegendariumEntries,
  onLoreRecorded: () => setLoreBannerText('Legendarium updated'),
});

useEffect(() => {
  const storyletId = activeStorylet?.id;
  if (!storyletId) return;
  unlockLegendariumEntries({ storylets: [storyletId] });
}, [activeStorylet]);

const previousSpiderBossActionFloorRef = useRef(floorLevel);
const previousSpiderBossActionCountRef = useRef(floorActionCount);

const explorationPassiveMods = React.useMemo(
  () => computeCombatMods(ownedRelics),
  [ownedRelics]
);

const beginSpiderBossCombat = React.useCallback((bossPos) => {
  if (!bossPos || isCombatActive || isPreCombatTransitionActive) return;

  preCombatPosRef.current = { ...playerPos };

  const passiveMods = explorationPassiveMods;
  const oneShotCost0 = Math.max(0, Number(nextCombatCost0) || 0);
  const oneShotNegate = Math.max(0, Number(nextCombatNegateNextDamage) || 0);
  const oneShotStartArmor = Math.max(0, Number(nextCombatStartArmor) || 0);
  const combinedMods = { ...passiveMods, ...levelCombatMods };

  combinedMods.firstTurnExtraDraw =
    (Number(passiveMods.firstTurnExtraDraw || 0) || 0) +
    (Number(levelCombatMods.firstTurnExtraDraw || 0) || 0);

  if (tarotPlayerStartArmor) {
    combinedMods.startArmor =
      (Number(combinedMods.startArmor || 0) || 0) + tarotPlayerStartArmor;
  }
  if (tarotEnemyStartArmor) {
    combinedMods.enemyStartArmor =
      (Number(combinedMods.enemyStartArmor || 0) || 0) + tarotEnemyStartArmor;
  }
  if (tarotPlayerStartReflectPct) {
    combinedMods.startReflectPct =
      (Number(combinedMods.startReflectPct || 0) || 0) + tarotPlayerStartReflectPct;
  }
  if (tarotEnemyStartReflectPct) {
    combinedMods.enemyStartReflectPct =
      (Number(combinedMods.enemyStartReflectPct || 0) || 0) + tarotEnemyStartReflectPct;
  }
  if (tarotMagicModifier === 'boost') {
    combinedMods.magicDamageMultiplier =
      Number(combinedMods.magicDamageMultiplier || 1) * 1.25;
  } else if (tarotMagicModifier === 'nerf') {
    combinedMods.magicDamageMultiplier =
      Number(combinedMods.magicDamageMultiplier || 1) * 0.75;
  }

  setActiveCombatMods({
    ...combinedMods,
    startArmor: (Number(combinedMods.startArmor || 0) || 0) + oneShotStartArmor,
    startNextCardCost0: Math.max(passiveMods.startNextCardCost0 || 0, oneShotCost0),
    startNegateNextDamage:
      (Number(passiveMods.startNegateNextDamage || 0) || 0) + oneShotNegate,
  });

  if (oneShotCost0 > 0) setNextCombatCost0(0);
  if (oneShotNegate > 0) setNextCombatNegateNextDamage(0);
  if (oneShotStartArmor > 0) setNextCombatStartArmor(0);

  beginCombatTransition({
    x: bossPos.x,
    y: bossPos.y,
    floor: floorLevel,
    enemyId: SPIDER_BOSS_ENEMY_ID,
    isSpiderBoss: true,
  });
}, [
  beginCombatTransition,
  floorLevel,
  isCombatActive,
  isPreCombatTransitionActive,
  levelCombatMods,
  nextCombatCost0,
  nextCombatNegateNextDamage,
  nextCombatStartArmor,
  explorationPassiveMods,
  playerPos,
  setActiveCombatMods,
  setNextCombatCost0,
  setNextCombatNegateNextDamage,
  setNextCombatStartArmor,
  tarotEnemyStartArmor,
  tarotEnemyStartReflectPct,
  tarotMagicModifier,
  tarotPlayerStartArmor,
  tarotPlayerStartReflectPct,
]);

useEffect(() => {
  if (previousSpiderBossActionFloorRef.current !== floorLevel) {
    previousSpiderBossActionFloorRef.current = floorLevel;
    previousSpiderBossActionCountRef.current = floorActionCount;
    return;
  }

  const previousCount = previousSpiderBossActionCountRef.current;
  previousSpiderBossActionCountRef.current = floorActionCount;

  if (floorActionCount <= previousCount) return;
  if (!isSpiderBossFloorActive) return;
  if (!spiderBossState.enabled || !spiderBossState.bossSpawned || spiderBossState.bossDefeated) {
    return;
  }
  if (isCombatActive || isStorylineActive || isPreCombatTransitionActive || trapQTE || pendingDeckCullReward) return;

  const bossPos = findSpiderBossPos(map) || spiderBossState.bossPos;
  if (!bossPos) return;

  const lockedOnPlayer =
    spiderBossState.bossLockedOnPlayer ||
    isPlayerWithinSpiderBossSight(bossPos, playerPos);

  const targetPos = lockedOnPlayer
    ? playerPos
    : parseCoordKey(spiderBossState.bossAlertWebKey);

  if (!targetPos) {
    setSpiderBossState((prev) => ({
      ...prev,
      bossLockedOnPlayer: lockedOnPlayer,
      bossPos,
    }));
    return;
  }

  const result = moveSpiderBossOneStep({
    map,
    bossPos,
    bossUnderTile: spiderBossState.bossUnderTile,
    targetPos,
    playerPos,
  });

  if (result.contactPlayer) {
    setSpiderBossState((prev) => ({
      ...prev,
      bossLockedOnPlayer: true,
      bossPos,
    }));
    beginSpiderBossCombat(bossPos);
    return;
  }

  if (!result.moved) {
    setSpiderBossState((prev) => ({
      ...prev,
      bossLockedOnPlayer: lockedOnPlayer,
      bossPos,
    }));
    return;
  }

  setMap(result.map);
  setSpiderBossState((prev) => ({
    ...prev,
    bossPos: result.bossPos,
    bossUnderTile: result.bossUnderTile,
    bossLockedOnPlayer:
      lockedOnPlayer ||
      isPlayerWithinSpiderBossSight(result.bossPos, playerPos),
  }));
}, [
  beginSpiderBossCombat,
  floorActionCount,
  floorLevel,
  isCombatActive,
  isSpiderBossFloorActive,
  isMonsignorBossFloorActive,
  isStorylineActive,
  map,
  pendingDeckCullReward,
  playerPos,
  setMap,
  spiderBossState.bossAlertWebKey,
  spiderBossState.bossDefeated,
  spiderBossState.bossLockedOnPlayer,
  spiderBossState.bossPos,
  spiderBossState.bossSpawned,
  spiderBossState.bossUnderTile,
  spiderBossState.enabled,
  trapQTE,
]);

// Lazily build the floor snapshot payload only when needed. This callback
// recreates the object with the same fields that were previously defined
// in the eager useMemo. Using useCallback here ensures that the function
// identity only changes when one of its dependencies does. The function
// body returns an object representing the current dungeon floor state,
// including runSeed, position, inventory, flags, and tarot modifiers.
const buildFloorSnapshotPayload = React.useCallback(
  () => ({
    runSeed: runSeedRef.current >>> 0,
    floorLevel,
    currentFloorMood,
    currentFloorTorchDuration,
    turns,
    torches,
    keys,
    teeth,
    potions,
    playerPos,
    map,
    barredDoorKeys: [...(barredDoorKeys || [])],
    exploredTiles: [...(exploredTiles || [])],
    litBraziers: [...(litBraziers || [])],
    floorActionCount,
    floorCorruption,
    specialBossFloorSelection: sanitizeSpecialBossSelectionForFloor(
      specialBossFloorSelection,
      floorLevel
    ),
    spiderBossState,
    slainEnemiesThisFloor,
    brazierQuestCompletionTriggered,
    brazierCompletionBannerText,
    cleansingQuestCompletionTriggered,
    cleansingCompletionBannerText,
    pendingDeckCullReward,
    pendingCorruptionBonusReward,
    showSpawnTorchHint,
    spawnTutorialStage,
    spawnTutorialMoveTriggered,
    merchantStock,
    relicOfferIds: (relics || []).map((r) => r.id),
    nextCombatCost0,
    nextCombatNegateNextDamage,
    nextCombatStartArmor,
    bypassEnemiesRemaining,
    freeChestsRemaining,
    pendingRansackedChestPos,
    pendingWellMythicPos,
    isWellEchoOpen,
    yahakaState,
    yahakaDefeatCount,
    yahakaSpawnArmed,
    yahakaBannerText,
    tarot: {
      history: tarotHistory,
      activeCardId: currentTarot?.card?.id ?? null,
      activeOrientation: currentTarot?.orientation ?? null,
      pendingCardId: pendingTarotForNextFloor?.card?.id ?? null,
      pendingOrientation: pendingTarotForNextFloor?.orientation ?? null,
      perTileHpHeal: tarotPerTileHpHeal,
      trapTimeFactor: tarotTrapTimeFactor,
      extraLife: tarotExtraLife,
      lifeUsed: tarotLifeUsed,
      bypassCombats: tarotBypassCombats,
      enemiesChase: tarotEnemiesChase,
      shopRarity: tarotShopRarity,
      playerStartArmor: tarotPlayerStartArmor,
      enemyStartArmor: tarotEnemyStartArmor,
      noTorchesNeeded: tarotNoTorchesNeeded,
      lightRadiusPenalty: tarotLightRadiusPenalty,
      freeTrinkets: tarotFreeTrinkets,
      noMerchant: tarotNoMerchant,
      extraRewardChoice: tarotExtraRewardChoice,
      reducedRewardChoice: tarotReducedRewardChoice,
      magicModifier: tarotMagicModifier,
      revealMap: tarotRevealMap,
      darknessDamage: tarotDarknessDamage,
      playerStartReflectPct: tarotPlayerStartReflectPct,
      enemyStartReflectPct: tarotEnemyStartReflectPct,
      chainExpBonus: tarotChainExpBonus,
      noExp: tarotNoExp,
    },
    corruptionBannerText,
  }),
  [
    floorLevel,
    currentFloorMood,
    currentFloorTorchDuration,
    turns,
    torches,
    keys,
    teeth,
    potions,
    playerPos,
    map,
    barredDoorKeys,
    exploredTiles,
    litBraziers,
    floorActionCount,
    floorCorruption,
    specialBossFloorSelection,
    spiderBossState,
    slainEnemiesThisFloor,
    brazierQuestCompletionTriggered,
    brazierCompletionBannerText,
    cleansingQuestCompletionTriggered,
    cleansingCompletionBannerText,
    pendingDeckCullReward,
    pendingCorruptionBonusReward,
    showSpawnTorchHint,
    spawnTutorialStage,
    spawnTutorialMoveTriggered,
    merchantStock,
    relics,
    nextCombatCost0,
    nextCombatNegateNextDamage,
    nextCombatStartArmor,
    bypassEnemiesRemaining,
    freeChestsRemaining,
    pendingRansackedChestPos,
    pendingWellMythicPos,
    isWellEchoOpen,
    yahakaState,
    yahakaDefeatCount,
    yahakaSpawnArmed,
    yahakaBannerText,
    tarotHistory,
    currentTarot,
    pendingTarotForNextFloor,
    tarotPerTileHpHeal,
    tarotTrapTimeFactor,
    tarotExtraLife,
    tarotLifeUsed,
    tarotBypassCombats,
    tarotEnemiesChase,
    tarotShopRarity,
    tarotPlayerStartArmor,
    tarotEnemyStartArmor,
    tarotNoTorchesNeeded,
    tarotLightRadiusPenalty,
    tarotFreeTrinkets,
    tarotNoMerchant,
    tarotExtraRewardChoice,
    tarotReducedRewardChoice,
    tarotMagicModifier,
    tarotRevealMap,
    tarotDarknessDamage,
    tarotPlayerStartReflectPct,
    tarotEnemyStartReflectPct,
    tarotChainExpBonus,
    tarotNoExp,
    corruptionBannerText,
  ]
);

// Holds the most recently built floor snapshot. This ref starts as null
// because the snapshot is now built lazily. It will be updated whenever
// floorSnapshotRevision changes or when an immediate flush occurs.
const latestFloorSnapshotRef = useRef(null);

// Keep a ref to the latest buildFloorSnapshotPayload callback so that
// the pagehide/beforeunload handler can call the current version without
// re-registering the event listener on each render.
const latestBuildFloorSnapshotPayloadRef = useRef(buildFloorSnapshotPayload);
useEffect(() => {
  latestBuildFloorSnapshotPayloadRef.current = buildFloorSnapshotPayload;
}, [buildFloorSnapshotPayload]);

// Track the latest floor level so that immediate flushes can use the
// most recent value. This ref is updated whenever floorLevel changes.
const latestFloorLevelRef = useRef(floorLevel);
useEffect(() => {
  latestFloorLevelRef.current = floorLevel;
}, [floorLevel]);

// Track the latest floor snapshot and persist it asynchronously. Using
// useEffect instead of useLayoutEffect avoids blocking layout on large
// serialization work.
// Compute a revision token that only changes when persistence-worthy
// state changes. Concatenate a subset of fields into a string to avoid
// object reference churn. This token is used to trigger writing the
// snapshot when necessary without rebuilding it on every render.
const floorSnapshotRevision = React.useMemo(
  () =>
    [
      floorLevel,
      playerPos?.x,
      playerPos?.y,
      turns,
      torches,
      keys,
      teeth,
      potions,
      floorActionCount,
      floorCorruption,
      map,
      spiderBossState,
      slainEnemiesThisFloor,
      brazierQuestCompletionTriggered,
      brazierCompletionBannerText,
      cleansingQuestCompletionTriggered,
      cleansingCompletionBannerText,
      pendingDeckCullReward,
      pendingCorruptionBonusReward,
      showSpawnTorchHint,
      spawnTutorialStage,
      spawnTutorialMoveTriggered,
      merchantStock,
      relics,
      nextCombatCost0,
      nextCombatNegateNextDamage,
      nextCombatStartArmor,
      bypassEnemiesRemaining,
      freeChestsRemaining,
      pendingRansackedChestPos,
      pendingWellMythicPos,
      isWellEchoOpen,
      yahakaState,
      yahakaDefeatCount,
      yahakaSpawnArmed,
      yahakaBannerText,
      tarotHistory,
      currentTarot?.card?.id,
      currentTarot?.orientation,
      pendingTarotForNextFloor?.card?.id,
      pendingTarotForNextFloor?.orientation,
      tarotPerTileHpHeal,
      tarotTrapTimeFactor,
      tarotExtraLife,
      tarotLifeUsed,
      tarotBypassCombats,
      tarotEnemiesChase,
      tarotShopRarity,
      tarotPlayerStartArmor,
      tarotEnemyStartArmor,
      tarotNoTorchesNeeded,
      tarotLightRadiusPenalty,
      tarotFreeTrinkets,
      tarotNoMerchant,
      tarotExtraRewardChoice,
      tarotReducedRewardChoice,
      tarotMagicModifier,
      tarotRevealMap,
      tarotDarknessDamage,
      tarotPlayerStartReflectPct,
      tarotEnemyStartReflectPct,
      tarotChainExpBonus,
      tarotNoExp,
      corruptionBannerText,
    ].join('|'),
  [
    floorLevel,
    playerPos,
    turns,
    torches,
    keys,
    teeth,
    potions,
    floorActionCount,
    floorCorruption,
    map,
    spiderBossState,
    slainEnemiesThisFloor,
    brazierQuestCompletionTriggered,
    brazierCompletionBannerText,
    cleansingQuestCompletionTriggered,
    cleansingCompletionBannerText,
    pendingDeckCullReward,
    pendingCorruptionBonusReward,
    showSpawnTorchHint,
    spawnTutorialStage,
    spawnTutorialMoveTriggered,
    merchantStock,
    relics,
    nextCombatCost0,
    nextCombatNegateNextDamage,
    nextCombatStartArmor,
    bypassEnemiesRemaining,
    freeChestsRemaining,
    pendingRansackedChestPos,
    pendingWellMythicPos,
    isWellEchoOpen,
    yahakaState,
    yahakaDefeatCount,
    yahakaSpawnArmed,
    yahakaBannerText,
    tarotHistory,
    currentTarot,
    pendingTarotForNextFloor,
    tarotPerTileHpHeal,
    tarotTrapTimeFactor,
    tarotExtraLife,
    tarotLifeUsed,
    tarotBypassCombats,
    tarotEnemiesChase,
    tarotShopRarity,
    tarotPlayerStartArmor,
    tarotEnemyStartArmor,
    tarotNoTorchesNeeded,
    tarotLightRadiusPenalty,
    tarotFreeTrinkets,
    tarotNoMerchant,
    tarotExtraRewardChoice,
    tarotReducedRewardChoice,
    tarotMagicModifier,
    tarotRevealMap,
    tarotDarknessDamage,
    tarotPlayerStartReflectPct,
    tarotEnemyStartReflectPct,
    tarotChainExpBonus,
    tarotNoExp,
    corruptionBannerText,
  ]
);

// When the revision token changes, build a new snapshot payload and
// persist it. This ensures that the expensive object construction
// and serialization only happens when relevant game state changes.
useEffect(() => {
  const snapshot = buildFloorSnapshotPayload();
  latestFloorSnapshotRef.current = snapshot;
  writeFloorSnapshot(snapshot);
}, [buildFloorSnapshotPayload, floorSnapshotRevision]);

useEffect(() => {
  const flushFloorSnapshotNow = () => {
    if (skipUnloadPersistenceRef.current) return;

    // Always build and write the latest snapshot and other run state
    // immediately before the page is hidden or unloaded. Use the
    // { immediate: true } option so that writes bypass the deferred
    // queue. Flush any remaining queued writes afterward to ensure
    // nothing is lost.
    const snapshot = latestBuildFloorSnapshotPayloadRef.current();
    latestFloorSnapshotRef.current = snapshot;
    writeFloorSnapshot(snapshot, { immediate: true });
    writeSavedRunSeed(runSeedRef.current, { immediate: true });
    writeSavedFloorLevel(latestFloorLevelRef.current, { immediate: true });
    writeRansackedChestSpawned(ransackedChestSpawnedRef.current, {
      immediate: true,
    });
    flushPendingStorageWrites();
  };

  window.addEventListener('pagehide', flushFloorSnapshotNow);
  window.addEventListener('beforeunload', flushFloorSnapshotNow);

  return () => {
    window.removeEventListener('pagehide', flushFloorSnapshotNow);
    window.removeEventListener('beforeunload', flushFloorSnapshotNow);
  };
}, []);

const reopenStatusOnLegendariumCloseRef = useRef(false);
const previousLegendariumOpenRef = useRef(isLegendariumOpen);

useEffect(() => {
  if (previousLegendariumOpenRef.current && !isLegendariumOpen && reopenStatusOnLegendariumCloseRef.current) {
    reopenStatusOnLegendariumCloseRef.current = false;
    setIsStatusOpen(true);
  }

  previousLegendariumOpenRef.current = isLegendariumOpen;
}, [isLegendariumOpen]);

const flushCurrentRunSnapshot = React.useCallback(() => {
  // Immediately build and commit the latest run state to storage. This
  // function is called before navigating to other screens (e.g. opening
  // the Legendarium). Building the snapshot here ensures that any
  // changes since the last automatic write are captured.
  const snapshot = latestBuildFloorSnapshotPayloadRef.current();
  latestFloorSnapshotRef.current = snapshot;
  writeFloorSnapshot(snapshot, { immediate: true });
  writeSavedRunSeed(runSeedRef.current, { immediate: true });
  writeSavedFloorLevel(latestFloorLevelRef.current, { immediate: true });
  writeRansackedChestSpawned(ransackedChestSpawnedRef.current, {
    immediate: true,
  });
  flushPendingStorageWrites();
}, []);

  /* =============================================
   * RENDER
   * ============================================= */
    /**
   * Render the tarot card overlay. When `isTarotVisible` is true and
   * `currentTarot` is set, this overlay slides up from the bottom of the
   * screen and displays the drawn card. The card image is rotated 180°
   * when the orientation is reversed. The overlay automatically fades
   * away after a brief delay (see effect below).
   */
  
const hideUI = isStorylineActive;

const {
  handleRootBoardClick,
} = useDungeonClickBoundary({
  isStorylineActive,
});

// Memoize boardRefs so that DungeonBoard only receives a stable object instance
const boardRefs = React.useMemo(() => ({
  boardViewportRef,
  boardElRef,
}), []);

const underPropRenders = React.useMemo(() => {
  if (!Array.isArray(underProps) || underProps.length === 0) return [];

  const z = boardLayoutZoom || 1;

  return underProps.map((p) => {
    const baseW = p.w ?? 180;
    const baseH = p.h ?? 180;
    const baseScale = p.scale ?? 1;

    const w = baseW * z * baseScale;
    const h = baseH * z * baseScale;

    const left = (p.cx * boardSpanX) - (w / 2);
    const top = (p.cy * boardSpanY) - (h / 2);

    return {
      id: p.id,
      src: p.src,
      left,
      top,
      w,
      h,
      rotateDeg: p.rotateDeg ?? 0,
      opacity: p.opacity ?? 1,
      mixBlendMode: p.mixBlendMode,
    };
  });
}, [underProps, boardLayoutZoom, boardSpanX, boardSpanY]);

const boardState = React.useMemo(() => ({
  map,
  mapWidth,
  mapHeight,
  playerPos,
  visibleTiles,
  exploredTiles,
  tileViewport,
  ambientPropRenders,
  underPropRenders,
  spiderwebKeys: spiderBossState.webKeys,
  spiderwebShakeTicksByKey: spiderBossState.webShakeTicksByKey,
}), [
  map,
  mapWidth,
  mapHeight,
  playerPos,
  visibleTiles,
  exploredTiles,
  tileViewport,
  ambientPropRenders,
  underPropRenders,
  spiderBossState.webKeys,
  spiderBossState.webShakeTicksByKey,
]);

const tileActions = React.useMemo(() => ({
  handleTileClick,
}), [handleTileClick]);

const tileHelpers = React.useMemo(() => ({
  isBrazierLit,
  isSpecialCorruptedEnemyAtTile,
  isYahakaAtTile,
}), [isBrazierLit, isSpecialCorruptedEnemyAtTile, isYahakaAtTile]);

const tileAssets = React.useMemo(() => ({
  backgroundImg,
  madnessOverlayImg,
  corridorImg,
  corridorImgs,
  corridorLab0aImg,
  corridorLab0bImg,
  corridorLab0cImg,
  corridorLab0dImg,
  corridorLab1aImg,
  corridorLab1bImg,
  corridorLab2aImg,
  corridorLab2bImg,
  corridorLab2cImg,
  corridorLab2dImg,
  corridorLab3aImg,
  corridorLab3bImg,
  corridorLab3cImg,
  corridorLab3dImg,
  corridorLab3eImg,
  restImg,
  doorOpenImg,
  doorLockedImg,
  cardbackImg,
  chestOpenImg,
  chestLockedImg,
  chestSimpleClosedImg,
  chestSimpleLockedImg,
  chestSimpleOpenImg,
  chestRareClosedImg,
  chestRareLockedImg,
  chestRareOpenImg,
  brazierImg,
  brazierOutImg,
  merchantImg,
  shrineImg,
  wellImg,
  witchImg,
  cultistEnemyImg,
  hexbinderEnemyImg,
  nestedHorrorEnemyImg,
  dreadbrandEnemyImg,
  corruptedCultistEnemyImg,
  chainedPenitentEnemyImg,
  chainedPenitentEnemy2Img,
  chainedPenitentEnemy3Img,
  monsignorEnemyImg,
  darkApostleEnemyImg,
  chymistEnemyImg,
  mercenaryEnemyImg,
  lampKeeperEnemyImg,
  thresholdVerifierEnemyImg,
  custodianEnemyImg,
  blackhandEnemyImg,
  primeVesselEnemyImg,
  machinePrimeCrucible1Img,
  machinePulseEngineImg,
  machineSynapticRetortImg,
  machineAstralReliquaryImg,
  primeVesselOverlayPrimeCrucibleImg,
  primeVesselOverlaySynapticRetortImg,
  primeVesselOverlayPulseEngineImg,
  primeVesselOverlayAstralReliquaryImg,
  yahakaEnemyImg: activeYahakaEnemyImg,
  stepsUpImg,
  stepsDownImg,
  loreImg,
  loreImg2,
  storylineImg,
  secretEntranceImg,
  spiderwebImg,
  damageMasks: [
    damageMask1Img,
    damageMask2Img,
    damageMask3Img,
    damageMask4Img,
    damageMask5Img,
    damageMask6Img,
  ],
  damageMaskOverlays: [
    damageMask1OverlayImg,
    damageMask2OverlayImg,
    damageMask3OverlayImg,
    damageMask4OverlayImg,
    damageMask5OverlayImg,
    damageMask6OverlayImg,
  ],
}), [
  backgroundImg,
  madnessOverlayImg,
  corridorImg,
  corridorImgs,
  corridorLab0aImg,
  corridorLab0bImg,
  corridorLab0cImg,
  corridorLab0dImg,
  corridorLab1aImg,
  corridorLab1bImg,
  corridorLab2aImg,
  corridorLab2bImg,
  corridorLab2cImg,
  corridorLab2dImg,
  corridorLab3aImg,
  corridorLab3bImg,
  corridorLab3cImg,
  corridorLab3dImg,
  corridorLab3eImg,
  restImg,
  doorOpenImg,
  doorLockedImg,
  cardbackImg,
  chestOpenImg,
  chestLockedImg,
  chestSimpleClosedImg,
  chestSimpleLockedImg,
  chestSimpleOpenImg,
  chestRareClosedImg,
  chestRareLockedImg,
  chestRareOpenImg,
  brazierImg,
  brazierOutImg,
  merchantImg,
  shrineImg,
  wellImg,
  witchImg,
  cultistEnemyImg,
  hexbinderEnemyImg,
  nestedHorrorEnemyImg,
  dreadbrandEnemyImg,
  corruptedCultistEnemyImg,
  chainedPenitentEnemyImg,
  chainedPenitentEnemy2Img,
  chainedPenitentEnemy3Img,
  monsignorEnemyImg,
  darkApostleEnemyImg,
  chymistEnemyImg,
  mercenaryEnemyImg,
  lampKeeperEnemyImg,
  thresholdVerifierEnemyImg,
  custodianEnemyImg,
  blackhandEnemyImg,
  primeVesselEnemyImg,
  machinePrimeCrucible1Img,
  machinePulseEngineImg,
  machineSynapticRetortImg,
  machineAstralReliquaryImg,
  primeVesselOverlayPrimeCrucibleImg,
  primeVesselOverlaySynapticRetortImg,
  primeVesselOverlayPulseEngineImg,
  primeVesselOverlayAstralReliquaryImg,
  activeYahakaEnemyImg,
  stepsUpImg,
  stepsDownImg,
  loreImg,
  loreImg2,
  storylineImg,
  secretEntranceImg,
  spiderwebImg,
  damageMask1Img,
  damageMask2Img,
  damageMask3Img,
  damageMask4Img,
  damageMask5Img,
  damageMask6Img,
  damageMask1OverlayImg,
  damageMask2OverlayImg,
  damageMask3OverlayImg,
  damageMask4OverlayImg,
  damageMask5OverlayImg,
  damageMask6OverlayImg,
]);

const handleLightTorch = React.useCallback(() => {
  if (torches <= 0) return;

  playTorchIgniteAndLoop();
  triggerTorchCameraRecenterAnim(effectiveExplorationScaleFactor, minZoom);
  setTurns(0);
  if (isBlackhandBossFloorActive) {
    setBlackhandTorchWarningText('The darkness holds your light, you cannot see further');
  }
  if (spawnTutorialStage === 'lightTorch') {
    setSpawnTutorialStage('moveInteract');
    setSpawnTutorialMoveTriggered(false);
  }
  setFlash(true);
  setTimeout(() => setFlash(false), 380);
  setTorches((t) => t - 1);

  applyTorchHooks(ownedRelics, {
    addNextCombatCost0: (n) => setNextCombatCost0((v) => Math.max(v, n)),
    addNextCombatNegateNextDamage: (n) =>
      setNextCombatNegateNextDamage((v) => Math.max(v, n)),
    addNextCombatStartArmor: (n) =>
      setNextCombatStartArmor((v) => Math.max(v, n)),
    addSanity: (n) => setSanity((s) => s + n),
    addPotions: (n) => setPotions((p) => Math.min(maxPotions, p + n)),
    addKeys: (n) => setKeys((k) => Math.min(maxKeys, k + n)),
  });
}, [
  torches,
  playTorchIgniteAndLoop,
  triggerTorchCameraRecenterAnim,
  effectiveExplorationScaleFactor,
  isBlackhandBossFloorActive,
  minZoom,
  setBlackhandTorchWarningText,
  ownedRelics,
  maxPotions,
  maxKeys,
  spawnTutorialStage,
]);

const handleBoardClick = React.useCallback((e) => {
  handleRootBoardClick(e);
  if (e.defaultPrevented) return;
  if (spawnTutorialStage !== 'lightTorch') return;
  if (!isDark) return;
  handleLightTorch();
}, [handleRootBoardClick, spawnTutorialStage, isDark, handleLightTorch]);

const openStatus = React.useCallback(() => setIsStatusOpen(true), []);
const openMiniMap = React.useCallback(() => setIsMiniMapOpen(true), []);
const toggleBackpack = React.useCallback(() => setIsBackpackOpen((v) => !v), []);
const hoverRelic = React.useCallback((relic) => setHoveredRelic(relic), []);
const leaveRelic = React.useCallback(() => setHoveredRelic(null), []);
const closeMobileRelicInfo = React.useCallback(() => setMobileRelicInfo(null), []);

const toggleMobileRelicInfo = React.useCallback((relic) => {
  setMobileRelicInfo((cur) => (cur?.id === relic.id ? null : relic));
}, []);

const openLegendariumFromHud = React.useCallback(() => {
  flushCurrentRunSnapshot();
  onOpenLegendarium?.();
}, [flushCurrentRunSnapshot, onOpenLegendarium]);

const hudFloorState = React.useMemo(() => ({
  floorLevel,
  floorMoodName: currentFloorMood?.name ?? '',
  brazierCompletionBannerText,
  cleansingCompletionBannerText,
  corruptionBannerText,
  yahakaBannerText,
  loreBannerText,
  compassHintText: '',
}), [
  floorLevel,
  currentFloorMood,
  brazierCompletionBannerText,
  cleansingCompletionBannerText,
  corruptionBannerText,
  yahakaBannerText,
  loreBannerText,
]);

const hudVitalsState = React.useMemo(() => ({
  hp,
  maxHp,
  sp: sanity,
  maxSp,
  sanityFx,
  sanityScreenFlicker,
  sanityDistortionSpike,
  sanityHudGlitchBurst,
}), [
  hp,
  maxHp,
  sanity,
  maxSp,
  sanityFx,
  sanityScreenFlicker,
  sanityDistortionSpike,
  sanityHudGlitchBurst,
]);

const hudInventoryState = React.useMemo(() => ({
  keys,
  maxKeys,
  teeth,
  maxTeeth,
  potions,
  maxPotions,
  torches,
  maxTorches,
  turns,
  torchDuration: currentFloorTorchDuration,
  showSpawnTorchHint,
  isBackpackOpen,
}), [
  keys,
  maxKeys,
  teeth,
  maxTeeth,
  potions,
  maxPotions,
  torches,
  maxTorches,
  turns,
  currentFloorTorchDuration,
  showSpawnTorchHint,
  isBackpackOpen,
]);

const hudOwnedRelics = React.useMemo(
  () => ownedRelics.map((relic) => applyRuntimeRelicDescription(relic)),
  [ownedRelics, applyRuntimeRelicDescription]
);

const hudHoveredRelic = React.useMemo(
  () => applyRuntimeRelicDescription(hoveredRelic),
  [hoveredRelic, applyRuntimeRelicDescription]
);

const hudMobileRelicInfo = React.useMemo(
  () => applyRuntimeRelicDescription(mobileRelicInfo),
  [mobileRelicInfo, applyRuntimeRelicDescription]
);

const hudRelicState = React.useMemo(() => ({
  ownedRelics: hudOwnedRelics,
  hoveredRelic: hudHoveredRelic,
  mobileRelicInfo: hudMobileRelicInfo,
  trinketLimit,
}), [
  hudOwnedRelics,
  hudHoveredRelic,
  hudMobileRelicInfo,
  trinketLimit,
]);

const hudActions = React.useMemo(() => ({
  onOpenStatus: openStatus,
  onResetDemo: resetDemo,
  onOpenMiniMap: openMiniMap,
  onOpenLegendarium: openLegendariumFromHud,
  onToggleBackpack: toggleBackpack,
  onUsePotion: usePotionFromBackpack,
  onLightTorch: handleLightTorch,
  onToggleGraphicsFxMode: toggleGraphicsFxMode,
  onHoverRelic: hoverRelic,
  onLeaveRelic: leaveRelic,
  onToggleMobileRelicInfo: toggleMobileRelicInfo,
  onCloseMobileRelicInfo: closeMobileRelicInfo,
}), [
  openStatus,
  resetDemo,
  openMiniMap,
  openLegendariumFromHud,
  toggleBackpack,
  usePotionFromBackpack,
  handleLightTorch,
  toggleGraphicsFxMode,
  hoverRelic,
  leaveRelic,
  toggleMobileRelicInfo,
  closeMobileRelicInfo,
]);

const statusPanelStartingBonuses = React.useMemo(() => ({
  armor:
    Math.max(0, Number(explorationPassiveMods?.startArmor || 0) || 0) +
    Math.max(0, Number(nextCombatStartArmor) || 0) +
    Math.max(0, Number(tarotPlayerStartArmor) || 0),
  reflect:
    Math.max(0, Number(explorationPassiveMods?.startReflectPct || 0) || 0) +
    Math.max(0, Number(tarotPlayerStartReflectPct) || 0),
  damage:
    Math.max(0, Number(explorationPassiveMods?.attackBonus || 0) || 0) +
    Math.max(0, Number(explorationPassiveMods?.turnStartAttackBonus || 0) || 0),
}), [
  explorationPassiveMods,
  nextCombatStartArmor,
  tarotPlayerStartArmor,
  tarotPlayerStartReflectPct,
]);

const renderState = React.useMemo(() => ({
  isMobile,
  lowFx,
  aggressiveLowFx,
  isStorylineActive,
  isPreCombatTransitionActive,
  floorLevel,
  floorSeed,
  floorCorruption,
  torchProgress,
  lightRadius,
  showBrazierRadiusGuide,
  brazierRadiusGuideByTile,
  tileVariations,
  currentFloorTilesetProfile,
  boardPerspectiveStageStyle,
  boardPerspectiveViewportStyle,
  boardPerspectiveBoardStyle,
  boardCameraTransition,
  boardMotionScale,
  offsetX,
  offsetY,
  renderTileWidth,
  renderTileHeight,
  renderTileHalfMargin,
  renderTileRadius,
  boardSpanX,
  boardSpanY,
  flash,
  secretWhisperTorchFlicker,
  sanityFx,
  madnessOverlayOpacity,
  madnessOverlayBlendMode: MADNESS_OVERLAY_BLEND_MODE,
  sanityScreenFlicker,
  sanityDistortionSpike,
  sanityPeripheralShadow,
  sanityCollapseBurst,
  sanityHudGlitchBurst,
  ghostEnemyFlicker,
  specialBossEnemyId: activeSpecialBossEnemyId,
  runSeed: runSeedRef.current,
  baseTileWidth: TILE_WIDTH,
  baseTileHeight: TILE_HEIGHT,
  brazierGuideMinOpacity: BRAZIER_RADIUS_GUIDE_MIN_OPACITY,
  brazierGuideMaxOpacity: BRAZIER_RADIUS_GUIDE_MAX_OPACITY,
  spiderwebShakeDurationMs: SPIDERWEB_SHAKE_DURATION_MS,
}), [
  isMobile,
  lowFx,
  aggressiveLowFx,
  isStorylineActive,
  isPreCombatTransitionActive,
  floorLevel,
  floorSeed,
  floorCorruption,
  torchProgress,
  lightRadius,
  showBrazierRadiusGuide,
  brazierRadiusGuideByTile,
  tileVariations,
  currentFloorTilesetProfile,
  boardPerspectiveStageStyle,
  boardPerspectiveViewportStyle,
  boardPerspectiveBoardStyle,
  boardCameraTransition,
  boardMotionScale,
  offsetX,
  offsetY,
  renderTileWidth,
  renderTileHeight,
  renderTileHalfMargin,
  renderTileRadius,
  boardSpanX,
  boardSpanY,
  flash,
  secretWhisperTorchFlicker,
  sanityFx,
  madnessOverlayOpacity,
  sanityScreenFlicker,
  sanityDistortionSpike,
  sanityPeripheralShadow,
  sanityCollapseBurst,
  sanityHudGlitchBurst,
  ghostEnemyFlicker,
  activeSpecialBossEnemyId,
  runSeedRef.current,
]);

return (
    <div
      className="w-screen overflow-hidden relative bg-black"
      style={{
        touchAction: 'none',
        height: '100dvh',
        minHeight: '100dvh',
        isolation: 'isolate',
        zIndex: 0,
      }}
    onTouchStart={handleTouchStart}
    onTouchMove={handleTouchMove}
    onTouchEnd={handleTouchEnd}
    onClick={handleBoardClick}
    >

      <TorchHintOverlay
        active={!!blackhandTorchWarningText}
        fadeMs={220}
        contentKey={blackhandTorchWarningText || 'blackhand-floor-torch-warning'}
        contentFadeMs={160}
      >
        {blackhandTorchWarningText}
      </TorchHintOverlay>

      <TorchHintOverlay
        active={
          !isBlackhandBossFloorActive && !blackhandTorchWarningText && (
            spawnTutorialStage === 'lightTorch'
              ? showSpawnTorchHint && isDark
              : (spawnTutorialStage === 'moveInteract' || spawnTutorialStage === 'findExit') && !isSpawnTutorialFinalFading
          )
        }
        fadeMs={spawnTutorialStage === 'findExit' || isSpawnTutorialFinalFading ? 900 : 220}
        contentKey={spawnTutorialStage}
        contentFadeMs={180}
      >
        {spawnTutorialStage === 'moveInteract' ? (
          <>
            Move with <b>WASD</b>.
            <p>
              <b>Click</b> to interact.
            </p>
          </>
        ) : spawnTutorialStage === 'findExit' ? (
          <>
            Find the <b>exit</b>. Stay <b>sane</b>.
            <p>
              Keep the flame <b>alive</b>.
            </p>
          </>
        ) : (
          <>
            Darkness will <b>consume</b> you.
            <br />
            Light up a torch.
          </>
        )}
      </TorchHintOverlay>
{/* Tarot card overlay */}
{isTarotVisible && (
  <TarotOverlay
    open
    currentTarot={displayedTarot}
    tarotOpenedAtRef={tarotOpenedAtRef}
    onClose={() => setIsTarotVisible(false)}
  />
)}
<AnimatePresence>
        {pulse && (
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 0.4, scale: 2 }}
            exit={{ opacity: 0, scale: 1 }}
            transition={{ duration: 0.8, ease: 'easeOut' }}
            className="absolute top-1/2 left-1/2 w-48 h-48 rounded-full pointer-events-none z-50"
            style={{
              transform: 'translate(-50%, -50%)',
              background: 'radial-gradient(circle, rgba(0,255,255,0.4) 0%, rgba(0,255,255,0) 70%)',
              filter: 'blur(20px)'
            }}
          />
        )}
      </AnimatePresence>

      {!bootReady && (
  <div
    className="fixed inset-0 bg-black flex items-center justify-center z-[5000]"
    style={{ pointerEvents: 'all' }}
  >
    <div className="text-center text-white">
      <img
  src={logo}
  alt="Deck & Delve"
  draggable={false}
  className="mx-auto mb-4"
  style={{
    width: 220,          // tweak size here
    height: 'auto',
    imageRendering: 'auto',
  }}
/>


      <div className="font-karma text-white/80 mb-4">
        Entering the Archmage's Tower...
      </div>

      <div className="font-karma text-white/90 text-xl">{bootPct}%</div>
      <div className="mt-2 font-karma text-white/50 text-sm">
        {bootProgress.loaded}/{bootProgress.total}
      </div>
    </div>
  </div>
)}

      {torchProgress > 0 && !lowFx && (
  <EmbersOverlay
    enabled
    intensity={0.6 + 0.4 * torchProgress}
  />
)}


      <AnimatePresence>
        {isPreCombatTransitionActive && (
          <motion.div
            key="pre-combat-fade"
            className="absolute inset-0 bg-black"
            style={{ zIndex: 110 }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 1 }}
            transition={{
              duration: (PRE_COMBAT_TRANSITION_MS - PRE_COMBAT_FADE_DELAY_MS) / 1000,
              delay: PRE_COMBAT_FADE_DELAY_MS / 1000,
              ease: 'easeInOut',
            }}
          />
        )}
      </AnimatePresence>

      {isCombatActive && (
        <CombatOverlay
          deckIds={playerDeckIds}
          initialHp={hp}
          initialSp={sanity}
          maxHp={maxHp}
          maxSp={maxSp}
          combatMods={combatModsForOverlay}
          enemyId={combatEnemyTile?.enemyId}
          enemyPortraitVariant={(
            isMonsignorBossFloorActive &&
            combatEnemyTile?.enemyId === 'chained-penitent' &&
            MONSIGNOR_GUARD_COORDS.some(
              ({ x, y }) => x === combatEnemyTile?.x && y === combatEnemyTile?.y,
            )
          ) ? 'monsignor-guard' : undefined}
          rewardSeed={
            (((runSeedRef.current ?? 0) ^ (floorLevel * 2654435761)) ^
              ((combatEnemyTile?.x ?? 0) << 16) ^ (combatEnemyTile?.y ?? 0)) >>> 0
          }
          onVictory={handleCombatVictoryWithStoryResume}
          onDefeat={handleCombatDefeatWithStoryResume}
          ownedRelics={ownedRelics}
          // Pass along tarot modifiers that adjust reward choice counts
          extraRewardChoices={tarotExtraRewardChoice}
          onlyRewardChoice={tarotReducedRewardChoice}
          torchProgress={torchProgress}
          lightRadius={lightRadius}
          lowFx={lowFx}
          aggressiveLowFx={aggressiveLowFx}
        />
      )}

<LevelUpModal
  open={isLevelUpOpen}
  levelUpStep={levelUpStep}
  playerLevel={playerLevel}
  levelUpPulse={levelUpPulse}
  onChooseHp={() => applyLevelUpChoice('hp')}
  onChooseSp={() => applyLevelUpChoice('sp')}
  onContinue={continueAfterDrawBonus}
/>

<DeckCullRewardModal
  open={pendingDeckCullReward && !isCombatActive && !isLevelUpOpen}
  deckCards={deckCards}
  deckCullCards={deckCullCards}
  getDeckCullBlockReason={getDeckCullBlockReason}
  onClaim={claimFloorCleansingReward}
  onSkip={() => setPendingDeckCullReward(false)}
/>

      {/* Merchant */}
      <MerchantModal
        open={isMerchantOpen}
onClose={() => {
  setIsMerchantOpen(false);
  setActiveMerchantKey(null);
}}
        teeth={teeth}
        torches={torches}
        maxTorches={maxTorches}
        keys={keys}
        maxKeys={maxKeys}
        potions={potions}
        maxPotions={maxPotions}
cardsForSale={activeMerchantStock?.cards || []}
trinketsForSale={activeMerchantStock?.trinkets || []}
cardPrice={activeMerchantStock?.cardPrice ?? getMerchantPrices().cardPrice}
trinketPrice={activeMerchantStock?.trinketPrice ?? getMerchantPrices().trinketPrice}
        noMerchant={tarotNoMerchant}
        onBuyCard={handleBuyMerchantCard}
        onBuyTrinket={handleBuyMerchantTrinket}
        onBuyTorch={handleBuyMerchantTorch}
        onBuyKey={handleBuyMerchantKey}
        onBuyPotion={handleBuyMerchantPotion}


      />

{!!trapQTE && (
  <TrapQTEOverlay
    open
    durationMs={trapQTE?.durationMs || 1200}
    label="DISARM"
    onSuccess={() => resolveTrap(true)}
    onFail={() => resolveTrap(false)}
    onAutoDisarm={() => resolveTrap(true)}
    onActivateVisual={playTrapActivateSfx}
  />
)}

<ExplorationScene
  boardRefs={boardRefs}
  boardState={boardState}
  renderState={renderState}
  tileActions={tileActions}
  tileHelpers={tileHelpers}
  tileAssets={tileAssets}
  sanityFx={sanityFx}
  sanityCollapseBurst={sanityCollapseBurst}
  lowFx={lowFx}
  aggressiveLowFx={aggressiveLowFx}
/>

      <GameHudOverlay
  hidden={hideUI}
  isMobile={isMobile}
  lowFx={lowFx}
  graphicsFxMode={graphicsFxMode}
  floorState={hudFloorState}
  vitalsState={hudVitalsState}
  inventoryState={hudInventoryState}
  relicState={hudRelicState}
  actions={hudActions}
/>

      {!hideUI && canRest && (
        <div className="absolute top-1/2 left-1/2 z-40 transform -translate-x-1/2 -translate-y-1/2">
          <TileActionButton label="Rest" onClick={triggerRest} />

        </div>
      )}

      {!hideUI && ((map[playerPos.y][playerPos.x] === 'chest-locked' ||
 map[playerPos.y][playerPos.x] === 'chest-closed' ||
 map[playerPos.y][playerPos.x] === 'chest-simple-locked' ||
 map[playerPos.y][playerPos.x] === 'chest-simple-closed' ||
 map[playerPos.y][playerPos.x] === 'chest-rare-locked' ||
 map[playerPos.y][playerPos.x] === 'chest-rare-closed')

 ? (
        <div className="absolute top-1/2 left-1/2 z-40 transform -translate-x-1/2 -translate-y-1/2">
  <TileActionButton
    label={
  (map[playerPos.y][playerPos.x] === 'chest-locked' ||
   map[playerPos.y][playerPos.x] === 'chest-simple-locked' ||
   map[playerPos.y][playerPos.x] === 'chest-rare-locked')
    ? 'Unlock'
    : 'Open'
}

    onClick={unlockChest}
  />
</div>

      ) : map[playerPos.y][playerPos.x] === 'merchant' && !isMerchantOpen ? (
  <div className="absolute top-1/2 left-1/2 z-40 transform -translate-x-1/2 -translate-y-1/2">
<TileActionButton
  label="Shop"
  onClick={() => {
    setActiveMerchantKey(`${playerPos.x},${playerPos.y}`);
    setIsMerchantOpen(true);
  }}
/>

  </div>
) : map[playerPos.y][playerPos.x] === 'well' && !isWellOpen ? (
  <div className="absolute top-1/2 left-1/2 z-40 transform -translate-x-1/2 -translate-y-1/2">
    <TileActionButton label="Forsake" onClick={() => openWellAt(playerPos.x, playerPos.y)} />
  </div>
) : map[playerPos.y][playerPos.x].startsWith('shrine-') && !isShrineOpen ? (
  <div className="absolute top-1/2 left-1/2 z-40 transform -translate-x-1/2 -translate-y-1/2">
    <TileActionButton label="Offer" onClick={() => openShrineAt(playerPos.x, playerPos.y)} />
  </div>

) : map[playerPos.y][playerPos.x] === 'witch' ? (
  <div className="absolute top-1/2 left-1/2 z-40 transform -translate-x-1/2 -translate-y-1/2">
    <TileActionButton label="Consult" onClick={handleConsultWitch} />
  </div>
) : map[playerPos.y][playerPos.x] === 'brazier'
    && BRAZIER_LIGHTING_ENABLED
    && !isBrazierLit(playerPos.x, playerPos.y) ? (
  <div className="absolute top-1/2 left-1/2 z-40 transform -translate-x-1/2 -translate-y-1/2">
    <TileActionButton label="Ignite" onClick={handleTap} />
  </div>
) : map[playerPos.y][playerPos.x] === MONSIGNOR_LIBERATED_GUARD_TILE ? (
  <div className="absolute top-1/2 left-1/2 z-40 transform -translate-x-1/2 -translate-y-1/2">
    <TileActionButton label="Observe" onClick={handleTap} />
  </div>
) : map[playerPos.y][playerPos.x] === 'steps-down' ? (

        <div className="absolute top-1/2 left-1/2 z-40 transform -translate-x-1/2 -translate-y-1/2">
          <TileActionButton label="Descend" onClick={descendStairs} />

                  </div>
      ) : map[playerPos.y][playerPos.x] === 'storyline' && !isStorylineActive && (
        <div className="absolute top-1/2 left-1/2 z-40 transform -translate-x-1/2 -translate-y-1/2">
          <TileActionButton label="Delve" onClick={startStoryline} />


        </div>
      ))}

      {!hideUI && map[playerPos.y][playerPos.x].startsWith('bookshelf-') && (
        <div className="absolute top-1/2 left-1/2 z-40 transform -translate-x-1/2 -translate-y-1/2">
          <TileActionButton label="Inspect" onClick={handleLoreClick} />

        </div>
      )}

      {!hideUI && canInspectSanctifiedSecretStatue && (
        <div className="absolute top-1/2 left-1/2 z-40 transform -translate-x-1/2 -translate-y-1/2">
          <TileActionButton label="Inspect" onClick={inspectSanctifiedSecretStatue} />

        </div>
      )}

{!hideUI && map[playerPos.y][playerPos.x] === RANSACKED_CHEST_TILE && (
  <div className="absolute top-1/2 left-1/2 z-40 transform -translate-x-1/2 -translate-y-1/2">
    <TileActionButton label="Inspect" onClick={openRansackedChest} />
  </div>
)}

      {/* Lore */}
      <LoreModal open={!!activeLore} text={activeLore || ''} onClose={closeLore} />
      <LoreModal
        open={!!barredDoorLore}
        text={barredDoorLore || ''}
        onClose={closeBarredDoorLore}
        showIllustration={false}
      />

<RansackedChestModal
  open={isRansackedChestOpen}
  onInspect={inspectRansackedChestReward}
  onClose={closeRansackedChest}
/>

<WellEchoModal
  open={isWellEchoOpen}
  onListen={confirmWellEchoListen}
/>

<SimpleChestResourceModal
  open={!!simpleChestResourceReward}
  rewards={simpleChestResourceReward?.rewards || []}
  onLootAll={lootSimpleChestResources}
/>

      {/* Shrine */}
      <ShrineModal
  open={isShrineOpen}
  tier={activeShrineTier}
  costText={activeShrineCostText}
  rewardText={activeShrineRewardText}
  canAfford={activeShrineCanAfford}
  deckCards={deckCards}
  onConfirm={confirmShrineOffer}
  onClose={closeShrine}
  error={shrineError}
  resultText={shrineResult}
/>

      {/* Well */}
      <WellModal
        open={isWellOpen}
        trinkets={ownedRelics}
        onConfirm={confirmWellDiscard}
        onClose={closeWell}
        error={wellError}
        resultText={wellResult}
      />

      {/* Relic picker */}
      <RelicPickerModal
  open={relics.length > 0 && !isCombatActive && !isLevelUpOpen && !pendingDeckCullReward}
  relics={relics}
  onClose={handleDungeonRelicPickerClose}
  onPick={handleDungeonRelicPick}
  lockClose={true}
  secondaryActionLabel={
    simpleChestRelicPickerMode === 'simple-chest' ? 'Leave untouched' : null
  }
  onSecondaryAction={
    simpleChestRelicPickerMode === 'simple-chest' ? handleDungeonRelicPickerClose : undefined
  }
/>

      {/* Storyline card overlay (same sizing as result card). Keeps board swipes from interfering. */}
      {/* Storyline overlay (new storylet system) */}

{isStorylineActive && cardState === 'story' && activeStorylet && (
  <StoryletOverlay
    open
    cardState={cardState}
    activeStorylet={activeStorylet}
    isMobile={isMobile}
    swipeDirection={swipeDirection}
    storyDragX={storyDragX}
    setStoryDragX={setStoryDragX}
    isStoryStepFlipping={isStoryStepFlipping}
    storyNextBg={storyNextBg}
    getActiveStep={getActiveStep}
    handleStorySwipe={handleStorySwipe}
    advanceStoryTap={advanceStoryTap}
    tileWidth={TILE_WIDTH}
    tileHeight={TILE_HEIGHT}
    fallbackImage={storyline1Img}
  />
)}

{isMiniMapOpen && (
  <MiniMapOverlay
    open
    onClose={() => setIsMiniMapOpen(false)}
    map={map}
    exploredTiles={exploredTiles}
    visibleTiles={visibleTiles}
    playerPos={playerPos}
    floorLevel={floorLevel}
    currentFloorMood={currentFloorMood}
    litBraziers={litBraziers}
  />
)}

{isStatusOpen && (
  <StatusPanelOverlay
    open
    onClose={() => setIsStatusOpen(false)}
    onOpenLegendarium={() => {
      flushCurrentRunSnapshot();
      reopenStatusOnLegendariumCloseRef.current = true;
      setIsStatusOpen(false);
      onOpenLegendarium?.();
    }}
    onExitToMainMenu={() => {
      flushCurrentRunSnapshot();
      reopenStatusOnLegendariumCloseRef.current = false;
      setIsStatusOpen(false);
      onExitToMainMenu?.();
    }}
    deckCards={deckCards}
    ownedRelics={ownedRelics}
    trinketLimit={trinketLimit}
    playerLevel={playerLevel}
    playerXp={playerXp}
    xpToNextLevel={xpToNextLevel}
    hp={hp}
    maxHp={maxHp}
    sp={sanity}
    maxSp={maxSp}
    brazierLitCount={brazierProgress.lit}
    brazierTotalCount={brazierProgress.total}
    enemySlainCount={floorCleansingProgress.slain}
    enemyTotalCount={floorCleansingProgress.total}
    startingArmorValue={statusPanelStartingBonuses.armor}
    startingReflectValue={statusPanelStartingBonuses.reflect}
    startingDamageValue={statusPanelStartingBonuses.damage}
  />
)}

    </div>
  );
};


const INTRO_LOGO_AUDIO_SRC = `${process.env.PUBLIC_URL || ''}/audio/intro_logo.mp3`;

const MenuIntroSplash = ({ onComplete }) => {
  const [canFadeOut, setCanFadeOut] = useState(false);
  const doneRef = useRef(false);
  const videoRef = useRef(null);
  const audioRef = useRef(null);

  const finish = () => {
    if (doneRef.current) return;
    doneRef.current = true;

    try {
      const audioEl = audioRef.current;
      if (audioEl) {
        audioEl.pause();
        audioEl.currentTime = 0;
      }
    } catch {}

    setCanFadeOut(true);
    window.setTimeout(() => {
      onComplete?.();
    }, 220);
  };

  useEffect(() => {
    const videoEl = videoRef.current;
    const audioEl = audioRef.current;
    let syncIntervalId = null;

    const tryStartAudio = () => {
      if (!audioEl || doneRef.current) return;
      try {
        if (videoEl && Number.isFinite(videoEl.currentTime)) {
          const drift = Math.abs((audioEl.currentTime || 0) - videoEl.currentTime);
          if (drift > 0.18) {
            audioEl.currentTime = videoEl.currentTime;
          }
        }
      } catch {}
      const playPromise = audioEl.play?.();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    };

    const handleVideoPlay = () => {
      tryStartAudio();
      if (syncIntervalId != null) return;
      syncIntervalId = window.setInterval(() => {
        if (!videoEl || !audioEl) return;
        if (videoEl.paused || audioEl.paused) return;
        const drift = Math.abs((audioEl.currentTime || 0) - (videoEl.currentTime || 0));
        if (drift > 0.22) {
          try {
            audioEl.currentTime = videoEl.currentTime || 0;
          } catch {}
        }
      }, 250);
    };

    const handleVideoPause = () => {
      try {
        audioEl?.pause?.();
      } catch {}
    };

    const handleUserUnlock = () => {
      tryStartAudio();
    };

    const fallbackId = window.setTimeout(() => {
      finish();
    }, 12000);

    videoEl?.addEventListener('play', handleVideoPlay);
    videoEl?.addEventListener('pause', handleVideoPause);
    window.addEventListener('pointerdown', handleUserUnlock, { passive: true });
    window.addEventListener('keydown', handleUserUnlock);
    window.addEventListener('touchstart', handleUserUnlock, { passive: true });

    handleVideoPlay();

    return () => {
      window.clearTimeout(fallbackId);
      if (syncIntervalId != null) window.clearInterval(syncIntervalId);
      videoEl?.removeEventListener('play', handleVideoPlay);
      videoEl?.removeEventListener('pause', handleVideoPause);
      window.removeEventListener('pointerdown', handleUserUnlock);
      window.removeEventListener('keydown', handleUserUnlock);
      window.removeEventListener('touchstart', handleUserUnlock);
      try {
        audioEl?.pause?.();
      } catch {}
    };
  }, []);

  return (
    <motion.div
      initial={{ opacity: 1 }}
      animate={{ opacity: canFadeOut ? 0 : 1 }}
      transition={{ duration: 0.22, ease: 'easeOut' }}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 999999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#000',
        overflow: 'hidden',
      }}
    >
      <audio
        ref={audioRef}
        preload="auto"
        src={INTRO_LOGO_AUDIO_SRC}
        onEnded={() => {}}
        style={{ display: 'none' }}
      />
      <video
        ref={videoRef}
        autoPlay
        muted
        playsInline
        preload="auto"
        controls={false}
        disablePictureInPicture
        onEnded={finish}
        onError={finish}
        style={{
          display: 'block',
          width: 'min(72vw, 720px)',
          maxWidth: '100%',
          maxHeight: '100vh',
          objectFit: 'contain',
          pointerEvents: 'none',
          userSelect: 'none',
          WebkitUserSelect: 'none',
          background: 'transparent',
        }}
      >
        <source src={logoIntroVideoSrc} type="video/mp4" />
      </video>
    </motion.div>
  );
};

function sanitizeSpecialBossSelectionForFloor(selection, floorLevel) {
  if (!selection || typeof selection !== 'object') return null;

  const normalizedFloor = Math.max(1, Math.floor(Number(floorLevel) || 1));
  if (!isSpecialBossFloor(normalizedFloor)) return null;

  const selectionFloor = Math.floor(Number(selection.floor));
  if (Number.isFinite(selectionFloor) && selectionFloor !== normalizedFloor) {
    return null;
  }

  return getSpecialBossFloorEncounter(
    {
      ...selection,
      floor: normalizedFloor,
    },
    { floor: normalizedFloor }
  );
}

const App = () => {
  const forceMenu = typeof window !== 'undefined' && window.location.hash.includes('menu');
  const [menuIntroSeen, setMenuIntroSeen] = useState(false);
  const [mainMenuSeen, setMainMenuSeen] = useState(() => readMainMenuSeen());
  const [selectedCharacter, setSelectedCharacter] = useState(() => readSelectedCharacter());
  const [legendariumContext, setLegendariumContext] = useState(null);
  const skipUnloadPersistenceRef = useRef(false);

const continueAvailable = hasSavedContinueRun();

const clearForcedMenuHash = () => {
  if (!forceMenu) return;
  try {
    window.location.hash = '';
  } catch {}
};

const writeTestRunSpecialBossOverride = (value) => {
  try {
    const next = String(value ?? '').trim();
    if (next) {
      localStorage.setItem(TEST_RUN_SPECIAL_BOSS_OVERRIDE_STORAGE_KEY, next);
    } else {
      localStorage.removeItem(TEST_RUN_SPECIAL_BOSS_OVERRIDE_STORAGE_KEY);
    }
  } catch {}
};

const sanitizeTestRunLaunchConfig = (value) => {
  const raw = value && typeof value === 'object' ? value : {};
  const toWhole = (input, fallback, min = 0, max = Number.MAX_SAFE_INTEGER) => {
    const parsed = Math.floor(Number(input));
    if (!Number.isFinite(parsed)) return fallback;
    return Math.max(min, Math.min(max, parsed));
  };

  return {
    floorLevel: toWhole(raw.floorLevel, 1, 1, 999),
    hp: toWhole(raw.hp, 100, 1, 999),
    sp: toWhole(raw.sp, 100, 1, 999),
    deckIds: Array.isArray(raw.deckIds)
      ? raw.deckIds.map((entry) => String(entry ?? '').trim()).filter(Boolean)
      : [],
    relicIds: Array.isArray(raw.relicIds)
      ? Array.from(new Set(raw.relicIds.map((entry) => String(entry ?? '').trim()).filter(Boolean)))
      : [],
    floor4BossId: String(raw.floor4BossId ?? '').trim(),
  };
};

const handleNewRun = () => {
  clearForcedMenuHash();

  const nextRunSeed = makeFreshRunSeed();

  clearSavedRunState({
    clearCharacter: true,
    clearMenuSeen: false,
  });

  writeTestRunSpecialBossOverride('');

 writeSavedRunSeed(nextRunSeed);
writeSavedFloorLevel(1);

  setSelectedCharacter(null);
  setMainMenuSeen(true);
  setLegendariumContext(null);
};

const handleStartTestRun = (config) => {
  clearForcedMenuHash();

  const nextRunSeed = makeFreshRunSeed();
  const safeConfig = sanitizeTestRunLaunchConfig(config);
  const extraMaxHp = Math.max(0, safeConfig.hp - 100);
  const extraMaxSp = Math.max(0, safeConfig.sp - 100);

  clearSavedRunState({
    clearCharacter: true,
    clearMenuSeen: false,
  });

  writeTestRunSpecialBossOverride(safeConfig.floor4BossId);

  try {
    localStorage.setItem('dd_player_deck_ids_v1', JSON.stringify(safeConfig.deckIds));
    localStorage.setItem('dd_owned_relics_v1', JSON.stringify(safeConfig.relicIds));
    localStorage.setItem('dd_player_hp_v1', JSON.stringify(safeConfig.hp));
    localStorage.setItem('dd_player_sp_v1', JSON.stringify(safeConfig.sp));
    localStorage.setItem('dd_level_maxhp_bonus_v1', JSON.stringify(extraMaxHp));
    localStorage.setItem('dd_level_maxsp_bonus_v1', JSON.stringify(extraMaxSp));
  } catch {}

  writeSavedRunSeed(nextRunSeed, { immediate: true });
  writeSavedFloorLevel(safeConfig.floorLevel, { immediate: true });

  setSelectedCharacter(null);
  setMainMenuSeen(true);
  setLegendariumContext(null);
};

const handleContinue = () => {
  clearForcedMenuHash();
  writeTestRunSpecialBossOverride('');

  if (!hasSavedContinueRun()) return;

  setSelectedCharacter(readSelectedCharacter());
  setMainMenuSeen(true);
  setLegendariumContext(null);
};

const handlePlayerDeath = () => {
  clearSavedRunState({
    clearCharacter: false,
    clearMenuSeen: false,
  });

  writeTestRunSpecialBossOverride('');

  setLegendariumContext(null);
  setMainMenuSeen(false);
};


  useEffect(() => {
  writeMainMenuSeen(mainMenuSeen);
}, [mainMenuSeen]);

  // Main menu (force it with URL hash: #menu)
  if (forceMenu || !mainMenuSeen) {
    if (!menuIntroSeen) {
      return <MenuIntroSplash onComplete={() => setMenuIntroSeen(true)} />;
    }

    if (legendariumContext === 'menu') {
      return <LegendariumScreen onClose={() => setLegendariumContext(null)} />;
    }

    return (
      <MainMenuScreen
        onNewRun={handleNewRun}
        onContinue={handleContinue}
        onOpenLegendarium={() => setLegendariumContext('menu')}
        onStartTestRun={handleStartTestRun}
        canContinue={continueAvailable}
      />
    );
  }

  // No character chosen yet → show the carousel select screen
  if (!selectedCharacter) {
    return (
      <CharacterSelectScreen
        initialId="fate"
        onConfirm={(id) => {
  writeSelectedCharacter(id);
  setSelectedCharacter(id);
}}
      />
    );
  }

  // Character chosen → run the normal dungeon demo

  return (
    <>
      <GameBoard
        onPlayerDeath={handlePlayerDeath}
        onOpenLegendarium={() => setLegendariumContext('status')}
        onExitToMainMenu={() => {
          setLegendariumContext(null);
          setMainMenuSeen(false);
        }}
        isLegendariumOpen={legendariumContext === 'status'}
        skipUnloadPersistenceRef={skipUnloadPersistenceRef}
      />

      {legendariumContext === 'status' && (
        <LegendariumScreen onClose={() => setLegendariumContext(null)} />
      )}
    </>
  );
};

export default App;
